import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import { configuration } from "../appConfig";
import moment from "moment";
import Lightbox from "react-image-lightbox";
import dashboardErrorImg from "../../src/assets/img/brand/dashboard-error-logo.png"
import { Spinner } from "reactstrap";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export class PreDamage93SVG extends Component {
  constructor(props) {
    super(props);
    this.PreDamage = React.createRef(null);
    this.state = {
      vin: "",
      lang: "",
      words: {},
      loading: false,
      imageSrc: "",
      captureImageName: "",
      extraImageNameArr: [],
      extraImageNameArr_1: [],
      isLightBoxOpen : false,
      clickedPartName : "",
    };
  }

  componentDidMount = () => {
    this.getLang();
  };
  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

  getBase644 = async (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  };

  capture = async (e) => {
    // if (e.target.files.length > 0) {
    //   this.setState(
    //     {
    //       imageSrc: e.target.files[0],
    //     },
    //     () => {
    //       this.props.uploadExtraImagesNew(this.state.imageSrc, this.state.captureImageName, this);
    //     }
    //   );
    // }
    const { files } = e.target;
    const base64 = await this.getBase644(files[0]);
    this.setState(
      {
        imageSrc: base64,
      },
      () => {
        this.props.uploadExtraImagesNew(
          this.state.imageSrc,
          this.state.captureImageName,
          this
        );
      }
    );
  };

  userClick = (part) => {
    this.setState({
      captureImageName: part,
      imageSrc: "",
    });
    if (!this.fillColor(part)) {
      if (this.props.authorized) {
        Toast.fire({
          type: "error",
          title: this.lang("ThisVINisAuthorized"),
        });
        return
      }
      this.PreDamage.click();
    } else{
      this.openImage(part)
    }
  };
  openImage =(clickedName)=>{
    const {extraNewImages} = this.props
    console.log(clickedName);
    const findName = extraNewImages && extraNewImages.length > 0 && extraNewImages.find((partName)=>{
      return partName.part == clickedName
    })
    this.setState({clickedPartName : findName.name,isLightBoxOpen : !this.state.isLightBoxOpen, clickedPartObj : findName})
  }

  fillColor = (part) => {
    const { extraImageNameArr_1 } = this.props;
    let partimages = extraImageNameArr_1.filter(
      (item) => item.includes(part) && item.split(".")[0].length === part.length
    );
    if (partimages[0]) {
      this.addClassName();
      return "#EF3D3C";
    }
  };
  addClassName = (part) => {
    const { extraImageNameArr_1 } = this.props;
    let partimages = extraImageNameArr_1.filter(
      (item) => item.includes(part) && item.split(".")[0].length === part.length
    );
    if (partimages[0]) {
      return "svg-parts-fill";
    } else {
      return null;
    }
  };

  handleRetake = ()=>{
    this.PreDamage.click();
  }
  handlerotate = ()=>{
    const {clickedPartObj} = this.state;
    const splitName = clickedPartObj.name.split("/")[clickedPartObj.name.split("/").length -1]
    this.props.handlerotate(splitName)
  }
  handleDelete =async()=>{
    const {clickedPartObj} = this.state;
    await this.props.handleDelete(clickedPartObj)
    await this.setState({isLightBoxOpen: false})
  }

  render() {
    const {isLightBoxOpen,clickedPartName} = this.state
    const {isRotateLoading, isDeleteLoading} = this.props
    let toolbarButtons = [];
    toolbarButtons = [
      <>
        <div className="photo_app_image_lightbox_wrapper">
          <button
            onClick={() => this.setState({ isLightBoxOpen: !isLightBoxOpen })}
          >
            <i className="fa fa-check"></i>

          </button>
          <button
          disabled={this.props.authorized}
          onClick={() => this.handleRetake()}>
            <i className="fa fa-camera"></i>
          </button>
          {/* <button onClick={() => this.toggleEdit()}>
            {isEditLoading ? <Spinner /> : <i className="fa fa-pencil"></i>}
          </button> */}
          <button 
          disabled={this.props.authorized}
          onClick={() => this.handlerotate()}>
            {isRotateLoading ? <Spinner style={{ height: '1rem', width: '1rem' }} /> : <i className="fa fa-repeat"></i>}
            {/* <i className="fa fa-repeat"></i> */}
          </button>
          <button 
          disabled={this.props.authorized}
          onClick={() => this.handleDelete()}>
            {isDeleteLoading ? <Spinner style={{ height: '1rem', width: '1rem' }} /> : <i className="fa fa-trash"></i>}
          </button>
        </div>
      </>,
    ];
    return (
      <>
        <input
          type="file"
          name="image"
          id="file"
          // ref="PreDamage"
          ref={(input) => (this.PreDamage = input)}
          accept="image/*"
          capture="environment"
          style={{ display: "none" }}
          onChange={(e) => this.capture(e)}
        />

        <svg
          version="1.1"
          id="Layer_1"
          xmlnsx="&ns_extend;"
          xmlnsi="&ns_ai;"
          // xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 1080 1207.4"
          style={{ enableBackground: "new 0 0 1080 1207.4" }}
          xmlSpace="preserve"
        >
          <style type="text/css">
            {`.st0{fill:#FFFFFF;stroke:#010101;stroke-width:0.5;stroke-miterlimit:10;}
              .st1{fill:none;stroke:#010101;stroke-width:0.5;stroke-miterlimit:10;}
              .st2{fill:none;}
              .st3{fill:#010101;}
              .st4{fill:#FFFFFF;stroke:#D71F26;stroke-width:0.5;stroke-miterlimit:10;}
              .st5{fill:#D71F26;}
              .st6{fill:#FFFFFF;}
              .st7{fill:#F6F7F7;stroke:#010101;stroke-width:0.5;stroke-miterlimit:10;}
              .st8{fill:#231F20;}`}
          </style>
          <g>
            <path
              class="st0"
              d="M900.4,279c0,35,28.5,63.4,63.5,63.4c3.5,0,7.1-0.3,10.5-0.9c30-4.9,52.9-31,52.9-62.5
		c0-31.4-22.8-57.5-52.9-62.5c-3.4-0.5-7-0.9-10.5-0.9C928.8,215.6,900.5,244,900.4,279z M923.9,278c0-21.4,17.4-38.7,38.8-38.7
		c4,0,7.9,0.5,11.6,1.7c15.7,4.9,27.2,19.7,27.2,37c0,17.3-11.5,32.1-27.2,37c-3.6,1.1-7.5,1.7-11.6,1.7
		C941.4,316.7,924,299.3,923.9,278z"
            />
            <line class="st0" x1="974.3" y1="352.1" x2="974.3" y2="341.6" />
            <line class="st0" x1="974.3" y1="216.5" x2="974.3" y2="205.2" />
            <path
              class="st0"
              d="M924,277.9c0,21.4,17.3,38.7,38.8,38.7c4.1,0,7.9-0.6,11.6-1.7c15.7-4.9,27.2-19.7,27.2-37s-11.5-32.1-27.2-37
		c-3.6-1.2-7.6-1.7-11.6-1.7C941.4,239.2,924,256.5,924,277.9z"
            />
          </g>
          <path
            class="st0"
            d="M974.3,761.9c-3.4-0.5-7-0.9-10.5-0.9c-35,0-63.4,28.5-63.5,63.4c0,35,28.5,63.4,63.5,63.4
	c3.5,0,7.1-0.3,10.5-0.9c30-4.9,52.9-31,52.9-62.5C1027.2,793,1004.4,766.9,974.3,761.9z M974.3,860.4c-3.6,1.1-7.5,1.7-11.6,1.7
	c-21.4,0-38.7-17.3-38.8-38.7c0-21.4,17.4-38.7,38.8-38.7c4,0,7.9,0.5,11.6,1.7c15.7,4.9,27.2,19.7,27.2,37S990.1,855.5,974.3,860.4
	z"
          />
          <path
            class="st0"
            d="M1001.5,823.4c0,17.3-11.5,32.1-27.2,37c-3.6,1.1-7.5,1.7-11.6,1.7c-21.4,0-38.7-17.3-38.8-38.7
	c0-21.4,17.4-38.7,38.8-38.7c4,0,7.9,0.5,11.6,1.7C990.1,791.3,1001.5,806.1,1001.5,823.4z"
          />
          <line class="st1" x1="974.3" y1="887" x2="974.3" y2="898.7" />
          <line class="st1" x1="974.3" y1="761.9" x2="974.3" y2="749.6" />
          <path
            class="st0"
            d="M974,952.6c-1.2,29.1-2.5,59.2-2.5,59.2h-11.8c-7.2,5.8-15,11.5-15,11.5l-36.1-1.4l-10.4-13.4
	c0,0-53.1,4.5-65.3,0s-8.1-31.9-8.1-31.9c-1.7-3.9-3.5-7.8-5.2-11.7c-4.4-9.8-8.7-19.7-13.1-29.5c-5.7-12.9-11.5-25.8-17.2-38.7
	c-5.8-13.1-11.6-26.3-17.4-39.4c-5.3-12.1-10.8-24.2-16-36.4c-5.2-12.1-9.1-24.7-13-37.3c-1.4-4.4-2.5-8.5-2.8-13.2
	c-0.3-4.6-0.2-9.2-0.3-13.9c-0.3-10.7-0.4-21.4-0.5-32.1c-0.1-13.3-0.2-26.6-0.2-40c0-14.2,0.1-28.4,0.3-42.6
	c0.2-13.3,0.4-26.7,0.8-40c0.3-10.7,0.7-21.5,1.5-32.2c0.3-4.1,0.6-8.3,1.1-12.4c5.4-43.8,18.4-84.2,18.4-84.2l75-149
	c0-0.6,0.1-1.2,0.1-1.8c0.9-15.5,2.1-31,3.7-46.5c1.3-12.5,2.8-25,4.7-37.5c1.5-9.9,3.2-19.7,5.2-29.5c1.5-7.5,3.3-15,5.3-22.4
	c1.5-5.5,3.1-11,4.9-16.3c1.8-5.3,3.9-10.5,5.8-15.8c1.8-5.1,3.7-10.3,6.8-14.8c6-8.6,15.8-13.5,24.8-18.4c2.3-1.2,4.6-2.5,6.8-3.8
	c0,0,3.1-1.6,4.3-2.2c0.2-0.2,0.5-0.5,0.5-0.5l5.9-5.7c0.1-0.1,0.3-0.2,0.5-0.2h30.2c0.3,0,0.6,0.2,0.7,0.5c1.3,3.4,9.7,14,26,7.1
	c6.1-2.6,13.3,41.7,13.2,41.5l-2.1,42.1l5.5,0.3v6.2c-25.2-3.7-52.3-0.5-72,16.8c-19.4,17-30.8,44-25.6,69.7
	c7.7,38.1,44.2,59.5,81.2,59.8c0.8,0,14.2-0.2,14.2-0.8c0,0.2,5,399.2,0,398.8c-1.8-0.1-3.6-0.4-5.4-0.5
	c-30.3-1.7-64.1,8.7-81.3,35.1c-0.7,1.1-1.4,2.2-2,3.3c-8.4,14.9-10.6,32.9-7.7,49.6c6.2,35.6,35.9,56.9,70.4,60.6
	c0.9,0.1,15.8,1.2,15.8,0.7C976.2,899.5,975.1,925.6,974,952.6z"
          />
          <path
            class="st0"
            d="M753.7,615.1l0.8,150l80,30.3c0,0,38.1,16.5,63-18.2c25.5-35.5,72.8-33.9,72.8-33.9l1.4-145.2
	C971.7,598,920,583.8,753.7,615.1z"
          />
          <path
            class="st0"
            d="M853.4,380.6c0,0-18,12.4-30,27.7c-11.5,14.6-47.3,80-61,135.2c-12.6,50.7-8.8,71.5-8.8,71.5
	c4.3-1.2,160.1-29.5,218-16.9l1.2-200.9c0,0,1.9-17.4-23.4-16.6C924,381.4,853.4,380.6,853.4,380.6z"
          />
          <path
            class="st0"
            d="M905.3,158.1c0,0-22.4,0.2-29.9,25.4c-8,26.8-23,131.6-23,131.6s-7.5,43-15,52.8l0.6-25.2l-1.3-19.8l-0.1-2.3
	c-0.4-23,12-155.3,40.8-186.7c12.1-9.3,26.7-16.2,30.7-18.1c0.5-0.3,1.1,0.2,1.1,0.8l-4.1,41.8"
          />
          <path
            class="st0"
            d="M905.2,158l0.8,76.5c0,0,22.4-36.9,82.6-28.1v-6.2l-5.5-0.3l1.9-36.6c0.2-3,0.4-5.9-0.2-8.9
	c-1.8-9.3-5.5-34.7-11.8-38.3c0,0-18.5,8.9-26.9-7.1c-0.1-0.2-0.3-0.3-0.5-0.3c-3.5,0-26.8,0.1-29.8,0.1c-0.2,0-0.4,0.1-0.5,0.2
	l-5.6,5.4c-0.1,0.1-0.2,0.3-0.2,0.5L905.2,158z"
          />
          <polyline
            class="st0"
            points="953.5,609.4 950.2,609.4 950.2,615.2 946.6,618.2 946.6,673.4 946.6,728.6 950.2,731.6 950.2,737.4 
	953.5,737.4 956.7,737.4 956.7,731.6 960.4,728.6 960.4,673.4 960.4,618.2 956.7,615.2 956.7,609.4 953.5,609.4 "
          />
          <polyline
            class="st0"
            points="953.5,403 950.2,403 950.2,408.8 946.6,411.8 946.6,463.7 946.6,521.4 946.6,572.3 950.2,575.3 
	950.2,581 953.5,581 956.7,581 956.7,575.3 960.4,572.3 960.4,520 960.4,462.6 960.4,411.8 956.7,408.8 956.7,403 953.5,403 "
          />
          <polygon
            class="st0"
            points="845.2,405.4 833.7,405.4 813.4,437.1 814.3,455.5 829.4,454.6 843.4,436.4 "
          />
          <polygon
            class="st0"
            points="843.3,436.6 829.5,454.4 830.3,460.7 835.5,461.3 842.8,452.8 "
          />
          <path
            class="st0"
            d="M867.5,577.4v-23.8c0-3.6-2.9-6.5-6.5-6.5l0,0c-3.6,0-6.5,2.9-6.5,6.5v23.8c0,3.6,2.9,6.5,6.5,6.5l0,0
	C864.6,583.9,867.5,581,867.5,577.4z"
          />
          <path
            class="st0"
            d="M867.5,786.5v-23.7c0-3.6-2.9-6.5-6.5-6.5l0,0c-3.6,0-6.5,2.9-6.5,6.5v23.8c0,3.6,2.9,6.5,6.5,6.5l0,0
	C864.6,793,867.5,790.1,867.5,786.5z"
          />
          <path
            class="st0"
            d="M762.8,774.6c0.6,1.3,7.3,2.8,9.1,3.5c2.6,1,5.2,2,7.8,3c6.3,2.5,12.6,4.9,18.9,7.4
	c10.7,4.2,21.4,8.4,32.1,12.6c0.2,0.1,3.1,1,3.1,1.2c0,16.2,0,32.3-0.1,48.5c0,4.6-0.3,9.8-3.8,12.8c-2.8,2.4-6.9,2.4-10.2,1.1
	c-2.6-1-4.9-2.8-7-4.6c-11.6-10.5-19.1-25.5-26.5-39C777.9,806,769.9,790.5,762.8,774.6z"
          />
          <path
            class="st0"
            d="M877.5,1009.1c0,0-1.9-24.6-1.9-30.9s-6.6-7.1-6.6-7.1s-15.2,0-22.5,0s-6.4,7.1-6.4,7.1v29.6v1.9
	c0,0,28.1,1.4,37.5,0V1009.1z"
          />
          <path
            class="st0"
            d="M900.4,864.7c0.2,0.3-0.5,2.3-0.6,2.7c-0.2,1.1-0.5,2.1-0.7,3.2c-2.3,11-2.5,22.4-2.3,33.6
	c0.2,11,0.5,22.1,0.7,33.1c0,0.4,0,0.9,0,1.3c0.2,13.6,0.5,27.2,0.7,40.8c0,9,0.3,18,0.4,27c0,0.6,0,1.2,0.2,1.7
	c0.2,0.6,0.6,1.1,0.9,1.5c2.3,3,4.6,6,6.9,9c0.7,1,1.5,1.9,2.6,2.5c2.2,1.2,5.2,0.5,7.6,0.6c2.8,0.2,5.5,0.2,8.3,0.3
	c6,0.2,12.1,0.5,18.1,0.7c0.8,0,1.6,0.1,2.4-0.2c0.7-0.2,1.2-0.7,1.7-1.2c3.8-3.2,7.6-6.2,11.5-9.2c0.4-0.3,0.9-0.7,1.4-0.8
	c0.3-0.1,0.7-0.1,1.1-0.1c3.5,0,7,0,10.5,0l4.8-112C976.4,899.6,929.8,904.8,900.4,864.7z"
          />
          <path
            class="st1"
            d="M761.6,472.1c0,0,6.2,17.7,8.3,22.2c2.1,4.5,67.1-124.9,67.1-124.9c2.4-6.4,0.5-45.7-0.3-46.1L761.6,472.1z"
          />
          <path
            class="st1"
            d="M752.4,771.4c1.7,9,3.7,17.9,5.4,26.9c2.7,14.2,10.3,26.9,16.7,39.6c4.8,9.6,9.7,19.3,14.6,28.9
	c5.2,10.3,10.4,20.6,15.6,30.8c4.4,8.7,8.9,17.5,13.3,26.2c2.5,5,5,9.9,7.6,14.9c0.2,0.4,0.5,0.9,0.7,1.3c0,0,8,16.9-1.6,36.6
	l-66.6-150.3c0,0-11.1-28.7-16.7-49.1l-0.4-1.7l11.2-5.2L752.4,771.4z"
          />
          <path
            class="st1"
            d="M752.1,770.3c-0.5-2.8-1-5.7-1.5-8.6c-1.1-7-3.3-156.9,2.2-192.6c5.6-35.7,16.6-74.9,16.6-74.9l-8-21.6
	c-7.9,14.8-17.9,76.6-17.9,76.6c-3.2,0-7.8,197.8-2.7,226.3L752.1,770.3z"
          />
          <ellipse class="st0" cx="879.1" cy="356.5" rx="8.2" ry="15.7" />
          <g>
            <line class="st2" x1="760.5" y1="604.8" x2="836.7" y2="587.9" />
            <polygon
              class="st3"
              points="836.8,588.1 836.7,587.5 760.4,604.6 760.5,605.1"
            />
          </g>
          <g>
            <line class="st2" x1="761.7" y1="623.2" x2="837.1" y2="616.3" />

            <rect
              x="761.6"
              y="619.4"
              transform="matrix(0.996 -8.982757e-02 8.982757e-02 0.996 -52.436 74.3137)"
              class="st3"
              width="75.7"
              height="0.5"
            />
          </g>
          <g>
            <line class="st2" x1="762.1" y1="623.2" x2="763.5" y2="757.4" />

            <rect
              x="762.6"
              y="623.2"
              transform="matrix(0.9999 -1.016754e-02 1.016754e-02 0.9999 -6.9792 7.7926)"
              class="st3"
              width="0.5"
              height="134.2"
            />
          </g>
          <g>
            <line class="st2" x1="763.5" y1="757" x2="833.8" y2="780.3" />
            <polygon
              class="st3"
              points="833.9,780.1 763.6,756.8 763.4,757.3 833.7,780.6"
            />
          </g>
          <g>
            <line class="st2" x1="836.4" y1="616.4" x2="833.8" y2="779.7" />

            <rect
              x="753.5"
              y="697.8"
              transform="matrix(1.562275e-02 -0.9999 0.9999 1.562275e-02 124.0881 1522.2416)"
              class="st3"
              width="163.3"
              height="0.5"
            />
          </g>
          <path
            class="st3"
            d="M845.2,405.6v-0.5h-11.7l-0.1,0.1l-20.5,32.1c-0.1,0.2-11.5,17.8-23.7,47c-11.2,27-25.4,69.8-29.2,120.2h0.5
	c3.9-50.4,18-93,29.1-120c12.1-29.2,23.4-46.7,23.7-46.9l20.4-31.9h11.5V405.6z"
          />
          <g>
            <line class="st2" x1="837.1" y1="587.9" x2="845.2" y2="405.4" />

            <rect
              x="749.8"
              y="496.4"
              transform="matrix(4.487628e-02 -0.999 0.999 4.487628e-02 307.2663 1314.6416)"
              class="st3"
              width="182.7"
              height="0.5"
            />
          </g>
          <path
            class="st0"
            d="M972.6,116.6c0,0-9.7,4.4-19.6,0v13.2c0,0,7.2,7.4,19.6,3.6C972.6,133.4,972.6,116.6,972.6,116.6z"
          />
          <g class={`${this.addClassName("svg_RightFrontFender")}`}>
            <path
              style={{ fill: this.fillColor("svg_RightFrontFender") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RightFrontFender")}
              class="st4"
              d="M898.1,226.6h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6V224
		C900.7,225.5,899.5,226.6,898.1,226.6z"
            />
            <g>
              <path
                class="st5"
                d="M890.6,213.5c0.3,0.2,0.5,0.6,0.7,0.9c0.2,0.4,0.3,0.9,0.3,1.5c0,0.6-0.1,1.1-0.3,1.6
			c-0.2,0.5-0.5,0.9-0.9,1.3c-0.4,0.4-0.9,0.7-1.5,0.9s-1.2,0.3-1.9,0.3c-0.7,0-1.4-0.1-2.1-0.3s-1.3-0.4-1.7-0.6v-1.8h0.1
			c0.5,0.3,1.1,0.6,1.7,0.8c0.7,0.2,1.3,0.3,1.9,0.3c0.4,0,0.8-0.1,1.2-0.2c0.4-0.1,0.7-0.3,1-0.5c0.3-0.3,0.5-0.5,0.6-0.8
			c0.1-0.3,0.2-0.7,0.2-1.2c0-0.5-0.1-0.8-0.2-1.2c-0.1-0.3-0.4-0.5-0.6-0.7c-0.3-0.2-0.6-0.3-0.9-0.4c-0.4-0.1-0.8-0.1-1.2-0.1H886
			V212h0.6c0.9,0,1.6-0.2,2.1-0.6s0.8-0.9,0.8-1.6c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.3-0.4-0.6-0.6c-0.2-0.2-0.5-0.3-0.8-0.3
			c-0.3-0.1-0.6-0.1-1-0.1c-0.6,0-1.1,0.1-1.8,0.3c-0.6,0.2-1.2,0.5-1.8,0.8h-0.1v-1.8c0.4-0.2,1-0.4,1.7-0.6s1.4-0.3,2-0.3
			c0.6,0,1.2,0.1,1.7,0.2c0.5,0.1,0.9,0.3,1.3,0.6c0.4,0.3,0.7,0.6,0.9,1c0.2,0.4,0.3,0.9,0.3,1.4c0,0.7-0.3,1.3-0.8,1.9
			c-0.5,0.5-1.1,0.9-1.8,1v0.1c0.3,0,0.6,0.1,1,0.3S890.4,213.3,890.6,213.5z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RightFrontDoor")}`}>
            <path
              style={{ fill: this.fillColor("svg_RightFrontDoor") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RightFrontDoor")}
              class="st4"
              d="M905.6,510H884c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6v21.6
		C908.2,508.8,907,510,905.6,510z"
            />
            <g>
              <path
                class="st5"
                d="M899,498.9c0,0.6-0.1,1.2-0.3,1.7s-0.5,1-0.9,1.4c-0.4,0.4-0.9,0.7-1.5,0.9s-1.2,0.3-2,0.3
			c-0.7,0-1.4-0.1-2-0.2c-0.7-0.1-1.2-0.3-1.7-0.5v-1.8h0.1c0.5,0.3,1,0.6,1.7,0.8s1.3,0.3,1.9,0.3c0.4,0,0.8-0.1,1.2-0.2
			c0.4-0.1,0.7-0.3,1-0.6c0.3-0.2,0.4-0.5,0.6-0.9c0.1-0.3,0.2-0.8,0.2-1.2c0-0.4-0.1-0.8-0.2-1.1c-0.2-0.3-0.4-0.6-0.6-0.7
			c-0.3-0.2-0.7-0.4-1.1-0.5c-0.4-0.1-0.9-0.1-1.5-0.1c-0.5,0-1,0-1.5,0.1s-0.9,0.1-1.2,0.2V490h7.8v1.5h-6.1v3.4
			c0.2,0,0.5,0,0.8-0.1c0.3,0,0.5,0,0.7,0c0.7,0,1.3,0.1,1.8,0.2c0.5,0.1,1,0.3,1.5,0.6c0.5,0.3,0.8,0.7,1.1,1.2
			S899,498.1,899,498.9z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RightBackDoor")}`}>
            <path
              style={{ fill: this.fillColor("svg_RightBackDoor") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RightBackDoor")}
              class="st4"
              d="M909.8,686.8h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6v21.6
		C912.4,685.6,911.2,686.8,909.8,686.8z"
            />
            <g>
              <path
                class="st5"
                d="M903.5,668.9l-5.9,11h-1.9l6.2-11.4h-7.4v-1.5h8.9V668.9z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RightBackFender")}`}>
            <path
              style={{ fill: this.fillColor("svg_RightBackFender") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RightBackFender")}
              class="st4"
              d="M869.5,909.3H848c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6v21.6
		C872.1,908.1,870.9,909.3,869.5,909.3z"
            />
            <g>
              <path
                class="st5"
                d="M863.3,895.1c0,1.1-0.1,2.2-0.4,3.1c-0.3,0.9-0.6,1.7-1.2,2.4c-0.5,0.7-1.2,1.2-2,1.5
			c-0.8,0.4-1.7,0.5-2.8,0.5c-0.3,0-0.6,0-0.9,0c-0.3,0-0.5-0.1-0.7-0.2v-1.7h0.1c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0.1,0.7,0.1,1,0.1
			c1.3,0,2.3-0.4,3-1.2c0.7-0.8,1.2-1.8,1.3-3.2c-0.5,0.3-1,0.6-1.5,0.7c-0.5,0.1-1,0.2-1.6,0.2c-0.5,0-1-0.1-1.5-0.2
			c-0.4-0.1-0.9-0.3-1.3-0.6c-0.5-0.4-0.9-0.8-1.2-1.3s-0.4-1.2-0.4-2c0-1.3,0.4-2.4,1.3-3.2c0.9-0.8,1.9-1.2,3.2-1.2
			c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.5,1.4,0.9c0.5,0.5,0.9,1.1,1.1,1.9C863.2,892.9,863.3,893.9,863.3,895.1z M861.6,894.7
			c0-0.9-0.1-1.6-0.3-2.2c-0.2-0.5-0.4-1-0.8-1.3c-0.3-0.3-0.6-0.4-0.9-0.6c-0.3-0.1-0.7-0.2-1-0.2c-0.8,0-1.5,0.3-2,0.8
			c-0.5,0.5-0.7,1.3-0.7,2.2c0,0.6,0.1,1,0.2,1.3c0.2,0.3,0.4,0.7,0.8,0.9c0.3,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.7,0.1,1,0.1
			c0.5,0,0.9-0.1,1.4-0.2c0.5-0.1,0.9-0.3,1.3-0.5c0-0.1,0-0.2,0-0.4C861.6,895.1,861.6,894.9,861.6,894.7z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M77.4,116.6c0,0,9.7,4.4,19.6,0v13.2c0,0-7.2,7.4-19.6,3.6L77.4,116.6z"
          />
          <g>
            <path
              class="st0"
              d="M86.7,215.8c-3.5,0-7.1,0.3-10.5,0.9c-30.1,5-52.9,31.1-52.9,62.5c0,31.5,22.9,57.6,52.9,62.5
		c3.4,0.5,7,0.9,10.5,0.9c35,0,63.5-28.4,63.5-63.4C150,244.1,121.7,215.8,86.7,215.8z M87.8,316.9c-4.1,0-7.9-0.6-11.6-1.7
		c-15.7-4.9-27.2-19.7-27.2-37s11.5-32.1,27.2-37c3.6-1.2,7.6-1.7,11.6-1.7c21.4,0,38.8,17.3,38.8,38.7
		C126.5,299.5,109.2,316.9,87.8,316.9z"
            />
            <line class="st0" x1="76.2" y1="352.2" x2="76.2" y2="341.7" />
            <line class="st0" x1="76.2" y1="216.6" x2="76.2" y2="205.4" />
            <path
              class="st0"
              d="M126.5,278.1c0,21.4-17.3,38.7-38.8,38.7c-4.1,0-7.9-0.6-11.6-1.7c-15.7-4.9-27.2-19.7-27.2-37
		s11.5-32.1,27.2-37c3.6-1.2,7.6-1.7,11.6-1.7C109.2,239.3,126.5,256.7,126.5,278.1z"
            />
          </g>
          <path
            class="st0"
            d="M86.2,761c-3.5,0-7.1,0.3-10.5,0.9c-30.1,5-52.9,31.1-52.9,62.5c0,31.5,22.9,57.6,52.9,62.5
	c3.4,0.5,7,0.9,10.5,0.9c35,0,63.5-28.4,63.5-63.4C149.5,789.5,121.1,761,86.2,761z M87.2,862.1c-4.1,0-7.9-0.6-11.6-1.7
	c-15.7-4.9-27.2-19.7-27.2-37s11.5-32.1,27.2-37c3.6-1.2,7.6-1.7,11.6-1.7c21.4,0,38.8,17.3,38.8,38.7
	C126,844.8,108.6,862.1,87.2,862.1z"
          />
          <path
            class="st0"
            d="M126.1,823.4c-0.1,21.4-17.4,38.7-38.8,38.7c-4.1,0-7.9-0.6-11.6-1.7c-15.7-4.9-27.2-19.7-27.2-37
	s11.5-32.1,27.2-37c3.6-1.2,7.6-1.7,11.6-1.7C108.6,784.7,126.1,802,126.1,823.4z"
          />
          <line class="st1" x1="75.7" y1="887" x2="75.7" y2="900.7" />
          <line class="st1" x1="75.7" y1="761.9" x2="75.7" y2="749.6" />
          <path
            class="st0"
            d="M75.5,953.1c1.2,29.1,2.5,59.2,2.5,59.2h11.8c7.2,5.8,15,11.5,15,11.5l36.1-1.4l10.4-13.4c0,0,53.1,4.5,65.3,0
	s8.1-31.9,8.1-31.9c1.7-3.9,3.5-7.8,5.2-11.7c4.4-9.8,8.7-19.7,13.1-29.5c5.7-12.9,11.5-25.8,17.2-38.7
	c5.8-13.1,11.6-26.3,17.4-39.4c5.3-12.1,10.8-24.2,16-36.4c5.2-12.1,9.1-24.7,13-37.3c1.4-4.4,2.5-8.5,2.8-13.2
	c0.3-4.6,0.2-9.2,0.3-13.9c0.3-10.7,0.4-21.4,0.5-32.1c0.1-13.3,0.2-26.6,0.2-40c0-14.2-0.1-28.4-0.3-42.6
	c-0.2-13.3-0.4-26.7-0.8-40c-0.3-10.7-0.7-21.5-1.5-32.2c-0.3-4.1-0.6-8.3-1.1-12.4c-5.4-43.8-18.4-84.2-18.4-84.2l-75-149
	c0-0.6-0.1-1.2-0.1-1.8c-0.9-15.5-2.1-31-3.7-46.5c-1.3-12.5-2.8-25-4.7-37.5c-1.5-9.9-3.2-19.7-5.2-29.5c-1.5-7.5-3.3-15-5.3-22.4
	c-1.5-5.5-3.1-11-4.9-16.3c-1.8-5.3-3.9-10.5-5.8-15.8c-1.8-5.1-3.7-10.3-6.8-14.8c-6-8.6-15.8-13.5-24.8-18.4
	c-2.3-1.2-4.6-2.5-6.8-3.8c0,0-3.1-1.6-4.3-2.2c-0.2-0.2-0.5-0.5-0.5-0.5l-5.9-5.7c-0.1-0.1-0.3-0.2-0.5-0.2h-30.2
	c-0.3,0-0.6,0.2-0.7,0.5c-1.3,3.4-9.7,14-26,7.1c-6.1-2.6-13.3,41.7-13.2,41.5l2.1,42.1l-5.5,0.3v6.2c25.2-3.7,52.3-0.5,72,16.8
	c19.4,17,30.8,44,25.6,69.7c-7.7,38.1-44.2,59.5-81.2,59.8c-0.8,0-14.2-0.2-14.2-0.8c0,0.2-5,399.2,0,398.8c1.8-0.1,3.6-0.4,5.4-0.5
	c30.3-1.7,64.1,8.7,81.3,35.1c0.7,1.1,1.4,2.2,2,3.3c8.4,14.9,10.6,32.9,7.7,49.6c-6.2,35.6-35.9,56.9-70.4,60.6
	c-0.9,0.1-15.8,1.2-15.8,0.7C73.2,900.1,74.3,926.1,75.5,953.1z"
          />
          <path
            class="st1"
            d="M296.3,615.1l-0.8,150l-80,30.3c0,0-38.1,16.5-63-18.2c-25.5-35.5-72.8-33.9-72.8-33.9L78.3,598
	C78.3,598,130,583.8,296.3,615.1z"
          />
          <ellipse class="st0" cx="193.5" cy="904.2" rx="13.9" ry="20.1" />
          <path
            class="st1"
            d="M196.6,380.6c0,0,18,12.4,30,27.7c11.5,14.6,47.3,80,61,135.2c12.6,50.7,8.8,71.5,8.8,71.5
	c-4.3-1.2-160.1-29.5-218-16.9l-1.2-200.9c0,0-1.9-17.4,23.4-16.6C126,381.4,196.6,380.6,196.6,380.6z"
          />
          <path
            class="st0"
            d="M144.7,158.1c0,0,22.4,0.2,29.9,25.4c8,26.8,23,131.6,23,131.6s7.5,43,15,52.8l-0.6-25.2l1.3-19.8l0.1-2.3
	c0.4-23-12-155.3-40.8-186.7c-12.1-9.3-26.7-16.2-30.7-18.1c-0.5-0.3-1.1,0.2-1.1,0.8l4.1,41.8"
          />
          <path
            class="st0"
            d="M144.8,159l-0.8,76.5c0,0-22.4-36.9-82.6-28.1v-6.2l5.5-0.3l-1.9-36.6c-0.2-3-0.4-5.9,0.2-8.9
	c1.8-9.3,5.5-34.7,11.8-38.3c0,0,18.5,8.9,26.9-7.1c0.1-0.2,0.3-0.3,0.5-0.3c3.5,0,26.8,0.1,29.8,0.1c0.2,0,0.4,0.1,0.5,0.2l5.6,5.4
	c0.1,0.1,0.2,0.3,0.2,0.5L144.8,159z"
          />
          <polyline
            class="st0"
            points="96.5,609.4 99.8,609.4 99.8,615.2 103.4,618.2 103.4,673.4 103.4,728.6 99.8,731.6 99.8,737.4 
	96.5,737.4 93.3,737.4 93.3,731.6 89.6,728.6 89.6,673.4 89.6,618.2 93.3,615.2 93.3,609.4 96.5,609.4 "
          />
          <polyline
            class="st0"
            points="96.5,403 99.8,403 99.8,408.8 103.4,411.8 103.4,463.7 103.4,521.4 103.4,572.3 99.8,575.3 99.8,581 
	96.5,581 93.3,581 93.3,575.3 89.6,572.3 89.6,520 89.6,462.6 89.6,411.8 93.3,408.8 93.3,403 96.5,403 "
          />
          <polygon
            class="st0"
            points="204.8,405.4 216.3,405.4 236.6,437.1 235.7,455.5 220.6,454.6 206.5,436.4 "
          />
          <polygon
            class="st0"
            points="206.7,436.6 220.5,454.4 219.7,460.7 214.5,461.3 207.2,452.8 "
          />
          <path
            class="st0"
            d="M182.5,577.4v-23.8c0-3.6,2.9-6.5,6.5-6.5l0,0c3.6,0,6.5,2.9,6.5,6.5v23.8c0,3.6-2.9,6.5-6.5,6.5l0,0
	C185.4,583.9,182.5,581,182.5,577.4z"
          />
          <path
            class="st0"
            d="M182.5,786.5v-23.7c0-3.6,2.9-6.5,6.5-6.5l0,0c3.6,0,6.5,2.9,6.5,6.5v23.8c0,3.6-2.9,6.5-6.5,6.5l0,0
	C185.4,793,182.5,790.1,182.5,786.5z"
          />
          <path
            class="st0"
            d="M287.1,774.6c-0.6,1.3-7.3,2.8-9.1,3.5c-2.6,1-5.2,2-7.8,3c-6.3,2.5-12.6,4.9-18.9,7.4
	c-10.7,4.2-21.4,8.4-32.1,12.6c-0.2,0.1-3.1,1-3.1,1.2c0,16.2,0,32.3,0.1,48.5c0,4.6,0.3,9.8,3.8,12.8c2.8,2.4,6.9,2.4,10.2,1.1
	c2.6-1,4.9-2.8,7-4.6c11.6-10.5,19.1-25.5,26.5-39C272.1,806,280.1,790.5,287.1,774.6z"
          />
          <path
            class="st0"
            d="M210,978.1v31.6c0,0-28.1,1.4-37.4,0v-0.6c0,0,1.9-24.6,1.9-30.9c0-6.3,6.6-7.1,6.6-7.1s15.2,0,22.5,0
	C210.8,971.1,210,978.1,210,978.1z"
          />
          <path
            class="st1"
            d="M149.6,865.7c-0.2,0.3,0.5,2.3,0.6,2.7c0.2,1.1,0.5,2.1,0.7,3.2c2.3,11,2.5,22.4,2.3,33.6
	c-0.2,11-0.5,22.1-0.7,33.1c0,0.4,0,0.9,0,1.3c-0.2,13.6-0.5,27.2-0.7,40.8c0,9-0.3,18-0.4,27c0,0.6,0,1.2-0.2,1.7
	c-0.2,0.6-0.6,1.1-0.9,1.5c-2.3,3-4.6,6-6.9,9c-0.7,1-1.5,1.9-2.6,2.5c-2.2,1.2-5.2,0.5-7.6,0.6c-2.8,0.2-5.5,0.2-8.3,0.3
	c-6,0.2-12.1,0.5-18.1,0.7c-0.8,0-1.6,0.1-2.4-0.2c-0.7-0.2-1.2-0.7-1.7-1.2c-3.8-3.2-7.6-6.2-11.5-9.2c-0.4-0.3-0.9-0.7-1.4-0.8
	c-0.3-0.1-0.7-0.1-1.1-0.1c-3.5,0-7,0-10.5,0l-4.8-112C73.6,900.6,120.2,905.8,149.6,865.7z"
          />
          <path
            class="st0"
            d="M288.4,472.1c0,0-6.2,17.7-8.3,22.2S213,369.3,213,369.3c-2.4-6.4-0.5-45.7,0.3-46.1L288.4,472.1z"
          />
          <path
            class="st0"
            d="M297.6,771.4c-1.7,9-3.7,17.9-5.4,26.9c-2.7,14.2-10.3,26.9-16.7,39.6c-4.8,9.6-9.7,19.3-14.6,28.9
	c-5.2,10.3-10.4,20.6-15.6,30.8c-4.4,8.7-8.9,17.5-13.3,26.2c-2.5,5-5,9.9-7.6,14.9c-0.2,0.4-0.5,0.9-0.7,1.3c0,0-8,16.9,1.6,36.6
	l66.6-150.3c0,0,11.1-28.7,16.7-49.1l0.4-1.7l-11.2-5.2L297.6,771.4z"
          />
          <path
            class="st0"
            d="M297.8,770.3c0.5-2.8,1-5.7,1.5-8.6c1.1-7,3.3-156.9-2.2-192.6c-5.6-35.7-16.6-74.9-16.6-74.9l8-21.6
	c7.9,14.8,17.9,76.6,17.9,76.6c3.2,0,7.8,197.8,2.7,226.3L297.8,770.3z"
          />
          <ellipse class="st0" cx="170.9" cy="356.5" rx="8.2" ry="15.7" />
          <g>
            <line class="st2" x1="289.5" y1="604.8" x2="213.3" y2="587.9" />
            <polygon
              class="st3"
              points="213.2,588.1 213.3,587.5 289.6,604.6 289.5,605.1"
            />
          </g>
          <g>
            <line class="st2" x1="288.3" y1="623.2" x2="212.9" y2="616.3" />

            <rect
              x="250.3"
              y="581.9"
              transform="matrix(8.982757e-02 -0.996 0.996 8.982757e-02 -389.1275 813.6318)"
              class="st3"
              width="0.5"
              height="75.7"
            />
          </g>
          <g>
            <line class="st2" x1="287.9" y1="623.2" x2="286.5" y2="757.4" />

            <rect
              x="220"
              y="690"
              transform="matrix(1.016754e-02 -0.9999 0.9999 1.016754e-02 -406.0941 970.3518)"
              class="st3"
              width="134.2"
              height="0.5"
            />
          </g>
          <g>
            <line class="st2" x1="286.5" y1="757" x2="216.2" y2="780.3" />
            <polygon
              class="st3"
              points="216.1,780.1 286.4,756.8 286.6,757.3 216.3,780.6"
            />
          </g>
          <g>
            <line class="st2" x1="213.6" y1="616.4" x2="216.2" y2="779.7" />

            <rect
              x="214.6"
              y="616.4"
              transform="matrix(0.9999 -1.562275e-02 1.562275e-02 0.9999 -10.88 3.4417)"
              class="st3"
              width="0.5"
              height="163.3"
            />
          </g>
          <path
            class="st3"
            d="M204.8,405.6v-0.5h11.7l0.1,0.1l20.5,32.1c0.1,0.2,11.5,17.8,23.7,47c11.2,27,25.4,69.8,29.2,120.2h-0.5
	c-3.9-50.4-18-93-29.1-120c-12.1-29.2-23.4-46.7-23.7-46.9l-20.4-31.9h-11.5V405.6z"
          />
          <g>
            <line class="st2" x1="212.9" y1="587.9" x2="204.8" y2="405.4" />

            <rect
              x="208.6"
              y="405.3"
              transform="matrix(0.999 -4.487628e-02 4.487628e-02 0.999 -22.0766 9.8729)"
              class="st3"
              width="0.5"
              height="182.7"
            />
          </g>
          <g class={`${this.addClassName("svg_LeftFrontFender")}`}>
            <path
              style={{ fill: this.fillColor("svg_LeftFrontFender") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_LeftFrontFender")}
              class="st4"
              d="M173.4,226.6h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6V224
		C176,225.5,174.9,226.6,173.4,226.6z"
            />
            <g>
              <path
                class="st5"
                d="M167.1,219.9h-8.8v-1.8c0.6-0.5,1.2-1,1.8-1.6c0.6-0.5,1.2-1,1.7-1.6c1.1-1.1,1.9-1.9,2.3-2.6
			c0.4-0.6,0.6-1.3,0.6-2.1c0-0.7-0.2-1.2-0.7-1.6s-1.1-0.6-1.9-0.6c-0.5,0-1.1,0.1-1.7,0.3s-1.2,0.5-1.8,0.9h-0.1v-1.8
			c0.4-0.2,1-0.4,1.7-0.6c0.7-0.2,1.4-0.3,2-0.3c1.3,0,2.4,0.3,3.1,1c0.8,0.6,1.1,1.5,1.1,2.6c0,0.5-0.1,1-0.2,1.4
			c-0.1,0.4-0.3,0.8-0.6,1.2c-0.2,0.4-0.5,0.7-0.8,1.1s-0.7,0.7-1.1,1.2c-0.6,0.6-1.3,1.2-1.9,1.8c-0.7,0.6-1.3,1.1-1.9,1.6h7V219.9
			z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_LeftFrontDoor")}`}>
            <path
              style={{ fill: this.fillColor("svg_LeftFrontDoor") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_LeftFrontDoor")}
              class="st4"
              d="M155.6,500.4H134c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6v21.6
		C158.2,499.2,157,500.4,155.6,500.4z"
            />
            <g>
              <path
                class="st5"
                d="M149.7,489.8h-1.9v3.6h-1.7v-3.6h-6.2v-2l6.3-7.3h1.6v7.9h1.9V489.8z M146.1,488.4v-5.9l-5,5.9H146.1z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_LeftBackDoor")}`}>
            <path
              style={{ fill: this.fillColor("svg_LeftBackDoor") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_LeftBackDoor")}
              class="st4"
              d="M156.9,683.6h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6V681
		C159.5,682.5,158.3,683.6,156.9,683.6z"
            />
            <g>
              <path
                class="st5"
                d="M150.7,672.5c0,1.3-0.4,2.4-1.3,3.2s-1.9,1.2-3.2,1.2c-0.6,0-1.2-0.1-1.7-0.3c-0.5-0.2-1-0.5-1.4-0.9
			c-0.5-0.5-0.9-1.1-1.2-1.9s-0.4-1.8-0.4-2.9c0-1.1,0.1-2.2,0.4-3.1c0.2-0.9,0.6-1.7,1.2-2.4c0.5-0.7,1.2-1.2,2-1.5
			c0.8-0.4,1.7-0.6,2.8-0.6c0.3,0,0.6,0,0.9,0s0.5,0.1,0.7,0.2v1.7h-0.1c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3-0.1-0.7-0.1-1-0.1
			c-1.2,0-2.2,0.4-3,1.2s-1.2,1.8-1.3,3.2c0.5-0.3,1-0.5,1.4-0.7s1-0.2,1.6-0.2c0.6,0,1,0.1,1.5,0.2c0.4,0.1,0.9,0.3,1.3,0.6
			c0.5,0.4,0.9,0.8,1.2,1.3C150.6,671.1,150.7,671.8,150.7,672.5z M148.9,672.6c0-0.5-0.1-1-0.2-1.3c-0.2-0.4-0.4-0.7-0.8-0.9
			c-0.3-0.2-0.6-0.3-0.9-0.4c-0.3-0.1-0.7-0.1-1-0.1c-0.5,0-1,0.1-1.4,0.2s-0.9,0.3-1.3,0.5c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0,0.4
			c0,0.9,0.1,1.6,0.3,2.2c0.2,0.5,0.4,1,0.8,1.3c0.3,0.3,0.6,0.4,0.9,0.6c0.3,0.1,0.6,0.2,1,0.2c0.8,0,1.5-0.3,2-0.8
			C148.7,674.3,148.9,673.6,148.9,672.6z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_LeftBackFender")}`}>
            <path
              style={{ fill: this.fillColor("svg_LeftBackFender") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_LeftBackFender")}
              class="st4"
              d="M194.4,875.6h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6V873
		C197,874.5,195.9,875.6,194.4,875.6z"
            />
            <g>
              <path
                class="st5"
                d="M188.3,865.1c0,1.1-0.4,2.1-1.3,2.8c-0.9,0.7-2,1.1-3.3,1.1c-1.4,0-2.5-0.4-3.4-1.1c-0.8-0.7-1.2-1.7-1.2-2.8
			c0-0.7,0.2-1.4,0.6-2s1-1,1.8-1.4v-0.1c-0.7-0.4-1.2-0.8-1.5-1.2s-0.5-1-0.5-1.7c0-1,0.4-1.8,1.2-2.4c0.8-0.7,1.8-1,3.1-1
			c1.3,0,2.3,0.3,3.1,0.9c0.8,0.6,1.2,1.4,1.2,2.4c0,0.6-0.2,1.2-0.5,1.7c-0.4,0.6-0.9,1-1.6,1.3v0.1c0.8,0.3,1.4,0.8,1.9,1.3
			C188,863.7,188.3,864.3,188.3,865.1z M186.5,865.3c0-0.5-0.1-1-0.4-1.3s-0.7-0.6-1.4-1c-0.3-0.1-0.6-0.2-0.9-0.4
			c-0.3-0.1-0.8-0.3-1.3-0.5c-0.5,0.3-0.9,0.7-1.3,1.2c-0.3,0.5-0.5,1-0.5,1.7c0,0.8,0.3,1.4,0.8,1.9c0.5,0.5,1.2,0.8,2.1,0.8
			c0.8,0,1.5-0.2,2-0.7C186.2,866.6,186.5,866,186.5,865.3z M186.2,858.8c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.4-1.1-0.6-1.8-0.6
			c-0.7,0-1.3,0.2-1.8,0.5c-0.5,0.3-0.7,0.8-0.7,1.4c0,0.4,0.1,0.8,0.4,1.1s0.6,0.6,1.1,0.8c0.2,0.1,0.5,0.2,0.9,0.4
			s0.8,0.3,1.2,0.4c0.6-0.4,1-0.8,1.2-1.2S186.2,859.3,186.2,858.8z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_FenderTrimPlateFL")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_FenderTrimPlateFL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_FenderTrimPlateFL")}
              class="st0"
              points="180.7,263.6 180.7,300.3 162.4,282"
            />
            <g>
              <path
                d="M172.6,284.8h-3.4v-0.6h1.3V280h-1.3v-0.6c0.2,0,0.4,0,0.6,0c0.2,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.2,0.3-0.3
			c0.1-0.1,0.1-0.3,0.1-0.4h0.7v5.6h1.3V284.8z"
              />
              <path
                d="M178.5,282.8c0,0.6-0.2,1.2-0.6,1.6c-0.4,0.4-0.9,0.6-1.5,0.6c-0.3,0-0.6,0-0.8-0.1c-0.3-0.1-0.5-0.2-0.7-0.4
			c-0.2-0.2-0.4-0.5-0.6-0.9c-0.1-0.4-0.2-0.8-0.2-1.4c0-0.6,0.1-1,0.2-1.5c0.1-0.4,0.3-0.8,0.6-1.1c0.2-0.3,0.6-0.6,1-0.7
			c0.4-0.2,0.8-0.3,1.4-0.3c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0.1v0.8h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1
			c-0.6,0-1.1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0.2-0.1,0.5-0.3,0.7-0.3c0.2-0.1,0.5-0.1,0.8-0.1c0.3,0,0.5,0,0.7,0.1
			c0.2,0,0.4,0.1,0.6,0.3c0.2,0.2,0.4,0.4,0.6,0.6C178.5,282.1,178.5,282.4,178.5,282.8z M177.7,282.8c0-0.3,0-0.5-0.1-0.6
			c-0.1-0.2-0.2-0.3-0.4-0.4c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2,0-0.3,0-0.5,0c-0.2,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.1-0.6,0.3
			c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.4,0,0.8,0.1,1c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3
			c0.1,0.1,0.3,0.1,0.5,0.1c0.4,0,0.7-0.1,1-0.4C177.6,283.7,177.7,283.3,177.7,282.8z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RightFrontFender")}`}>
            <polygon
              style={{
                fill: this.fillColor("svg_SideFenderTurnSignalRepeaterLampL"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_SideFenderTurnSignalRepeaterLampL")
              }
              class="st0"
              points="143.1,373.6 143.1,339.3 160.3,356.5"
            />
            <g>
              <path
                d="M148.2,360.1h-4v-0.8h1.5v-5h-1.5v-0.7c0.2,0,0.4,0,0.7-0.1c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.2,0.4-0.3
			c0.1-0.1,0.1-0.3,0.2-0.5h0.8v6.7h1.5V360.1z"
              />
              <path
                d="M155,357.7c0,0.3-0.1,0.7-0.2,1s-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.9,0.5c-0.3,0.1-0.7,0.2-1.1,0.2
			c-0.4,0-0.8,0-1.2-0.1c-0.4-0.1-0.7-0.2-1-0.3v-1.1h0.1c0.3,0.2,0.6,0.3,1,0.4c0.4,0.1,0.7,0.2,1.1,0.2c0.2,0,0.5,0,0.7-0.1
			c0.2-0.1,0.4-0.2,0.6-0.3c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.7c0-0.3,0-0.5-0.1-0.6c-0.1-0.2-0.2-0.3-0.4-0.4
			c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.5-0.1-0.8-0.1c-0.3,0-0.6,0-0.8,0.1c-0.3,0-0.5,0.1-0.7,0.1v-3.8h4.5v0.9h-3.5v2
			c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.6,0.2,0.8,0.4c0.3,0.2,0.5,0.4,0.6,0.7
			C155,356.9,155,357.3,155,357.7z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_DecorStickerOfRoofFrameL")}`}>
            <path
              style={{ fill: this.fillColor("svg_DecorStickerOfRoofFrameL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_DecorStickerOfRoofFrameL")}
              class="st4"
              d="M275.7,451.1L275.7,451.1c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8
		l0,0C288.5,445.4,282.8,451.1,275.7,451.1z"
            />
            <g>
              <path
                d="M273.7,443.4h-5.5v-1h2.1v-6.8h-2.1v-0.9c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.5-0.4
			c0.1-0.2,0.2-0.4,0.2-0.7h1.1v9.1h2.1V443.4z"
              />
              <path d="M283.2,434.8l-4.6,8.6h-1.5l4.9-8.9h-5.8v-1.2h6.9V434.8z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_SideViewMirrorL")}`}>
            <path
              style={{ fill: this.fillColor("svg_SideViewMirrorL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_SideViewMirrorL")}
              class="st4"
              d="M219.3,443.3L219.3,443.3c-5.7,0-10.3-4.6-10.3-10.3v0c0-5.7,4.6-10.3,10.3-10.3h0c5.7,0,10.3,4.6,10.3,10.3v0
		C229.6,438.7,225,443.3,219.3,443.3z"
            />
            <g>
              <path
                d="M217.7,437.1h-4.4v-0.8h1.7v-5.4h-1.7v-0.7c0.2,0,0.5,0,0.7-0.1c0.3,0,0.5-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.3
			c0.1-0.1,0.2-0.3,0.2-0.6h0.8v7.3h1.7V437.1z"
              />
              <path
                d="M225.3,434.8c0,0.7-0.3,1.3-0.8,1.7c-0.5,0.5-1.2,0.7-2.1,0.7c-0.9,0-1.6-0.2-2.1-0.7c-0.5-0.5-0.8-1-0.8-1.7
			c0-0.5,0.1-0.9,0.4-1.2c0.3-0.4,0.6-0.7,1.1-0.9v0c-0.4-0.2-0.8-0.5-1-0.8c-0.2-0.3-0.3-0.6-0.3-1c0-0.6,0.3-1.1,0.8-1.5
			c0.5-0.4,1.1-0.6,1.9-0.6c0.8,0,1.5,0.2,1.9,0.6c0.5,0.4,0.7,0.9,0.7,1.5c0,0.4-0.1,0.7-0.3,1.1c-0.2,0.4-0.6,0.6-1,0.8v0
			c0.5,0.2,0.9,0.5,1.2,0.8C225.2,433.9,225.3,434.3,225.3,434.8z M224.2,434.9c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.4-0.4-0.9-0.6
			c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5-0.2-0.8-0.3c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,1c0,0.5,0.2,0.9,0.5,1.2
			c0.3,0.3,0.8,0.5,1.3,0.5c0.5,0,1-0.1,1.3-0.4C224,435.8,224.2,435.4,224.2,434.9z M224,430.9c0-0.4-0.1-0.7-0.4-0.9
			c-0.3-0.2-0.7-0.3-1.1-0.3c-0.5,0-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.9c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.4,0.4,0.7,0.5
			c0.1,0.1,0.3,0.2,0.6,0.3c0.3,0.1,0.5,0.2,0.7,0.3c0.4-0.2,0.6-0.5,0.7-0.7C223.9,431.5,224,431.2,224,430.9z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_SideMirrorRepeaterLampL")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_SideMirrorRepeaterLampL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_SideMirrorRepeaterLampL")}
              class="st0"
              points="186.9,461.9 186.9,427.6 204.1,444.7"
            />
            <g>
              <path
                d="M192.1,446.7h-3.4V446h1.3v-4.3h-1.3v-0.6c0.2,0,0.4,0,0.6,0c0.2,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.2,0.3-0.3
			c0.1-0.1,0.1-0.3,0.1-0.4h0.7v5.7h1.3V446.7z"
              />
              <path
                d="M198,443.1c0,0.6-0.1,1.1-0.2,1.5c-0.1,0.5-0.3,0.8-0.6,1.2c-0.3,0.3-0.6,0.6-1,0.8c-0.4,0.2-0.8,0.3-1.4,0.3
			c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3-0.1v-0.8h0c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0.1,0.5,0.1c0.6,0,1.1-0.2,1.5-0.6
			c0.4-0.4,0.6-0.9,0.6-1.6c-0.3,0.2-0.5,0.3-0.7,0.3c-0.2,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.5,0-0.7-0.1c-0.2-0.1-0.4-0.2-0.6-0.3
			c-0.3-0.2-0.4-0.4-0.6-0.7c-0.1-0.3-0.2-0.6-0.2-1c0-0.6,0.2-1.2,0.6-1.6s0.9-0.6,1.6-0.6c0.3,0,0.6,0,0.9,0.1
			c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.4,0.5,0.6,0.9C198,442.1,198,442.5,198,443.1z M197.2,442.9c0-0.4,0-0.8-0.1-1.1
			c-0.1-0.3-0.2-0.5-0.4-0.6c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1c-0.4,0-0.7,0.1-1,0.4c-0.2,0.3-0.4,0.6-0.4,1.1
			c0,0.3,0,0.5,0.1,0.7c0.1,0.2,0.2,0.3,0.4,0.4c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0,0.7-0.1
			c0.2-0.1,0.4-0.1,0.6-0.3c0-0.1,0-0.1,0-0.2C197.2,443.1,197.2,443,197.2,442.9z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_OuterUpperDoorWindowTrim_Crom_FL"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_OuterUpperDoorWindowTrim_Crom_FL"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_OuterUpperDoorWindowTrim_Crom_FL")
              }
              class="st0"
              points="235.9,493.8 236.1,457.2 254.3,475.6"
            />
            <g>
              <path
                d="M242.8,479.3l-5,0l0-1c0.4-0.3,0.7-0.6,1.1-0.9c0.4-0.3,0.7-0.6,1-0.9c0.6-0.6,1.1-1.1,1.3-1.5c0.2-0.4,0.4-0.8,0.4-1.2
			c0-0.4-0.1-0.7-0.4-0.9c-0.3-0.2-0.6-0.3-1.1-0.3c-0.3,0-0.6,0-1,0.2c-0.4,0.1-0.7,0.3-1,0.5l-0.1,0l0-1.1c0.2-0.1,0.6-0.2,1-0.3
			c0.4-0.1,0.8-0.1,1.1-0.1c0.8,0,1.4,0.2,1.8,0.6c0.4,0.4,0.6,0.9,0.6,1.5c0,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.3,0.7
			c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.4,0.4-0.6,0.7c-0.4,0.3-0.7,0.7-1.1,1c-0.4,0.3-0.7,0.6-1.1,0.9l4,0L242.8,479.3z"
              />
              <path
                d="M249.3,475.6c0,1.3-0.2,2.3-0.6,2.9c-0.4,0.6-1.1,0.9-2,0.9c-0.9,0-1.5-0.3-2-1c-0.4-0.6-0.6-1.6-0.6-2.9
			c0-1.3,0.2-2.3,0.6-2.9c0.4-0.6,1.1-0.9,2-0.9c0.9,0,1.5,0.3,2,1C249.1,473.4,249.3,474.3,249.3,475.6z M248,477.9
			c0.1-0.3,0.2-0.6,0.2-1c0-0.4,0.1-0.8,0.1-1.3c0-0.5,0-0.9-0.1-1.3c0-0.4-0.1-0.7-0.2-1c-0.1-0.3-0.3-0.5-0.5-0.6
			c-0.2-0.1-0.5-0.2-0.8-0.2c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.5,0.6c-0.1,0.2-0.2,0.6-0.2,1c0,0.4-0.1,0.8-0.1,1.3
			c0,0.5,0,1,0,1.3c0,0.4,0.1,0.7,0.2,0.9c0.1,0.3,0.3,0.5,0.5,0.6c0.2,0.1,0.5,0.2,0.8,0.2c0.3,0,0.6-0.1,0.8-0.2
			C247.7,478.4,247.9,478.2,248,477.9z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_SideWindowFL")}`}>
            <path
              style={{ fill: this.fillColor("svg_SideWindowFL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_SideWindowFL")}
              class="st4"
              d="M246.8,544.4L246.8,544.4c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8
		l0,0C259.6,538.6,253.9,544.4,246.8,544.4z"
            />
            <g>
              <path
                d="M245.9,536.6h-6.8v-1.4c0.5-0.4,1-0.8,1.4-1.2c0.5-0.4,0.9-0.8,1.3-1.2c0.9-0.8,1.5-1.5,1.8-2c0.3-0.5,0.5-1,0.5-1.6
			c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.3-0.8-0.4-1.5-0.4c-0.4,0-0.9,0.1-1.3,0.2c-0.5,0.1-0.9,0.4-1.4,0.7h-0.1v-1.4
			c0.3-0.2,0.8-0.3,1.3-0.4c0.5-0.1,1.1-0.2,1.6-0.2c1,0,1.8,0.3,2.4,0.8c0.6,0.5,0.9,1.2,0.9,2c0,0.4,0,0.7-0.1,1.1
			c-0.1,0.3-0.2,0.6-0.4,0.9c-0.2,0.3-0.4,0.6-0.6,0.8c-0.2,0.3-0.5,0.6-0.9,0.9c-0.5,0.5-1,0.9-1.5,1.4c-0.5,0.4-1,0.9-1.4,1.2h5.4
			V536.6z"
              />
              <path
                d="M253.9,531.7c0.2,0.2,0.4,0.4,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1
			c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.2-1.5,0.2c-0.6,0-1.1-0.1-1.7-0.2c-0.5-0.1-1-0.3-1.3-0.4v-1.4h0.1
			c0.4,0.3,0.8,0.5,1.4,0.6s1,0.3,1.5,0.3c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.5-0.7
			c0.1-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.1
			h-0.6v-1.1h0.5c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.3c0-0.2-0.1-0.5-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5
			c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1c-0.4,0-0.9,0.1-1.4,0.2c-0.5,0.2-0.9,0.4-1.4,0.7h-0.1v-1.4
			c0.3-0.2,0.8-0.3,1.3-0.4c0.5-0.1,1.1-0.2,1.6-0.2c0.5,0,0.9,0,1.3,0.1c0.4,0.1,0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.7,0.8
			c0.2,0.3,0.3,0.7,0.3,1.1c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.7-1.4,0.8v0.1c0.2,0,0.5,0.1,0.7,0.2
			C253.4,531.4,253.7,531.6,253.9,531.7z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_Rocker_RunningPanelFL_DecorStrip"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_Rocker_RunningPanelFL_DecorStrip"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_Rocker_RunningPanelFL_DecorStrip")
              }
              class="st0"
              points="123,405.6 123,439.9 105.8,422.8"
            />
            <g>
              <path
                d="M115.4,426.1H111v-0.9c0.3-0.3,0.6-0.5,0.9-0.8c0.3-0.3,0.6-0.5,0.9-0.8c0.6-0.5,0.9-1,1.1-1.3c0.2-0.3,0.3-0.7,0.3-1
			c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.9-0.3c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.6,0.2-0.9,0.4h0v-0.9c0.2-0.1,0.5-0.2,0.8-0.3
			c0.3-0.1,0.7-0.1,1-0.1c0.7,0,1.2,0.2,1.6,0.5c0.4,0.3,0.6,0.8,0.6,1.3c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.3,0.6
			c-0.1,0.2-0.2,0.4-0.4,0.5c-0.2,0.2-0.3,0.4-0.6,0.6c-0.3,0.3-0.6,0.6-1,0.9c-0.3,0.3-0.6,0.6-0.9,0.8h3.5V426.1z"
              />
              <path
                d="M121,424c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.4-0.7,0.5c-0.3,0.1-0.6,0.2-1,0.2
			c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1c0.2,0.2,0.5,0.3,0.8,0.4s0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4
			c-0.2-0.1-0.3-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.7,0.1c-0.2,0-0.4,0.1-0.6,0.1v-3.3h3.9v0.8h-3.1v1.7
			c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0c0.4,0,0.7,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.4,0.5,0.6
			C121,423.3,121,423.6,121,424z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_UprightOuterDoorCover_PlateFirstOneBL"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor(
                  "svg_UprightOuterDoorCover_PlateFirstOneBL"
                ),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_UprightOuterDoorCover_PlateFirstOneBL")
              }
              class="st0"
              points="250.7,638.4 216.4,638.4 233.5,621.2"
            />
            <g>
              <path
                d="M233.2,635.2h-4.6v-1c0.3-0.3,0.6-0.6,1-0.8c0.3-0.3,0.6-0.5,0.9-0.8c0.6-0.6,1-1,1.2-1.4c0.2-0.3,0.3-0.7,0.3-1.1
			c0-0.4-0.1-0.6-0.4-0.8c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.6,0.2-1,0.4h0v-1c0.2-0.1,0.5-0.2,0.9-0.3
			c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.2,0.2,1.6,0.5c0.4,0.3,0.6,0.8,0.6,1.4c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.3,0.6
			c-0.1,0.2-0.3,0.4-0.4,0.6c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.7,0.6-1,0.9c-0.3,0.3-0.7,0.6-1,0.8h3.7V635.2z"
              />
              <path
                d="M239.3,633c0,0.7-0.2,1.3-0.7,1.7c-0.5,0.4-1,0.7-1.7,0.7c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.5
			c-0.3-0.3-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.6,0.1-1.1,0.2-1.6c0.1-0.5,0.3-0.9,0.6-1.2c0.3-0.3,0.6-0.6,1-0.8
			c0.4-0.2,0.9-0.3,1.5-0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0.1v0.9h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1
			c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.7,1.7c0.3-0.2,0.5-0.3,0.8-0.4c0.2-0.1,0.5-0.1,0.9-0.1c0.3,0,0.5,0,0.8,0.1
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.2,0.5,0.4,0.6,0.7C239.2,632.2,239.3,632.5,239.3,633z M238.3,633c0-0.3,0-0.5-0.1-0.7
			c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0-0.5,0c-0.3,0-0.5,0-0.7,0.1s-0.5,0.2-0.7,0.3c0,0.1,0,0.1,0,0.2
			c0,0.1,0,0.1,0,0.2c0,0.5,0,0.9,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.3,0.1,0.5,0.1
			c0.4,0,0.8-0.1,1-0.4C238.2,633.9,238.3,633.5,238.3,633z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_OuterUpperDoorWindowTrim_Crom_BL"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_OuterUpperDoorWindowTrim_Crom_BL"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_OuterUpperDoorWindowTrim_Crom_BL")
              }
              class="st0"
              points="267.5,664.3 267.5,630 284.7,647.1"
            />
            <g>
              <path
                d="M273.7,651.5h-4.5v-0.9c0.3-0.3,0.6-0.5,0.9-0.8c0.3-0.3,0.6-0.5,0.9-0.8c0.6-0.6,1-1,1.2-1.3c0.2-0.3,0.3-0.7,0.3-1.1
			c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.9-0.3c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.6,0.2-0.9,0.4h0v-0.9c0.2-0.1,0.5-0.2,0.8-0.3
			c0.4-0.1,0.7-0.1,1-0.1c0.7,0,1.2,0.2,1.6,0.5c0.4,0.3,0.6,0.8,0.6,1.3c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.3,0.6
			c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.2-0.3,0.4-0.6,0.6c-0.3,0.3-0.6,0.6-1,0.9c-0.3,0.3-0.7,0.6-0.9,0.8h3.6V651.5z"
              />
              <path d="M279.5,645.9l-3,5.6h-1l3.2-5.8H275v-0.8h4.5V645.9z" />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_UprightOuterDoorCover_PlateSecondOneBL"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor(
                  "svg_UprightOuterDoorCover_PlateSecondOneBL"
                ),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_UprightOuterDoorCover_PlateSecondOneBL")
              }
              class="st0"
              points="249.6,743 284,743 266.8,760.2"
            />
            <g>
              <path
                d="M265.8,753l-4.7-0.4l0.1-1c0.3-0.3,0.7-0.5,1-0.8c0.3-0.3,0.7-0.5,1-0.8c0.6-0.5,1.1-1,1.3-1.3c0.2-0.3,0.4-0.7,0.4-1.1
			c0-0.4-0.1-0.6-0.3-0.9c-0.2-0.2-0.5-0.3-1-0.4c-0.3,0-0.6,0-0.9,0.1s-0.7,0.2-1,0.4l0,0l0.1-1c0.2-0.1,0.5-0.2,0.9-0.2
			c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0.1,1.2,0.3,1.6,0.6c0.4,0.4,0.5,0.8,0.5,1.4c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.2,0.4-0.3,0.6
			c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.2-0.4,0.4-0.6,0.6c-0.4,0.3-0.7,0.6-1.1,0.9c-0.4,0.3-0.7,0.5-1.1,0.8l3.7,0.3L265.8,753z"
              />
              <path
                d="M272.1,751.5c0,0.6-0.3,1.1-0.8,1.4c-0.5,0.4-1.1,0.5-1.8,0.5c-0.7-0.1-1.3-0.3-1.7-0.7c-0.4-0.4-0.6-0.9-0.6-1.5
			c0-0.4,0.2-0.7,0.4-1c0.2-0.3,0.6-0.5,1-0.7l0,0c-0.4-0.2-0.6-0.5-0.8-0.7c-0.2-0.2-0.2-0.5-0.2-0.9c0-0.5,0.3-0.9,0.7-1.2
			c0.5-0.3,1-0.4,1.7-0.4c0.7,0.1,1.2,0.3,1.6,0.6c0.4,0.4,0.6,0.8,0.5,1.3c0,0.3-0.1,0.6-0.4,0.9c-0.2,0.3-0.5,0.5-0.9,0.6l0,0
			c0.4,0.2,0.7,0.5,0.9,0.8C272,750.7,272.1,751.1,272.1,751.5z M271.1,751.5c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.3-0.4-0.7-0.6
			c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3,0.1-0.5,0.3-0.7,0.6c-0.2,0.2-0.3,0.5-0.3,0.9c0,0.4,0.1,0.8,0.4,1.1
			c0.3,0.3,0.6,0.5,1.1,0.5c0.5,0,0.8-0.1,1.1-0.3C270.9,752.2,271.1,751.9,271.1,751.5z M271.2,748c0-0.3-0.1-0.6-0.3-0.8
			c-0.2-0.2-0.6-0.3-1-0.4c-0.4,0-0.7,0-1,0.2c-0.3,0.2-0.4,0.4-0.4,0.7c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.3,0.5,0.5
			c0.1,0.1,0.3,0.1,0.5,0.3c0.2,0.1,0.4,0.2,0.6,0.3c0.3-0.2,0.5-0.4,0.7-0.6C271.1,748.6,271.2,748.3,271.2,748z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_OuterLowerDoorWindowSlotSeal_Crom_BL"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor(
                  "svg_OuterLowerDoorWindowSlotSeal_Crom_BL"
                ),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_OuterLowerDoorWindowSlotSeal_Crom_BL")
              }
              class="st0"
              points="234.9,726.1 234.9,760.4 217.7,743.2"
            />
            <g>
              <path
                d="M227.4,746.8h-4.7v-1c0.3-0.3,0.6-0.6,1-0.8c0.3-0.3,0.6-0.6,0.9-0.8c0.6-0.6,1-1,1.2-1.4c0.2-0.3,0.3-0.7,0.3-1.1
			c0-0.4-0.1-0.6-0.4-0.8c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.6,0.2-1,0.5h0v-1c0.2-0.1,0.5-0.2,0.9-0.3
			c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.3,0.2,1.7,0.5c0.4,0.3,0.6,0.8,0.6,1.4c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.3,0.6
			c-0.1,0.2-0.3,0.4-0.4,0.6c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.7,0.6-1,0.9c-0.4,0.3-0.7,0.6-1,0.8h3.7V746.8z"
              />
              <path
                d="M233.4,742.9c0,0.6-0.1,1.1-0.2,1.6c-0.1,0.5-0.3,0.9-0.6,1.3c-0.3,0.4-0.6,0.6-1.1,0.8s-0.9,0.3-1.5,0.3
			c-0.2,0-0.3,0-0.5,0c-0.1,0-0.3,0-0.4-0.1v-0.9h0c0.1,0,0.2,0.1,0.4,0.1c0.2,0,0.3,0.1,0.5,0.1c0.7,0,1.2-0.2,1.6-0.6
			c0.4-0.4,0.6-1,0.7-1.7c-0.3,0.2-0.6,0.3-0.8,0.4c-0.3,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.5,0-0.8-0.1c-0.2-0.1-0.5-0.2-0.7-0.3
			c-0.3-0.2-0.5-0.4-0.6-0.7c-0.1-0.3-0.2-0.6-0.2-1c0-0.7,0.2-1.3,0.7-1.7c0.5-0.4,1-0.7,1.7-0.7c0.3,0,0.6,0.1,0.9,0.2
			c0.3,0.1,0.5,0.3,0.7,0.5c0.3,0.3,0.5,0.6,0.6,1C233.3,741.8,233.4,742.3,233.4,742.9z M232.5,742.7c0-0.5,0-0.9-0.1-1.2
			s-0.2-0.5-0.4-0.7c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.3-0.1-0.5-0.1c-0.4,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.2
			c0,0.3,0,0.5,0.1,0.7c0.1,0.2,0.2,0.3,0.4,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4,0,0.6,0c0.2,0,0.5,0,0.7-0.1
			c0.2-0.1,0.5-0.2,0.7-0.3c0-0.1,0-0.1,0-0.2C232.5,742.9,232.5,742.8,232.5,742.7z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_SideWindowBL")}`}>
            <path
              style={{ fill: this.fillColor("svg_SideWindowBL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_SideWindowBL")}
              class="st4"
              d="M251.9,705.8L251.9,705.8c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8
		l0,0C264.7,700.1,259,705.8,251.9,705.8z"
            />
            <g>
              <path
                d="M250,693.2c0.2,0.2,0.4,0.4,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1
			c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.2-1.5,0.2c-0.6,0-1.1-0.1-1.7-0.2c-0.5-0.1-1-0.3-1.3-0.4v-1.4h0.1
			c0.4,0.3,0.8,0.5,1.4,0.6c0.5,0.2,1,0.3,1.5,0.3c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.5-0.7
			c0.1-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.1
			h-0.6v-1.1h0.5c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.3c0-0.2-0.1-0.5-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5
			c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1c-0.4,0-0.9,0.1-1.4,0.2c-0.5,0.2-0.9,0.4-1.4,0.7h-0.1v-1.4
			c0.3-0.2,0.8-0.3,1.3-0.4c0.5-0.1,1.1-0.2,1.6-0.2c0.5,0,0.9,0,1.3,0.1c0.4,0.1,0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.7,0.8
			c0.2,0.3,0.3,0.7,0.3,1.1c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.7-1.4,0.8v0.1c0.2,0,0.5,0.1,0.7,0.2
			C249.6,692.9,249.8,693.1,250,693.2z"
              />
              <path
                d="M259.7,693c0,1.8-0.3,3.1-0.9,4c-0.6,0.8-1.5,1.3-2.6,1.3c-1.2,0-2.1-0.4-2.7-1.3c-0.6-0.9-0.8-2.2-0.8-4
			c0-1.8,0.3-3.1,0.8-4c0.6-0.9,1.4-1.3,2.6-1.3c1.2,0,2.1,0.4,2.7,1.3C259.4,690,259.7,691.3,259.7,693z M257.9,696.1
			c0.2-0.4,0.3-0.8,0.3-1.3c0.1-0.5,0.1-1.1,0.1-1.8c0-0.7,0-1.3-0.1-1.8c-0.1-0.5-0.2-0.9-0.3-1.3c-0.2-0.3-0.4-0.6-0.6-0.8
			c-0.3-0.2-0.6-0.3-1.1-0.3c-0.4,0-0.8,0.1-1.1,0.3c-0.3,0.2-0.5,0.4-0.7,0.8c-0.2,0.3-0.3,0.8-0.3,1.3c-0.1,0.5-0.1,1.1-0.1,1.8
			c0,0.7,0,1.3,0.1,1.8c0,0.5,0.2,0.9,0.3,1.3c0.1,0.4,0.4,0.6,0.6,0.8c0.3,0.2,0.6,0.3,1.1,0.3c0.4,0,0.8-0.1,1.1-0.3
			C257.6,696.8,257.8,696.5,257.9,696.1z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_QuarterWindowBL")}`}>
            <path
              style={{ fill: this.fillColor("svg_QuarterWindowBL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_QuarterWindowBL")}
              class="st4"
              d="M242.5,830.7L242.5,830.7c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8
		l0,0C255.3,825,249.5,830.7,242.5,830.7z"
            />
            <g>
              <path
                d="M240.6,818.1c0.2,0.2,0.4,0.4,0.5,0.7s0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1
			c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.2-1.5,0.2c-0.6,0-1.1-0.1-1.7-0.2c-0.5-0.1-1-0.3-1.3-0.4v-1.4h0.1
			c0.4,0.3,0.8,0.5,1.4,0.6c0.5,0.2,1,0.3,1.5,0.3c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.5-0.7
			c0.1-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.1H237
			v-1.1h0.5c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.3c0-0.2-0.1-0.5-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5
			c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5-0.1-0.8-0.1c-0.4,0-0.9,0.1-1.4,0.2s-0.9,0.4-1.4,0.7H235v-1.4c0.3-0.2,0.8-0.3,1.3-0.4
			c0.5-0.1,1.1-0.2,1.6-0.2c0.5,0,0.9,0,1.3,0.1s0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.7,0.8c0.2,0.3,0.3,0.7,0.3,1.1
			c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.7-1.4,0.8v0.1c0.2,0,0.5,0.1,0.7,0.2C240.2,817.8,240.4,817.9,240.6,818.1z"
              />
              <path
                d="M249.5,818.1c0.2,0.2,0.4,0.4,0.5,0.7s0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1
			c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.2-1.5,0.2c-0.6,0-1.1-0.1-1.7-0.2c-0.5-0.1-1-0.3-1.3-0.4v-1.4h0.1
			c0.4,0.3,0.8,0.5,1.4,0.6c0.5,0.2,1,0.3,1.5,0.3c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.5-0.7
			c0.1-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.1
			h-0.6v-1.1h0.5c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.3c0-0.2-0.1-0.5-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5
			c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5-0.1-0.8-0.1c-0.4,0-0.9,0.1-1.4,0.2c-0.5,0.2-0.9,0.4-1.4,0.7h-0.1v-1.4c0.3-0.2,0.8-0.3,1.3-0.4
			c0.5-0.1,1.1-0.2,1.6-0.2c0.5,0,0.9,0,1.3,0.1c0.4,0.1,0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.7,0.8c0.2,0.3,0.3,0.7,0.3,1.1
			c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.7-1.4,0.8v0.1c0.2,0,0.5,0.1,0.7,0.2C249,817.8,249.3,817.9,249.5,818.1z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_TailLightOuterL")}`}>
            <path
              style={{ fill: this.fillColor("svg_TailLightOuterL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_TailLightOuterL")}
              class="st4"
              d="M192.2,1002.2L192.2,1002.2c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8h0
		c7.1,0,12.8,5.7,12.8,12.8l0,0C205.1,996.5,199.3,1002.2,192.2,1002.2z"
            />
            <g>
              <path
                d="M190.3,989.6c0.2,0.2,0.4,0.4,0.5,0.7s0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1
			c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.2-1.5,0.2c-0.6,0-1.1-0.1-1.7-0.2c-0.5-0.1-1-0.3-1.3-0.4v-1.4h0.1
			c0.4,0.3,0.8,0.5,1.4,0.6s1,0.3,1.5,0.3c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.5-0.7
			c0.1-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.1
			h-0.6v-1.1h0.5c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.3c0-0.2-0.1-0.5-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5
			c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1c-0.4,0-0.9,0.1-1.4,0.2c-0.5,0.2-0.9,0.4-1.4,0.7h-0.1v-1.4
			c0.3-0.2,0.8-0.3,1.3-0.4c0.5-0.1,1.1-0.2,1.6-0.2c0.5,0,0.9,0,1.3,0.1c0.4,0.1,0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.7,0.8
			c0.2,0.3,0.3,0.7,0.3,1.1c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.7-1.4,0.8v0.1c0.2,0,0.5,0.1,0.7,0.2
			C189.9,989.3,190.1,989.4,190.3,989.6z"
              />
              <path d="M200.1,985.9l-4.6,8.6h-1.5l4.9-8.9h-5.8v-1.2h6.9V985.9z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_FenderTrimPlateFR")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_FenderTrimPlateFR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_FenderTrimPlateFR")}
              class="st0"
              points="869.9,299.3 869.9,262.7 888.2,281"
            />
            <g>
              <path
                d="M877,282.3c0,0.7-0.2,1.3-0.7,1.8c-0.5,0.5-1.1,0.7-1.8,0.7c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.5
			c-0.3-0.3-0.5-0.6-0.6-1.1c-0.2-0.4-0.2-1-0.2-1.6c0-0.6,0.1-1.2,0.2-1.7c0.1-0.5,0.4-0.9,0.7-1.3c0.3-0.4,0.7-0.7,1.1-0.9
			c0.5-0.2,1-0.3,1.6-0.3c0.2,0,0.4,0,0.5,0c0.1,0,0.3,0,0.4,0.1v0.9h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.4-0.1-0.6-0.1
			c-0.7,0-1.3,0.2-1.7,0.7c-0.4,0.4-0.7,1-0.7,1.8c0.3-0.2,0.5-0.3,0.8-0.4c0.3-0.1,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.8,0.1
			c0.2,0.1,0.5,0.2,0.7,0.3c0.3,0.2,0.5,0.4,0.6,0.8C876.9,281.5,877,281.8,877,282.3z M876,282.3c0-0.3,0-0.6-0.1-0.8
			c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5,0-0.8,0.1c-0.2,0.1-0.5,0.2-0.7,0.3
			c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.3c0,0.5,0.1,0.9,0.2,1.2c0.1,0.3,0.3,0.5,0.4,0.7c0.1,0.1,0.3,0.2,0.5,0.3
			c0.2,0.1,0.4,0.1,0.6,0.1c0.5,0,0.8-0.1,1.1-0.4C875.9,283.3,876,282.8,876,282.3z"
              />
              <path d="M883.2,278.5l-3.3,6.2h-1l3.5-6.4h-4.1v-0.9h5V278.5z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_DecorStickerOfRoofFrameR")}`}>
            <path
              style={{ fill: this.fillColor("svg_DecorStickerOfRoofFrameR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_DecorStickerOfRoofFrameR")}
              class="st4"
              d="M775.5,454L775.5,454c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8l0,0c7.1,0,12.8,5.7,12.8,12.8v0
		C788.3,448.3,782.6,454,775.5,454z"
            />
            <g>
              <path
                d="M774.7,443c0,1-0.3,1.9-1,2.5c-0.7,0.6-1.5,1-2.5,1c-0.5,0-1-0.1-1.4-0.2s-0.8-0.4-1.1-0.7c-0.4-0.4-0.7-0.9-0.9-1.5
			c-0.2-0.6-0.3-1.4-0.3-2.2c0-0.9,0.1-1.7,0.3-2.4c0.2-0.7,0.5-1.3,0.9-1.8c0.4-0.5,0.9-0.9,1.5-1.2c0.6-0.3,1.4-0.4,2.2-0.4
			c0.3,0,0.5,0,0.7,0c0.2,0,0.4,0.1,0.6,0.1v1.3h-0.1c-0.1-0.1-0.3-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.8-0.1c-1,0-1.8,0.3-2.3,0.9
			c-0.6,0.6-0.9,1.4-1,2.5c0.4-0.2,0.8-0.4,1.1-0.5c0.4-0.1,0.8-0.2,1.3-0.2c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.7,0.2,1,0.5
			c0.4,0.3,0.7,0.6,0.9,1C774.6,441.9,774.7,442.4,774.7,443z M773.3,443.1c0-0.4-0.1-0.8-0.2-1c-0.1-0.3-0.3-0.5-0.6-0.7
			c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3,0-0.5-0.1-0.8-0.1c-0.4,0-0.7,0-1.1,0.1c-0.3,0.1-0.7,0.2-1,0.4c0,0.1,0,0.2,0,0.3
			c0,0.1,0,0.2,0,0.3c0,0.7,0.1,1.3,0.2,1.7c0.1,0.4,0.3,0.7,0.6,1c0.2,0.2,0.4,0.3,0.7,0.4c0.2,0.1,0.5,0.1,0.8,0.1
			c0.7,0,1.2-0.2,1.5-0.6C773.1,444.4,773.3,443.8,773.3,443.1z"
              />
              <path
                d="M783.5,443.5c0,0.9-0.3,1.6-1,2.2c-0.7,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8c-0.7-0.6-1-1.3-1-2.2
			c0-0.6,0.2-1.1,0.5-1.5c0.3-0.5,0.8-0.8,1.4-1.1v0c-0.5-0.3-0.9-0.6-1.2-1c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.8,0.3-1.4,0.9-1.9
			c0.6-0.5,1.4-0.8,2.4-0.8c1,0,1.8,0.2,2.4,0.7c0.6,0.5,0.9,1.1,0.9,1.8c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.7,0.8-1.3,1v0
			c0.6,0.3,1.1,0.6,1.5,1C783.3,442.3,783.5,442.8,783.5,443.5z M782.1,443.6c0-0.4-0.1-0.8-0.3-1c-0.2-0.3-0.5-0.5-1.1-0.8
			c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3-0.1-0.6-0.2-1-0.4c-0.4,0.2-0.7,0.5-1,0.9c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.6,0.2,1.1,0.6,1.5
			s1,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.5C781.9,444.7,782.1,444.2,782.1,443.6z M781.9,438.5c0-0.5-0.2-0.9-0.6-1.2
			c-0.4-0.3-0.9-0.4-1.4-0.4c-0.6,0-1,0.1-1.4,0.4c-0.4,0.3-0.5,0.6-0.5,1.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.4-0.3,0.8-0.6,0.9-0.9C781.8,439.3,781.9,438.9,781.9,438.5z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_SideViewMirrorR")}`}>
            <path
              style={{ fill: this.fillColor("svg_SideViewMirrorR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_SideViewMirrorR")}
              class="st4"
              d="M831.1,441.1L831.1,441.1c-5.6,0-10.2-4.6-10.2-10.2v0c0-5.6,4.6-10.2,10.2-10.2l0,0c5.6,0,10.2,4.6,10.2,10.2
		v0C841.3,436.6,836.7,441.1,831.1,441.1z"
            />
            <g>
              <path
                d="M830.5,432.4c0,0.8-0.3,1.5-0.8,2c-0.5,0.5-1.2,0.8-2,0.8c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.6-0.3-0.9-0.5
			c-0.3-0.3-0.5-0.7-0.7-1.2c-0.2-0.5-0.3-1.1-0.3-1.8c0-0.7,0.1-1.3,0.2-1.9c0.2-0.6,0.4-1,0.7-1.5c0.3-0.4,0.7-0.7,1.2-1
			c0.5-0.2,1.1-0.3,1.8-0.3c0.2,0,0.4,0,0.5,0c0.1,0,0.3,0.1,0.4,0.1v1h-0.1c-0.1-0.1-0.3-0.1-0.5-0.2c-0.2,0-0.4-0.1-0.6-0.1
			c-0.8,0-1.4,0.2-1.9,0.7c-0.5,0.5-0.7,1.1-0.8,2c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.6-0.1,1-0.1c0.3,0,0.6,0,0.9,0.1
			c0.3,0.1,0.5,0.2,0.8,0.4c0.3,0.2,0.6,0.5,0.7,0.8C830.4,431.5,830.5,431.9,830.5,432.4z M829.4,432.4c0-0.3,0-0.6-0.1-0.8
			c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.3-0.2-0.6-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.5,0.2-0.8,0.3
			c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3c0,0.6,0.1,1,0.2,1.3c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.3,0.3,0.5,0.3
			c0.2,0.1,0.4,0.1,0.6,0.1c0.5,0,0.9-0.2,1.2-0.5C829.2,433.5,829.4,433,829.4,432.4z"
              />
              <path
                d="M837.4,430.5c0,0.7-0.1,1.3-0.2,1.9c-0.2,0.6-0.4,1.1-0.7,1.5c-0.3,0.4-0.7,0.7-1.2,1c-0.5,0.2-1.1,0.3-1.7,0.3
			c-0.2,0-0.4,0-0.5,0c-0.2,0-0.3-0.1-0.4-0.1v-1h0.1c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0,0.4,0.1,0.6,0.1c0.8,0,1.4-0.2,1.9-0.7
			c0.5-0.5,0.7-1.1,0.8-2c-0.3,0.2-0.7,0.3-0.9,0.4c-0.3,0.1-0.6,0.1-1,0.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.8-0.4
			c-0.3-0.2-0.6-0.5-0.7-0.8c-0.2-0.3-0.2-0.7-0.2-1.2c0-0.8,0.3-1.5,0.8-2c0.5-0.5,1.2-0.8,2-0.8c0.4,0,0.7,0.1,1.1,0.2
			c0.3,0.1,0.6,0.3,0.9,0.5c0.3,0.3,0.5,0.7,0.7,1.2C837.3,429.1,837.4,429.7,837.4,430.5z M836.3,430.2c0-0.6-0.1-1-0.2-1.3
			c-0.1-0.3-0.3-0.6-0.5-0.8c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.8-0.5,1.4
			c0,0.3,0,0.6,0.1,0.8c0.1,0.2,0.3,0.4,0.5,0.6c0.2,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4,0.1,0.6,0.1c0.3,0,0.6,0,0.9-0.1
			c0.3-0.1,0.6-0.2,0.8-0.3c0-0.1,0-0.2,0-0.2C836.3,430.4,836.3,430.3,836.3,430.2z"
              />
            </g>
          </g>
          <polygon
            class="st0"
            points="380.2,506 380.2,825.6 358,825.6 358,508.7 329.3,395.5 350.8,390.1 377.7,496.3 "
          />
          <polygon
            class="st0"
            points="669.8,506 669.8,825.6 691.9,825.6 691.9,508.7 720.7,395.5 699.2,390.1 672.3,496.3 "
          />
          <path
            class="st0"
            d="M678.2,386L652,503.9c0,0-1.3,2-16,2c-14.7,0-87.6-19.7-232.7,0L372.9,386H678.2"
          />
          <g>
            <path
              class="st0"
              d="M515.4,395c0,0,5.2,3.1,0,8.4l-109-1.1V396L515.4,395z"
            />
            <rect x="391.7" y="392" class="st0" width="14.8" height="15.1" />
          </g>
          <g>
            <path
              class="st0"
              d="M657.4,393.2c0,0,4.7,3.1,0,8.4l-98.3-1.1v-6.3L657.4,393.2z"
            />
            <rect x="544.4" y="390.2" class="st0" width="14.8" height="15.1" />
          </g>
          <path class="st1" d="M434.9,502.4c0,0,95.9-12.8,177.6,0.8" />
          <path class="st3" d="M425.5,825.6" />
          <path
            class="st0"
            d="M612.8,503.5v317.9c0,0-117.8,9.3-177.6,3.7V502.2C435.2,502.2,544.3,490,612.8,503.5z"
          />
          <polygon
            class="st0"
            points="435,502.2 435,825.1 416.2,819.7 419.8,503.9 "
          />
          <polygon
            class="st0"
            points="631.5,820 612.6,821.3 612.6,503.5 627.8,505.6 "
          />
          <path class="st1" d="M523.7,155.6" />
          <path
            class="st0"
            d="M523.8,157.8c-19.5-0.5-39,0.1-58.3,2.1c-15.3,1.6-30.4,4.3-45.2,8.5c-13.3,3.8-28.7,8.1-38.1,19
	c-1.3,1.5-2.4,3.1-3.4,4.8c-0.3,0.5-0.5,1-0.8,1.6c-9.6,21.9-13.9,122.5-11.3,167.3l0.9,10.9l3.1,14.3l6.7-7.5l3.3-3.2
	c3.7-3.4,5.6-4.8,8.7-6.8c29.4-19.5,73.1-25.2,110.1-26.2c8.1-0.2,16.3,0.4,24.4,0.4c8.1,0,16.3-0.7,24.4-0.4
	c37,1,80.7,6.8,110.1,26.2c3.1,2,5,3.4,8.7,6.8l3.3,3.2l6.7,7.5L680,372l0.9-10.9c2.6-44.8-1.7-145.3-11.3-167.3
	c-0.2-0.5-0.5-1.1-0.8-1.6c-0.9-1.7-2.1-3.3-3.4-4.8c-9.4-10.9-24.7-15.2-38.1-19c-14.8-4.2-29.9-6.9-45.2-8.5
	C562.9,157.9,543.3,157.3,523.8,157.8z"
          />
          <path
            class="st0"
            d="M371.5,386.1h154.8l0.8-43.9C527,342.2,405.3,334.2,371.5,386.1z"
          />
          <path
            class="st0"
            d="M526.3,386.1h150.3c0,0-23.1-54.9-149.5-43.9L526.3,386.1z"
          />
          <path
            class="st0"
            d="M656.6,949.8l-6.5,47c-49.6,7.1-91.9,10.2-126,11c-34-0.8-76.4-4-126-11l-6.5-47c1,0.4,1.2,0.6,2.2,1
	c0,0,0.1,0,0.1,0c4.1,1.9,12.1,5.4,23.4,9.2c0,0,15.6,5.3,39.6,10.5c26.3,5.7,50.1,7.1,66.6,7h1.3c16.4,0.1,40.3-1.3,66.6-7
	c24-5.2,39.6-10.5,39.6-10.5c11.3-3.8,19.3-7.3,23.4-9.2c0,0,0.1,0,0.1,0C655.4,950.4,655.6,950.3,656.6,949.8z"
          />
          <path
            class="st0"
            d="M657,950c0,0-1,0.6-3,1.5c0,0-0.1,0-0.1,0c-7.8,3.5-15.6,6.5-23.4,9.2c-0.1,0-0.2,0.1-0.3,0.1
	c-4.8,1.8-9.8,3.2-14.7,4.6c-5.8,1.7-11.7,3.1-17.6,4.5c-6.7,1.5-13.5,2.8-20.2,3.9c-7.5,1.2-15.1,2.1-22.6,2.8
	c-8.1,0.7-16.2,1.2-24.3,1.3c-8.1,0.2-16.3,0-24.4-0.4c-7.7-0.4-15.4-1.1-23-2c-7-0.8-14-1.9-20.9-3.2c-6.2-1.2-12.4-2.5-18.6-4
	c-5.4-1.3-10.8-2.8-16.1-4.4c-1.7-0.5-3.3-1-5-1.5c-1.5-0.5-3.2-0.8-4.6-1.5c-0.1,0-0.2-0.1-0.3-0.1c-7.7-2.7-15.5-5.8-23.4-9.2
	c0,0-0.1,0-0.1,0c-2-0.9-3-1.5-3-1.5l9.2-82.4c0,0-0.3-8,3.1-9.4c0,0.1,0,0.1,0,0.1c5.5,1.2,10.9,2.2,16.4,3.1
	c5,0.8,10,1.6,15.1,2.3c6.2,0.9,12.4,1.8,18.7,2.6c1.6,0.2,3.2,0.4,4.9,0.6c0.2,0,0.3,0,0.5,0.1c18.2,2.3,39.4,4.5,61,5.8
	c1.2,0.1,2.4,0.1,3.6,0.2h0.7c0.2,0,0.4,0,0.5,0c0.2,0,0.3,0,0.5,0c0.9,0,1.7-0.1,2.6-0.2c21.5-1.3,42.7-3.5,60.8-5.8
	c0.2,0,0.5-0.1,0.7-0.1c1.6-0.2,3.2-0.4,4.9-0.6c6.2-0.8,12.4-1.7,18.7-2.6c5-0.7,10.1-1.5,15.1-2.3c5.5-0.9,11-1.9,16.4-3.1
	c0,0,0-0.1,0-0.1c3.4,1.4,3.1,9.4,3.1,9.4L657,950z"
          />
          <path
            class="st0"
            d="M644.4,842.5c0,1.2,0.3,13.8,0.3,15.3c0,0.1,0,0.1,0,0.1c-5.5,1.2-10.9,2.2-16.5,3.1c-5,0.8-10,1.6-15.1,2.3
	c-6.2,0.9-12.4,1.8-18.7,2.6c-1.6,0.2-3.2,0.4-4.9,0.6c-0.2,0-0.5,0.1-0.7,0.1c-0.4,0.1-0.8,0.1-1.2,0.2c-3.6,0.4-7.2,0.9-10.8,1.3
	c-3.8,0.4-7.6,0.8-11.4,1.2c-3.9,0.4-7.8,0.8-11.8,1.2c-4,0.4-8.1,0.7-12.1,1c0,0-0.1,0-0.1,0c-4,0.3-8.1,0.7-12.1,0.8
	c-4.1,0.2-8.1,0.2-12.2,0c-2-0.1-4.1-0.3-6.1-0.5c-2-0.2-4-0.2-6-0.4c-4-0.4-8.1-0.7-12.2-1.1c-3.9-0.4-7.9-0.8-11.8-1.2
	c-3.8-0.4-7.6-0.8-11.3-1.3c-3.6-0.4-7.1-0.9-10.7-1.3c-0.2,0-0.3,0-0.5-0.1c-1.6-0.2-3.2-0.4-4.9-0.6c-6.2-0.8-12.4-1.7-18.7-2.6
	c-5-0.7-10.1-1.5-15.1-2.3c-5.5-0.9-11-1.9-16.4-3.1c0,0,0-0.1,0-0.1c0-1.4,0.2-14.1,0.3-15.3c0.2-6.1-3.1-20.5,5.7-22
	c2.8-0.5,6.4-1.1,9.1-0.1c19.4,7.1,40.9,6.8,61.4,6.4c3.2-0.1,38.6-0.7,42.7-0.7l2.1-0.1c0,0,1.1,0,1.1,0c0.4,0,40.1-2,43.2-1.9
	c12.6,0.3,26.7-1,39.2-2.5c7.9-1,15.6-1.1,22.9-1.6c2.9-0.2,4.5,0,7.3,0.5C647.5,822,644.2,836.5,644.4,842.5z"
          />
          <g>
            <path
              class="st3"
              d="M508.1,795.5v12.8h25.3v-12.8H508.1z M532.6,807.6h-23.7v-11.3h23.7V807.6z"
            />
            <rect x="508.9" y="796.3" class="st6" width="23.7" height="11.3" />
          </g>
          <rect
            x="526"
            y="802.4"
            transform="matrix(0.8378 -0.5459 0.5459 0.8378 -357.793 419.1347)"
            class="st3"
            width="1.2"
            height="18.8"
          />
          <g>
            <path
              class="st0"
              d="M570.2,952.1c0,0,2.6,3.1,0,8.4l-54.7-1.1V953L570.2,952.1z"
            />
            <rect x="500.7" y="949" class="st0" width="14.8" height="15.1" />
          </g>
          <g class={`${this.addClassName("svg_Trunk")}`}>
            <path
              style={{ fill: this.fillColor("svg_Trunk") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_Trunk")}
              class="st4"
              d="M540.2,1006h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6v21.6
		C542.8,1004.9,541.6,1006,540.2,1006z"
            />
            <g>
              <path
                class="st5"
                d="M526.9,999.1h-7v-1.3h2.7v-8.7h-2.7v-1.2c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.7-0.1,0.9-0.3
			c0.3-0.1,0.5-0.3,0.6-0.6c0.2-0.2,0.2-0.5,0.3-0.9h1.3v11.7h2.6V999.1z"
              />
              <path
                class="st5"
                d="M538.9,992.6c0,2.3-0.4,4-1.1,5.1c-0.7,1.1-1.9,1.6-3.4,1.6c-1.6,0-2.7-0.6-3.4-1.7c-0.7-1.1-1.1-2.8-1.1-5.1
			c0-2.3,0.4-4,1.1-5.1c0.7-1.1,1.9-1.7,3.4-1.7c1.6,0,2.7,0.6,3.4,1.7C538.6,988.7,538.9,990.4,538.9,992.6z M536.7,996.6
			c0.2-0.5,0.3-1,0.4-1.7c0.1-0.6,0.1-1.4,0.1-2.3c0-0.9,0-1.6-0.1-2.3c-0.1-0.7-0.2-1.2-0.4-1.7c-0.2-0.4-0.5-0.8-0.8-1
			c-0.4-0.2-0.8-0.3-1.4-0.3c-0.5,0-1,0.1-1.4,0.3c-0.4,0.2-0.6,0.6-0.8,1c-0.2,0.4-0.3,1-0.4,1.7c-0.1,0.7-0.1,1.4-0.1,2.3
			c0,0.9,0,1.7,0.1,2.3c0.1,0.6,0.2,1.2,0.4,1.6c0.2,0.5,0.5,0.8,0.8,1c0.4,0.2,0.8,0.4,1.4,0.4c0.5,0,1-0.1,1.4-0.3
			S536.5,997.1,536.7,996.6z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M691.8,1081.5v102.4c0,0-3.6,11.2-11.2,13.8c-7.6,2.5-25.5,0-25.5,0s-10.7-5.1-10.2-14.3
	c0.5-8.7-2.3-36.7-2.5-39.5c0-0.2,0-0.2,0-0.2c-0.7-1.5-59.1-4.3-118.4-5c-59.3,0.7-117.6,3.4-118.4,5c0,0,0,0.1,0,0.2
	c-0.3,2.8-3,30.8-2.5,39.5c0.5,9.2-10.2,14.3-10.2,14.3s-17.8,2.5-25.5,0c-7.6-2.5-11.2-13.8-11.2-13.8v-102.4h10.2
	c3.6-14.8,4.1-72.8,4.1-72.8h307c0,0,0.5,58.1,4.1,72.8H691.8z"
          />
          <path
            class="st0"
            d="M691.5,1112l-10.1,6.2l1.4,24.5c-5.5,19.7-26.7,6.6-36.9,1.8c-0.6-0.3-1.8-0.5-3.5-0.8
	c-14.2-2.1-65.2-4.1-117.3-4.4c-0.4,0-0.7,0-1.1,0s-0.7,0-1.1,0c-52.1,0.3-103.1,2.3-117.3,4.4c-1.8,0.3-3,0.5-3.5,0.8
	c-10.2,4.8-31.4,17.8-36.9-1.8l1.4-24.5l-10.1-6.2l-0.2-30.6l166.1,1.3c0,0,0.8,0,1.6,0c0.8,0,1.6,0,1.6,0l166.1-1.3L691.5,1112z"
          />
          <polygon
            class="st0"
            points="677.5,1050.4 677.5,1050.3 678.4,1050.4 677.5,1015 650.4,1016.5 639.8,1050.4 "
          />
          <path
            class="st0"
            d="M691.6,1111.9l0.2,71.8c0,0-4.5,11.6-9.6,13c-5.1,1.4-7.7,2.3-27.1,0.7c0,0-10.7-4.2-10.2-14.3l-2.5-39.7l3.6,1
	c0,0,11.5,5.7,18,7.7c6.5,2,16.6,1.2,18.9-9.9l-1.4-24.2L691.6,1111.9z"
          />
          <path
            class="st0"
            d="M356.4,1111.9l-0.2,71.8c0,0,4.5,11.6,9.6,13c5.1,1.4,7.7,2.3,27.1,0.7c0,0,10.7-4.2,10.2-14.3l2.5-39.7l-3.6,1
	c0,0-11.5,5.7-18,7.7c-6.5,2-16.6,1.2-18.9-9.9l1.4-24.2L356.4,1111.9z"
          />
          <path
            class="st0"
            d="M649.6,1008.6l-20.9,60.4c0,0-1,7.6-12.7,7.6c-11.7,0-184.4,0-184.4,0s-11.7-1.5-14.3-11.7
	c-2.5-10.2-18.3-56.3-18.3-56.3L649.6,1008.6L649.6,1008.6z"
          />
          <path
            class="st0"
            d="M468.9,1051.7v-19.4c0-2.2,1.8-4.1,4.1-4.1h102.3c2.2,0,4.1,1.8,4.1,4.1v19.4c0,2.2-1.8,4.1-4.1,4.1H473
	C470.8,1055.8,468.9,1054,468.9,1051.7z"
          />
          <path
            class="st0"
            d="M510,1019.2v-6.3c0-0.7,0.5-1.3,1.1-1.3h26.8c0.6,0,1.1,0.6,1.1,1.3v6.3c0,0.7-0.5,1.3-1.1,1.3H511
	C510.4,1020.6,510,1020,510,1019.2z"
          />
          <path
            class="st0"
            d="M421.2,1035.4v-6.3c0-0.7,0.4-1.3,0.8-1.3h21.3c0.5,0,0.8,0.6,0.8,1.3v6.3c0,0.7-0.4,1.3-0.8,1.3H422
	C421.6,1036.7,421.2,1036.1,421.2,1035.4z"
          />
          <polygon
            class="st0"
            points="370.3,1049.9 370.3,1049.9 369.4,1049.9 370.3,1014.5 397.4,1016.1 408,1049.9 "
          />
          <g class={`${this.addClassName("svg_TrunkCover")}`}>
            <path
              style={{ fill: this.fillColor("svg_TrunkCover") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_TrunkCover")}
              class="st4"
              d="M539.5,1128.2h-21.6c-1.4,0-2.6-1.2-2.6-2.6V1104c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6v21.6
		C542.1,1127,540.9,1128.2,539.5,1128.2z"
            />
            <g>
              <path
                class="st5"
                d="M526.5,1121.3h-7v-1.3h2.7v-8.7h-2.7v-1.2c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.7-0.1,0.9-0.3
			c0.3-0.1,0.5-0.3,0.6-0.6c0.2-0.2,0.2-0.5,0.3-0.9h1.3v11.7h2.6V1121.3z"
              />
              <path
                class="st5"
                d="M537.9,1121.3h-7v-1.3h2.7v-8.7h-2.7v-1.2c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.7-0.1,0.9-0.3
			c0.3-0.1,0.5-0.3,0.6-0.6s0.2-0.5,0.3-0.9h1.3v11.7h2.6V1121.3z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_Roof")}`}>
            <path
              style={{ fill: this.fillColor("svg_Roof") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_Roof")}
              class="st4"
              d="M534.6,660.1h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6v21.6
		C537.2,658.9,536,660.1,534.6,660.1z"
            />
            <g>
              <path
                class="st5"
                d="M521.3,653.3h-7V652h2.7v-8.7h-2.7v-1.2c0.4,0,0.8,0,1.2-0.1s0.7-0.1,0.9-0.3c0.3-0.1,0.5-0.3,0.6-0.6
			c0.2-0.2,0.2-0.5,0.3-0.9h1.3V652h2.6V653.3z"
              />
              <path
                class="st5"
                d="M533.4,653.3h-8.8v-1.8c0.6-0.5,1.2-1,1.8-1.6c0.6-0.5,1.2-1,1.7-1.6c1.1-1.1,1.9-1.9,2.3-2.6
			s0.6-1.3,0.6-2.1c0-0.7-0.2-1.2-0.7-1.6s-1.1-0.6-1.9-0.6c-0.5,0-1.1,0.1-1.7,0.3c-0.6,0.2-1.2,0.5-1.8,0.9h-0.1v-1.8
			c0.4-0.2,1-0.4,1.7-0.6s1.4-0.3,2-0.3c1.3,0,2.4,0.3,3.1,1c0.8,0.6,1.1,1.5,1.1,2.6c0,0.5-0.1,1-0.2,1.4c-0.1,0.4-0.3,0.8-0.6,1.2
			c-0.2,0.4-0.5,0.7-0.8,1.1s-0.7,0.7-1.1,1.2c-0.6,0.6-1.3,1.2-1.9,1.8c-0.7,0.6-1.3,1.1-1.9,1.6h7V653.3z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_LeftRoofFrame")}`}>
            <path
              style={{ fill: this.fillColor("svg_LeftRoofFrame") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_LeftRoofFrame")}
              class="st4"
              d="M379.8,629.6h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6V627
		C382.4,628.5,381.3,629.6,379.8,629.6z"
            />
            <g>
              <path
                class="st5"
                d="M366.6,622.7h-7v-1.3h2.7v-8.7h-2.7v-1.2c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.7-0.1,0.9-0.3
			c0.3-0.1,0.5-0.3,0.6-0.6s0.2-0.5,0.3-0.9h1.3v11.7h2.6V622.7z"
              />
              <path
                class="st5"
                d="M377.6,616.5c0.3,0.2,0.5,0.6,0.7,0.9c0.2,0.4,0.3,0.9,0.3,1.5c0,0.6-0.1,1.1-0.3,1.6s-0.5,0.9-0.9,1.3
			c-0.4,0.4-0.9,0.7-1.5,0.9c-0.6,0.2-1.2,0.3-1.9,0.3c-0.7,0-1.4-0.1-2.1-0.3s-1.3-0.4-1.7-0.6v-1.8h0.1c0.5,0.3,1.1,0.6,1.7,0.8
			s1.3,0.3,1.9,0.3c0.4,0,0.8-0.1,1.2-0.2c0.4-0.1,0.7-0.3,1-0.5c0.3-0.3,0.5-0.5,0.6-0.8s0.2-0.7,0.2-1.2c0-0.5-0.1-0.8-0.2-1.2
			s-0.4-0.5-0.6-0.7c-0.3-0.2-0.6-0.3-0.9-0.4c-0.4-0.1-0.8-0.1-1.2-0.1H373V615h0.6c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.8-0.9,0.8-1.6
			c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.3-0.4-0.6-0.6c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3-0.1-0.6-0.1-1-0.1c-0.6,0-1.1,0.1-1.8,0.3
			c-0.6,0.2-1.2,0.5-1.8,0.8h-0.1v-1.8c0.4-0.2,1-0.4,1.7-0.6c0.7-0.2,1.4-0.3,2-0.3c0.6,0,1.2,0.1,1.7,0.2s0.9,0.3,1.3,0.6
			c0.4,0.3,0.7,0.6,0.9,1c0.2,0.4,0.3,0.9,0.3,1.4c0,0.7-0.3,1.3-0.8,1.9c-0.5,0.5-1.1,0.9-1.8,1v0.1c0.3,0,0.6,0.1,1,0.3
			C377,616.1,377.3,616.3,377.6,616.5z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RightRoofFrame")}`}>
            <path
              style={{ fill: this.fillColor("svg_RightRoofFrame") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RightRoofFrame")}
              class="st4"
              d="M692.4,629.6h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6V627
		C695,628.5,693.9,629.6,692.4,629.6z"
            />
            <g>
              <path
                class="st5"
                d="M679,622.8h-7v-1.3h2.7v-8.7H672v-1.2c0.4,0,0.8,0,1.2-0.1s0.7-0.1,0.9-0.3c0.3-0.1,0.5-0.3,0.6-0.6
			c0.2-0.2,0.2-0.5,0.3-0.9h1.3v11.7h2.6V622.8z"
              />
              <path
                class="st5"
                d="M691.3,619.1h-1.9v3.6h-1.7v-3.6h-6.2v-2l6.3-7.3h1.6v7.9h1.9V619.1z M687.8,617.7v-5.9l-5,5.9H687.8z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_Hood")}`}>
            <path
              style={{ fill: this.fillColor("svg_Hood") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_Hood")}
              class={`${this.addClassName("svg_Hood")} st4`}
              d="M534.6,262.5h-21.6c-1.4,0-2.6-1.2-2.6-2.6v-21.6c0-1.4,1.2-2.6,2.6-2.6h21.6c1.4,0,2.6,1.2,2.6,2.6v21.6
		C537.2,261.4,536,262.5,534.6,262.5z"
            />
            <g>
              <path
                class="st5"
                d="M528.3,257.5h-9v-1.7h3.5v-11.2h-3.5v-1.5c0.5,0,1,0,1.5-0.1c0.5-0.1,0.9-0.2,1.2-0.3
			c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.3-0.7,0.3-1.2h1.7v15h3.4V257.5z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_HoodEmblem")}`}>
            <path
              style={{ fill: this.fillColor("svg_HoodEmblem") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_HoodEmblem")}
              class="st4"
              d="M523.8,190.4L523.8,190.4c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C536.6,184.7,530.9,190.4,523.8,190.4z"
            />
            <g>
              <path d="M523.2,179.8h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V179.8z M520.4,178.7v-4.6l-3.9,4.6H520.4z" />
              <path d="M532.1,179.8h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V179.8z M529.3,178.7v-4.6l-3.9,4.6H529.3z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_CoverForPlenumChamberL")}`}>
            <path
              style={{ fill: this.fillColor("svg_CoverForPlenumChamberL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_CoverForPlenumChamberL")}
              class="st4"
              d="M462.1,376.7L462.1,376.7c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C474.9,371,469.2,376.7,462.1,376.7z"
            />
            <g>
              <path d="M461.6,366h-1.5v2.8h-1.3V366H454v-1.6l4.9-5.7h1.2v6.2h1.5V366z M458.8,365v-4.6l-3.9,4.6H458.8z" />
              <path
                d="M470.2,365.7c0,0.5-0.1,0.9-0.3,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.3-1.6,0.3
			c-0.6,0-1.1-0.1-1.6-0.2c-0.5-0.1-0.9-0.3-1.3-0.4v-1.4h0.1c0.4,0.2,0.8,0.4,1.3,0.6c0.5,0.2,1,0.2,1.5,0.2c0.3,0,0.6,0,0.9-0.1
			c0.3-0.1,0.6-0.2,0.8-0.5c0.2-0.2,0.3-0.4,0.5-0.7c0.1-0.3,0.2-0.6,0.2-0.9c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6
			c-0.2-0.2-0.5-0.3-0.9-0.4c-0.3-0.1-0.7-0.1-1.1-0.1c-0.4,0-0.8,0-1.2,0.1c-0.4,0.1-0.7,0.1-1,0.2v-5.2h6.1v1.2h-4.8v2.7
			c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.5,0c0.5,0,1,0,1.4,0.1c0.4,0.1,0.8,0.3,1.1,0.5c0.4,0.2,0.6,0.6,0.8,1S470.2,365.1,470.2,365.7z
			"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_CoverForPlenumChamberR")}`}>
            <path
              style={{ fill: this.fillColor("svg_CoverForPlenumChamberR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_CoverForPlenumChamberR")}
              class="st4"
              d="M597.8,376.7L597.8,376.7c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C610.6,371,604.9,376.7,597.8,376.7z"
            />
            <g>
              <path d="M597.3,366.1h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V366.1z M594.5,365.1v-4.6l-3.9,4.6H594.5z" />
              <path
                d="M606,365.7c0,1-0.3,1.9-1,2.5c-0.7,0.6-1.5,1-2.5,1c-0.5,0-1-0.1-1.4-0.2c-0.4-0.2-0.8-0.4-1.1-0.7
			c-0.4-0.4-0.7-0.9-0.9-1.5c-0.2-0.6-0.3-1.4-0.3-2.2c0-0.9,0.1-1.7,0.3-2.4c0.2-0.7,0.5-1.3,0.9-1.8c0.4-0.5,0.9-0.9,1.5-1.2
			c0.6-0.3,1.4-0.4,2.2-0.4c0.3,0,0.5,0,0.7,0c0.2,0,0.4,0.1,0.6,0.1v1.3H605c-0.1-0.1-0.3-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.8-0.1
			c-1,0-1.8,0.3-2.3,0.9c-0.6,0.6-0.9,1.4-1,2.5c0.4-0.2,0.8-0.4,1.1-0.5c0.4-0.1,0.8-0.2,1.3-0.2c0.4,0,0.8,0,1.1,0.1
			c0.3,0.1,0.7,0.2,1,0.5c0.4,0.3,0.7,0.6,0.9,1C605.9,364.6,606,365.1,606,365.7z M604.7,365.8c0-0.4-0.1-0.8-0.2-1
			c-0.1-0.3-0.3-0.5-0.6-0.7c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3,0-0.5-0.1-0.8-0.1c-0.4,0-0.7,0-1.1,0.1c-0.3,0.1-0.7,0.2-1,0.4
			c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.7,0.1,1.3,0.2,1.7c0.1,0.4,0.3,0.7,0.6,1c0.2,0.2,0.4,0.3,0.7,0.4
			c0.2,0.1,0.5,0.1,0.8,0.1c0.7,0,1.2-0.2,1.5-0.6C604.5,367.1,604.7,366.5,604.7,365.8z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_Windshield")}`}>
            <path
              style={{ fill: this.fillColor("svg_Windshield") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_Windshield")}
              class="st4"
              d="M523.2,468.9L523.2,468.9c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8
		l0,0C536,463.2,530.3,468.9,523.2,468.9z"
            />
            <g>
              <path d="M522.8,458.3h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V458.3z M519.9,457.2v-4.6l-3.9,4.6H519.9z" />
              <path
                d="M531.4,455.5c0,0.9-0.1,1.7-0.3,2.4c-0.2,0.7-0.5,1.3-0.9,1.8c-0.4,0.5-0.9,0.9-1.5,1.2c-0.6,0.3-1.3,0.4-2.2,0.4
			c-0.2,0-0.5,0-0.7,0c-0.2,0-0.4-0.1-0.6-0.1v-1.3h0.1c0.1,0.1,0.3,0.1,0.6,0.2c0.2,0.1,0.5,0.1,0.8,0.1c1,0,1.8-0.3,2.4-0.9
			c0.6-0.6,0.9-1.4,1-2.5c-0.4,0.3-0.8,0.4-1.2,0.5c-0.4,0.1-0.8,0.2-1.2,0.2c-0.4,0-0.8,0-1.1-0.1c-0.3-0.1-0.7-0.2-1-0.5
			c-0.4-0.3-0.7-0.6-0.9-1.1c-0.2-0.4-0.3-0.9-0.3-1.5c0-1,0.3-1.9,1-2.5c0.7-0.6,1.5-1,2.5-1c0.5,0,0.9,0.1,1.4,0.2
			c0.4,0.2,0.8,0.4,1.1,0.7c0.4,0.4,0.7,0.9,0.9,1.4C531.2,453.8,531.4,454.6,531.4,455.5z M530,455.2c0-0.7-0.1-1.3-0.2-1.7
			c-0.1-0.4-0.3-0.8-0.6-1c-0.2-0.2-0.4-0.4-0.7-0.4c-0.2-0.1-0.5-0.1-0.8-0.1c-0.7,0-1.2,0.2-1.5,0.6c-0.4,0.4-0.6,1-0.6,1.7
			c0,0.4,0.1,0.8,0.2,1.1c0.1,0.3,0.3,0.5,0.6,0.7c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0,0.5,0.1,0.8,0.1c0.4,0,0.7,0,1.1-0.1
			c0.4-0.1,0.7-0.2,1-0.4c0-0.1,0-0.2,0-0.3C530,455.5,530,455.4,530,455.2z"
              />
            </g>
          </g>
          <polygon
            class="st0"
            points="380.7,386.3 371.2,386.3 401.5,506.2 410.4,505 "
          />
          <path
            class="st0"
            d="M641.9,506c1.4-0.1,2.9-0.3,4.3-0.4c1.4-0.1,2.7-0.5,4-0.9c0.5-0.1,0.9-0.3,1.4-0.4c0,0,0.1,0,0.1-0.1
	c0,0,0-0.1,0-0.1c0.1-0.5,0.2-1,0.3-1.4c0.1-0.4,0.2-0.9,0.3-1.3c0.1-0.6,0.3-1.1,0.4-1.7c0.2-0.7,0.3-1.3,0.5-2
	c0.2-0.8,0.3-1.6,0.5-2.3c0.2-0.9,0.4-1.8,0.6-2.6c0.2-1,0.4-1.9,0.7-2.9c0.2-1.1,0.5-2.1,0.7-3.2c0.3-1.1,0.5-2.3,0.8-3.4
	c0.3-1.2,0.5-2.4,0.8-3.6c0.3-1.3,0.6-2.5,0.8-3.8c0.3-1.3,0.6-2.6,0.9-3.9c0.3-1.4,0.6-2.7,0.9-4.1c0.3-1.4,0.6-2.8,0.9-4.2
	c0.3-1.4,0.6-2.9,1-4.3c0.3-1.5,0.7-2.9,1-4.4c0.3-1.5,0.7-2.9,1-4.4c0.3-1.5,0.7-3,1-4.4c0.3-1.5,0.7-3,1-4.5c0.3-1.5,0.7-3,1-4.4
	c0.3-1.5,0.7-2.9,1-4.4c0.3-1.4,0.6-2.9,1-4.3c0.3-1.4,0.6-2.8,1-4.3c0.3-1.4,0.6-2.8,0.9-4.1c0.3-1.3,0.6-2.7,0.9-4
	c0.3-1.3,0.6-2.6,0.9-3.9c0.3-1.2,0.5-2.5,0.8-3.7c0.3-1.2,0.5-2.3,0.8-3.5c0.2-1.1,0.5-2.2,0.7-3.3c0.2-1,0.5-2,0.7-3
	c0.2-0.9,0.4-1.8,0.6-2.8c0.2-0.8,0.4-1.7,0.6-2.5c0.2-0.7,0.3-1.4,0.5-2.2c0.1-0.6,0.3-1.2,0.4-1.8c0.1-0.5,0.2-1,0.3-1.5
	c0.1-0.4,0.2-0.7,0.2-1.1c0.1-0.2,0.1-0.5,0.2-0.7c0-0.1,0-0.2,0.1-0.3h-7.9c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.4-0.1,0.6
	c-0.1,0.3-0.2,0.7-0.2,1c-0.1,0.4-0.2,0.9-0.3,1.3c-0.1,0.6-0.3,1.1-0.4,1.7c-0.2,0.7-0.3,1.3-0.5,2c-0.2,0.8-0.4,1.5-0.5,2.3
	c-0.2,0.9-0.4,1.7-0.6,2.6c-0.2,0.9-0.4,1.9-0.7,2.8c-0.2,1-0.5,2-0.7,3.1c-0.3,1.1-0.5,2.2-0.8,3.3c-0.3,1.2-0.5,2.3-0.8,3.5
	c-0.3,1.2-0.6,2.4-0.9,3.6c-0.3,1.3-0.6,2.5-0.9,3.8c-0.3,1.3-0.6,2.6-0.9,3.9c-0.3,1.3-0.6,2.7-1,4c-0.3,1.4-0.7,2.8-1,4.1
	c-0.3,1.4-0.7,2.8-1,4.2c-0.3,1.4-0.7,2.9-1,4.3c-0.3,1.4-0.7,2.9-1,4.3c-0.3,1.4-0.7,2.9-1,4.3c-0.3,1.4-0.7,2.9-1,4.3
	c-0.3,1.4-0.7,2.9-1,4.3c-0.3,1.4-0.7,2.8-1,4.3c-0.3,1.4-0.7,2.8-1,4.2c-0.3,1.4-0.6,2.7-1,4.1c-0.3,1.3-0.6,2.7-0.9,4
	c-0.3,1.3-0.6,2.6-0.9,3.9c-0.3,1.2-0.6,2.5-0.9,3.7c-0.3,1.2-0.6,2.4-0.8,3.6c-0.3,1.1-0.5,2.3-0.8,3.4c-0.3,1.1-0.5,2.1-0.8,3.2
	c-0.2,1-0.5,2-0.7,3c-0.2,0.9-0.4,1.8-0.6,2.7c-0.2,0.8-0.4,1.6-0.6,2.5c-0.2,0.7-0.3,1.4-0.5,2.2c-0.1,0.6-0.3,1.2-0.4,1.9
	c-0.1,0.5-0.2,1-0.4,1.5c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.3-0.1,0.6-0.2,0.8C642,505.7,642,505.8,641.9,506z"
          />
          <g class={`${this.addClassName("svg_TrunckCover_Spoiler")}`}>
            <path
              style={{ fill: this.fillColor("svg_TrunckCover_Spoiler") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_TrunckCover_Spoiler")}
              class="st4"
              d="M523.8,861L523.8,861c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8l0,0
		C536.6,855.3,530.9,861,523.8,861z"
            />
            <g>
              <path
                d="M522.6,850c0,0.5-0.1,0.9-0.3,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.3-1.6,0.3
			c-0.6,0-1.1-0.1-1.6-0.2c-0.5-0.1-0.9-0.3-1.3-0.4v-1.4h0.1c0.4,0.2,0.8,0.4,1.3,0.6c0.5,0.2,1,0.2,1.5,0.2c0.3,0,0.6,0,0.9-0.1
			c0.3-0.1,0.6-0.2,0.8-0.5c0.2-0.2,0.3-0.4,0.5-0.7c0.1-0.3,0.2-0.6,0.2-0.9c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6
			c-0.2-0.2-0.5-0.3-0.9-0.4c-0.3-0.1-0.7-0.1-1.1-0.1c-0.4,0-0.8,0-1.2,0.1c-0.4,0.1-0.7,0.1-1,0.2v-5.2h6.1v1.2h-4.8v2.7
			c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.5,0c0.5,0,1,0,1.4,0.1c0.4,0.1,0.8,0.3,1.1,0.5c0.4,0.2,0.6,0.6,0.8,1
			C522.5,849,522.6,849.5,522.6,850z"
              />
              <path
                d="M531.6,850.4c0,0.9-0.3,1.6-1,2.2c-0.7,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8c-0.7-0.6-1-1.3-1-2.2
			c0-0.6,0.2-1.1,0.5-1.5c0.3-0.5,0.8-0.8,1.4-1.1v0c-0.5-0.3-0.9-0.6-1.2-1c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.8,0.3-1.4,0.9-1.9
			s1.4-0.8,2.4-0.8c1,0,1.8,0.2,2.4,0.7c0.6,0.5,0.9,1.1,0.9,1.8c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.7,0.8-1.3,1v0
			c0.6,0.3,1.1,0.6,1.5,1S531.6,849.8,531.6,850.4z M530.2,850.6c0-0.4-0.1-0.8-0.3-1c-0.2-0.3-0.5-0.5-1.1-0.8
			c-0.2-0.1-0.4-0.2-0.7-0.3s-0.6-0.2-1-0.4c-0.4,0.2-0.7,0.5-1,0.9c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.6,0.2,1.1,0.6,1.5
			c0.4,0.4,1,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.5C530,851.6,530.2,851.2,530.2,850.6z M530,845.5c0-0.5-0.2-0.9-0.6-1.2
			c-0.4-0.3-0.9-0.4-1.4-0.4c-0.6,0-1,0.1-1.4,0.4c-0.4,0.3-0.5,0.6-0.5,1.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.4-0.3,0.8-0.6,0.9-0.9C529.9,846.3,530,845.9,530,845.5z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RearWindshield")}`}>
            <path
              style={{ fill: this.fillColor("svg_RearWindshield") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RearWindshield")}
              class="st4"
              d="M523.7,932.2L523.7,932.2c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8
		l0,0C536.5,926.4,530.7,932.2,523.7,932.2z"
            />
            <g>
              <path
                d="M522.9,921.1c0,1-0.3,1.9-1,2.5c-0.7,0.6-1.5,1-2.5,1c-0.5,0-1-0.1-1.4-0.2c-0.4-0.2-0.8-0.4-1.1-0.7
			c-0.4-0.4-0.7-0.9-0.9-1.5c-0.2-0.6-0.3-1.4-0.3-2.2c0-0.9,0.1-1.7,0.3-2.4c0.2-0.7,0.5-1.3,0.9-1.8c0.4-0.5,0.9-0.9,1.5-1.2
			c0.6-0.3,1.4-0.4,2.2-0.4c0.3,0,0.5,0,0.7,0c0.2,0,0.4,0.1,0.6,0.1v1.3h-0.1c-0.1-0.1-0.3-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.8-0.1
			c-1,0-1.8,0.3-2.3,0.9c-0.6,0.6-0.9,1.4-1,2.5c0.4-0.2,0.8-0.4,1.1-0.5c0.4-0.1,0.8-0.2,1.3-0.2c0.4,0,0.8,0,1.1,0.1
			c0.3,0.1,0.7,0.2,1,0.5c0.4,0.3,0.7,0.6,0.9,1C522.8,920,522.9,920.5,522.9,921.1z M521.5,921.2c0-0.4-0.1-0.8-0.2-1
			c-0.1-0.3-0.3-0.5-0.6-0.7c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3,0-0.5-0.1-0.8-0.1c-0.4,0-0.7,0-1.1,0.1c-0.3,0.1-0.7,0.2-1,0.4
			c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.7,0.1,1.3,0.2,1.7c0.1,0.4,0.3,0.7,0.6,1c0.2,0.2,0.4,0.3,0.7,0.4
			c0.2,0.1,0.5,0.1,0.8,0.1c0.7,0,1.2-0.2,1.5-0.6C521.3,922.5,521.5,921.9,521.5,921.2z"
              />
              <path
                d="M531.6,919.4c0,1.8-0.3,3.1-0.9,4c-0.6,0.8-1.5,1.3-2.6,1.3c-1.2,0-2.1-0.4-2.7-1.3c-0.6-0.9-0.8-2.2-0.8-4
			c0-1.8,0.3-3.1,0.8-4c0.6-0.9,1.4-1.3,2.6-1.3c1.2,0,2.1,0.4,2.7,1.3C531.3,916.3,531.6,917.6,531.6,919.4z M529.8,922.4
			c0.2-0.4,0.3-0.8,0.3-1.3c0.1-0.5,0.1-1.1,0.1-1.8c0-0.7,0-1.3-0.1-1.8c-0.1-0.5-0.2-0.9-0.3-1.3c-0.2-0.3-0.4-0.6-0.6-0.8
			c-0.3-0.2-0.6-0.3-1.1-0.3c-0.4,0-0.8,0.1-1.1,0.3c-0.3,0.2-0.5,0.4-0.7,0.8c-0.2,0.3-0.3,0.8-0.3,1.3c-0.1,0.5-0.1,1.1-0.1,1.8
			c0,0.7,0,1.3,0.1,1.8c0,0.5,0.2,0.9,0.3,1.3c0.1,0.4,0.4,0.6,0.6,0.8c0.3,0.2,0.6,0.3,1.1,0.3c0.4,0,0.8-0.1,1.1-0.3
			C529.4,923.1,529.7,922.8,529.8,922.4z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_TailLightInnerL")}`}>
            <path
              style={{ fill: this.fillColor("svg_TailLightInnerL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_TailLightInnerL")}
              class="st4"
              d="M385.7,1045L385.7,1045c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8l0,0c7.1,0,12.8,5.7,12.8,12.8v0
		C398.5,1039.3,392.7,1045,385.7,1045z"
            />
            <g>
              <path
                d="M384.8,1034c0,1-0.3,1.9-1,2.5c-0.7,0.6-1.5,1-2.5,1c-0.5,0-1-0.1-1.4-0.2c-0.4-0.2-0.8-0.4-1.1-0.7
			c-0.4-0.4-0.7-0.9-0.9-1.5c-0.2-0.6-0.3-1.4-0.3-2.2c0-0.9,0.1-1.7,0.3-2.4c0.2-0.7,0.5-1.3,0.9-1.8c0.4-0.5,0.9-0.9,1.5-1.2
			c0.6-0.3,1.4-0.4,2.2-0.4c0.3,0,0.5,0,0.7,0c0.2,0,0.4,0.1,0.6,0.1v1.3h-0.1c-0.1-0.1-0.3-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.8-0.1
			c-1,0-1.8,0.3-2.3,0.9c-0.6,0.6-0.9,1.4-1,2.5c0.4-0.2,0.8-0.4,1.1-0.5c0.4-0.1,0.8-0.2,1.3-0.2c0.4,0,0.8,0,1.1,0.1
			c0.3,0.1,0.7,0.2,1,0.5c0.4,0.3,0.7,0.6,0.9,1C384.7,1032.9,384.8,1033.4,384.8,1034z M383.4,1034c0-0.4-0.1-0.8-0.2-1
			c-0.1-0.3-0.3-0.5-0.6-0.7c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3,0-0.5-0.1-0.8-0.1c-0.4,0-0.7,0-1.1,0.1c-0.3,0.1-0.7,0.2-1,0.4
			c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.7,0.1,1.3,0.2,1.7c0.1,0.4,0.3,0.7,0.6,1c0.2,0.2,0.4,0.3,0.7,0.4
			c0.2,0.1,0.5,0.1,0.8,0.1c0.7,0,1.2-0.2,1.5-0.6C383.2,1035.4,383.4,1034.8,383.4,1034z"
              />
              <path d="M393.7,1034.4h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V1034.4z M390.9,1033.3v-4.6l-3.9,4.6H390.9z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_TailLightInnerR")}`}>
            <path
              style={{ fill: this.fillColor("svg_TailLightInnerR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_TailLightInnerR")}
              class="st4"
              d="M661.3,1045L661.3,1045c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8l0,0c7.1,0,12.8,5.7,12.8,12.8v0
		C674.1,1039.3,668.4,1045,661.3,1045z"
            />
            <g>
              <path
                d="M660.6,1034c0,1-0.3,1.9-1,2.5c-0.7,0.6-1.5,1-2.5,1c-0.5,0-1-0.1-1.4-0.2c-0.4-0.2-0.8-0.4-1.1-0.7
			c-0.4-0.4-0.7-0.9-0.9-1.5c-0.2-0.6-0.3-1.4-0.3-2.2c0-0.9,0.1-1.7,0.3-2.4c0.2-0.7,0.5-1.3,0.9-1.8c0.4-0.5,0.9-0.9,1.5-1.2
			c0.6-0.3,1.4-0.4,2.2-0.4c0.3,0,0.5,0,0.7,0c0.2,0,0.4,0.1,0.6,0.1v1.3h-0.1c-0.1-0.1-0.3-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.8-0.1
			c-1,0-1.8,0.3-2.3,0.9c-0.6,0.6-0.9,1.4-1,2.5c0.4-0.2,0.8-0.4,1.1-0.5c0.4-0.1,0.8-0.2,1.3-0.2c0.4,0,0.8,0,1.1,0.1
			c0.3,0.1,0.7,0.2,1,0.5c0.4,0.3,0.7,0.6,0.9,1C660.5,1032.9,660.6,1033.4,660.6,1034z M659.2,1034c0-0.4-0.1-0.8-0.2-1
			c-0.1-0.3-0.3-0.5-0.6-0.7c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3,0-0.5-0.1-0.8-0.1c-0.4,0-0.7,0-1.1,0.1c-0.3,0.1-0.7,0.2-1,0.4
			c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.7,0.1,1.3,0.2,1.7c0.1,0.4,0.3,0.7,0.6,1c0.2,0.2,0.4,0.3,0.7,0.4
			c0.2,0.1,0.5,0.1,0.8,0.1c0.7,0,1.2-0.2,1.5-0.6C659,1035.4,659.2,1034.8,659.2,1034z"
              />
              <path
                d="M669.2,1034c0,0.5-0.1,0.9-0.3,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.3-1.6,0.3
			c-0.6,0-1.1-0.1-1.6-0.2c-0.5-0.1-0.9-0.3-1.3-0.4v-1.4h0.1c0.4,0.2,0.8,0.4,1.3,0.6c0.5,0.2,1,0.2,1.5,0.2c0.3,0,0.6,0,0.9-0.1
			c0.3-0.1,0.6-0.2,0.8-0.5c0.2-0.2,0.3-0.4,0.5-0.7c0.1-0.3,0.2-0.6,0.2-0.9c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6
			c-0.2-0.2-0.5-0.3-0.9-0.4c-0.3-0.1-0.7-0.1-1.1-0.1c-0.4,0-0.8,0-1.2,0.1c-0.4,0.1-0.7,0.1-1,0.2v-5.2h6.1v1.2h-4.8v2.7
			c0.2,0,0.4,0,0.6,0s0.4,0,0.5,0c0.5,0,1,0,1.4,0.1c0.4,0.1,0.8,0.3,1.1,0.5c0.4,0.2,0.6,0.6,0.8,1
			C669.1,1033,669.2,1033.4,669.2,1034z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M573.1,775.5h-98.5c-1.4,0-2.5-1.1-2.5-2.5v-59.2c0-1.4,1.1-2.5,2.5-2.5h98.5c1.4,0,2.5,1.1,2.5,2.5V773
	C575.6,774.4,574.5,775.5,573.1,775.5z"
          />
          <g class={`${this.addClassName("svg_SunRoof")}`}>
            <path
              style={{ fill: this.fillColor("svg_SunRoof") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_SunRoof")}
              class="st4"
              d="M523.8,756.2L523.8,756.2c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8
		l0,0C536.6,750.5,530.9,756.2,523.8,756.2z"
            />
            <g>
              <path
                d="M522.5,745.1c0,0.5-0.1,0.9-0.3,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.3-1.6,0.3
			c-0.6,0-1.1-0.1-1.6-0.2c-0.5-0.1-0.9-0.3-1.3-0.4v-1.4h0.1c0.4,0.2,0.8,0.4,1.3,0.6c0.5,0.2,1,0.2,1.5,0.2c0.3,0,0.6,0,0.9-0.1
			c0.3-0.1,0.6-0.2,0.8-0.5c0.2-0.2,0.3-0.4,0.5-0.7c0.1-0.3,0.2-0.6,0.2-0.9c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6
			c-0.2-0.2-0.5-0.3-0.9-0.4c-0.3-0.1-0.7-0.1-1.1-0.1c-0.4,0-0.8,0-1.2,0.1c-0.4,0.1-0.7,0.1-1,0.2v-5.2h6.1v1.2h-4.8v2.7
			c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.5,0c0.5,0,1,0,1.4,0.1c0.4,0.1,0.8,0.3,1.1,0.5c0.4,0.2,0.6,0.6,0.8,1S522.5,744.5,522.5,745.1z
			"
              />
              <path d="M531.7,745.5h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V745.5z M528.9,744.4v-4.6l-3.9,4.6H528.9z" />
            </g>
          </g>
          <polygon
            class="st0"
            points="419.5,504.2 413,505 410.4,820.4 416.2,819.7 "
          />
          <polygon
            class="st0"
            points="634.1,821 629.7,820 627.8,505.6 635,506.1 "
          />
          <path
            class="st0"
            d="M563,869.6l0,18.9l-77.7,1.2l0.5-20C485.8,869.6,524.1,874.3,563,869.6z"
          />
          <g class={`${this.addClassName("svg_SideWindowBR")}`}>
            <path
              style={{ fill: this.fillColor("svg_SideWindowBR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_SideWindowBR")}
              class="st4"
              d="M799.4,705.4L799.4,705.4c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8l0,0c7.1,0,12.8,5.7,12.8,12.8
		v0C812.2,699.7,806.5,705.4,799.4,705.4z"
            />
            <g>
              <path
                d="M798.9,694.9c0,0.9-0.3,1.6-1,2.2c-0.7,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8c-0.7-0.6-1-1.3-1-2.2
			c0-0.6,0.2-1.1,0.5-1.5c0.3-0.5,0.8-0.8,1.4-1.1v0c-0.5-0.3-0.9-0.6-1.2-1c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.8,0.3-1.4,0.9-1.9
			c0.6-0.5,1.4-0.8,2.4-0.8c1,0,1.8,0.2,2.4,0.7s0.9,1.1,0.9,1.8c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.7,0.8-1.3,1v0
			c0.6,0.3,1.1,0.6,1.5,1C798.7,693.7,798.9,694.2,798.9,694.9z M797.5,695c0-0.4-0.1-0.8-0.3-1c-0.2-0.3-0.5-0.5-1.1-0.8
			c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3-0.1-0.6-0.2-1-0.4c-0.4,0.2-0.7,0.5-1,0.9c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.6,0.2,1.1,0.6,1.5
			s1,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.5C797.3,696.1,797.5,695.6,797.5,695z M797.3,689.9c0-0.5-0.2-0.9-0.6-1.2
			c-0.4-0.3-0.9-0.4-1.4-0.4c-0.6,0-1,0.1-1.4,0.4c-0.4,0.3-0.5,0.6-0.5,1.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.4-0.3,0.8-0.6,0.9-0.9S797.3,690.3,797.3,689.9z"
              />
              <path
                d="M807.1,697.7h-5.5v-1h2.1v-6.8h-2.1v-0.9c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.5-0.4
			c0.1-0.2,0.2-0.4,0.2-0.7h1.1v9.1h2.1V697.7z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_QuarterWindowBR")}`}>
            <path
              style={{ fill: this.fillColor("svg_QuarterWindowBR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_QuarterWindowBR")}
              class="st4"
              d="M808.1,827.4L808.1,827.4c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8l0,0
		c7.1,0,12.8,5.7,12.8,12.8l0,0C820.9,821.6,815.2,827.4,808.1,827.4z"
            />
            <g>
              <path
                d="M807.2,816.8c0,0.9-0.3,1.6-1,2.2c-0.7,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8c-0.7-0.6-1-1.3-1-2.2
			c0-0.6,0.2-1.1,0.5-1.5c0.3-0.5,0.8-0.8,1.4-1.1v0c-0.5-0.3-0.9-0.6-1.2-1c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.8,0.3-1.4,0.9-1.9
			s1.4-0.8,2.4-0.8c1,0,1.8,0.2,2.4,0.7s0.9,1.1,0.9,1.8c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.7,0.8-1.3,1v0c0.6,0.3,1.1,0.6,1.5,1
			C807,815.7,807.2,816.2,807.2,816.8z M805.8,816.9c0-0.4-0.1-0.8-0.3-1c-0.2-0.3-0.5-0.5-1.1-0.8c-0.2-0.1-0.4-0.2-0.7-0.3
			c-0.3-0.1-0.6-0.2-1-0.4c-0.4,0.2-0.7,0.5-1,0.9c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.6,1.6,0.6
			c0.7,0,1.2-0.2,1.6-0.5C805.6,818,805.8,817.5,805.8,816.9z M805.6,811.9c0-0.5-0.2-0.9-0.6-1.2c-0.4-0.3-0.9-0.4-1.4-0.4
			c-0.6,0-1,0.1-1.4,0.4c-0.4,0.3-0.5,0.6-0.5,1.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6c0.2,0.1,0.4,0.2,0.7,0.3
			c0.3,0.1,0.6,0.2,0.9,0.3c0.4-0.3,0.8-0.6,0.9-0.9C805.5,812.7,805.6,812.3,805.6,811.9z"
              />
              <path d="M816.2,816.8h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V816.8z M813.4,815.7v-4.6l-3.9,4.6H813.4z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_TailLightOuterR")}`}>
            <path
              style={{ fill: this.fillColor("svg_TailLightOuterR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_TailLightOuterR")}
              class="st4"
              d="M858.7,1002.5L858.7,1002.5c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8l0,0
		c7.1,0,12.8,5.7,12.8,12.8v0C871.5,996.8,865.8,1002.5,858.7,1002.5z"
            />
            <g>
              <path
                d="M857.9,991.9c0,0.9-0.3,1.6-1,2.2c-0.7,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8c-0.7-0.6-1-1.3-1-2.2
			c0-0.6,0.2-1.1,0.5-1.5c0.3-0.5,0.8-0.8,1.4-1.1v0c-0.5-0.3-0.9-0.6-1.2-1c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.8,0.3-1.4,0.9-1.9
			s1.4-0.8,2.4-0.8c1,0,1.8,0.2,2.4,0.7s0.9,1.1,0.9,1.8c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.7,0.8-1.3,1v0c0.6,0.3,1.1,0.6,1.5,1
			C857.8,990.8,857.9,991.3,857.9,991.9z M856.5,992.1c0-0.4-0.1-0.8-0.3-1c-0.2-0.3-0.5-0.5-1.1-0.8c-0.2-0.1-0.4-0.2-0.7-0.3
			c-0.3-0.1-0.6-0.2-1-0.4c-0.4,0.2-0.7,0.5-1,0.9c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.6,1.6,0.6
			c0.7,0,1.2-0.2,1.6-0.5C856.3,993.1,856.5,992.6,856.5,992.1z M856.3,987c0-0.5-0.2-0.9-0.6-1.2c-0.4-0.3-0.9-0.4-1.4-0.4
			c-0.6,0-1,0.1-1.4,0.4c-0.4,0.3-0.5,0.6-0.5,1.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6c0.2,0.1,0.4,0.2,0.7,0.3
			c0.3,0.1,0.6,0.2,0.9,0.3c0.4-0.3,0.8-0.6,0.9-0.9C856.2,987.8,856.3,987.4,856.3,987z"
              />
              <path d="M866.7,986.1l-4.6,8.6h-1.5l4.9-8.9h-5.8v-1.2h6.9V986.1z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RearWindshieldDecorTrimR")}`}>
            <path
              style={{ fill: this.fillColor("svg_RearWindshieldDecorTrimR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RearWindshieldDecorTrimR")}
              class="st4"
              d="M775.1,891.4L775.1,891.4c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8l0,0
		c7.1,0,12.8,5.7,12.8,12.8l0,0C787.9,885.7,782.2,891.4,775.1,891.4z"
            />
            <g>
              <path
                d="M774.3,880.9c0,0.9-0.3,1.6-1,2.2c-0.7,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8c-0.7-0.6-1-1.3-1-2.2
			c0-0.6,0.2-1.1,0.5-1.5c0.3-0.5,0.8-0.8,1.4-1.1v0c-0.5-0.3-0.9-0.6-1.2-1c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.8,0.3-1.4,0.9-1.9
			s1.4-0.8,2.4-0.8c1,0,1.8,0.2,2.4,0.7c0.6,0.5,0.9,1.1,0.9,1.8c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.7,0.8-1.3,1v0
			c0.6,0.3,1.1,0.6,1.5,1S774.3,880.3,774.3,880.9z M772.9,881c0-0.4-0.1-0.8-0.3-1c-0.2-0.3-0.5-0.5-1.1-0.8
			c-0.2-0.1-0.4-0.2-0.7-0.3s-0.6-0.2-1-0.4c-0.4,0.2-0.7,0.5-1,0.9c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.6,0.2,1.1,0.6,1.5
			c0.4,0.4,1,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.5C772.7,882.1,772.9,881.6,772.9,881z M772.7,875.9c0-0.5-0.2-0.9-0.6-1.2
			c-0.4-0.3-0.9-0.4-1.4-0.4c-0.6,0-1,0.1-1.4,0.4c-0.4,0.3-0.5,0.6-0.5,1.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.4-0.3,0.8-0.6,0.9-0.9C772.6,876.7,772.7,876.4,772.7,875.9z"
              />
              <path
                d="M783.1,880.9c0,0.9-0.3,1.6-1,2.2c-0.7,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8c-0.7-0.6-1-1.3-1-2.2
			c0-0.6,0.2-1.1,0.5-1.5c0.3-0.5,0.8-0.8,1.4-1.1v0c-0.5-0.3-0.9-0.6-1.2-1c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.8,0.3-1.4,0.9-1.9
			c0.6-0.5,1.4-0.8,2.4-0.8c1,0,1.8,0.2,2.4,0.7c0.6,0.5,0.9,1.1,0.9,1.8c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.7,0.8-1.3,1v0
			c0.6,0.3,1.1,0.6,1.5,1C782.9,879.8,783.1,880.3,783.1,880.9z M781.7,881c0-0.4-0.1-0.8-0.3-1c-0.2-0.3-0.5-0.5-1.1-0.8
			c-0.2-0.1-0.4-0.2-0.7-0.3s-0.6-0.2-1-0.4c-0.4,0.2-0.7,0.5-1,0.9c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.6,0.2,1.1,0.6,1.5
			c0.4,0.4,1,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.5C781.5,882.1,781.7,881.6,781.7,881z M781.5,875.9c0-0.5-0.2-0.9-0.6-1.2
			c-0.4-0.3-0.9-0.4-1.4-0.4c-0.6,0-1,0.1-1.4,0.4c-0.4,0.3-0.5,0.6-0.5,1.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.4-0.3,0.8-0.6,0.9-0.9S781.5,876.4,781.5,875.9z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_SideWindowFR")}`}>
            <path
              style={{ fill: this.fillColor("svg_SideWindowFR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_SideWindowFR")}
              class="st4"
              d="M799.2,549.9L799.2,549.9c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C812,544.1,806.3,549.9,799.2,549.9z"
            />
            <g>
              <path d="M798.2,533.5l-4.6,8.6h-1.5l4.9-8.9h-5.8V532h6.9V533.5z" />
              <path d="M807.2,539.3h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V539.3z M804.4,538.2v-4.6l-3.9,4.6H804.4z" />
            </g>
          </g>
          <path
            class="st0"
            d="M355.7,112.2l-0.2-86.3c0,0,4.5-11.6,9.6-13c5.1-1.4,7.7-2.3,27.1-0.7c0,0,10.7,4.2,10.2,14.3l2.5,39.7l-3.6-1
	c0,0-11.5-5.7-18-7.7c-6.5-2-16.6-1.2-18.9,9.9l1.4,24.2L355.7,112.2z"
          />
          <path
            class="st0"
            d="M690.8,116.3l0.2-90.4c0,0-4.5-11.6-9.6-13s-7.7-2.3-27.1-0.7c0,0-10.7,4.2-10.2,14.3l-2.5,39.7l3.6-1
	c0,0,11.5-5.7,18-7.7c6.5-2,16.6-1.2,18.9,9.9l-1.4,24.2L690.8,116.3z"
          />
          <path class="st1" d="M656,16.2" />
          <path class="st1" d="M656,16.2" />
          <path
            class="st0"
            d="M690.9,120c0,0.6,0,1.3-0.5,1.8c-0.5,0.5-1.3,0.4-2.1,0.3c-3.4-0.5-7-1.6-10.3,0c-2.8,1.4-2.2,4.1-1.9,6.8
	c0.5,4.3,1,8.6,1.6,12.9c0.6,4.4,2.2,9.7,1.9,14.1l-45.5-0.8l-1.8,0l-48.6-0.8l-10-0.2l-50.1-0.2c0,0-0.1,0-0.3,0h-0.3
	c-0.1,0-0.3,0-0.3,0l-50.1,0.2l-10,0.2l-48.6,0.8l-1.8,0l-45.5,0.8c-0.3-4.5,1.3-9.7,1.9-14.1c0.6-4.3,1.1-8.6,1.6-12.9
	c0.3-2.7,1-5.4-1.9-6.8c-3.3-1.6-6.9-0.5-10.3,0c-0.7,0.1-1.6,0.2-2.1-0.3c-0.4-0.4-0.5-1.1-0.5-1.8c0.1-17,5.7-33.8,8.2-50.5
	c0.5-3.2,1-6.6,2.9-9.3c5.1-7.2,16.1-5.5,23.6-5.4c4.6,0.1,9.2,0.2,13.8,0.2c13.6,0.1,27.1,0.2,40.7,0.2c17.3,0,34.6,0,51.8,0
	c8.9,0,17.8,0,26.7-0.1c8.9,0,17.8,0.1,26.7,0.1c17.3,0,34.5,0.1,51.8,0c13.5,0,27.1-0.1,40.7-0.2c4.6,0,9.2-0.1,13.8-0.2
	c7.6-0.2,18.5-1.8,23.6,5.4c1.9,2.7,2.4,6.1,2.9,9.3C685.2,86.2,690.8,103,690.9,120z"
          />
          <g>
            <circle class="st7" cx="378.2" cy="101" r="11.2" />
          </g>
          <path
            class="st0"
            d="M524.7,72.7c8.9,0,17.8,0,26.7,0c32.8,0.1,65.4,0.3,98.2,0.4c2.9,2.6,6.1,5.9,7.4,9.6c0.6,1.7,0.7,3.7-0.2,5.2
	c-1.4,2.4-4.7,3.1-7.2,3.5c-5.8,0.9-33.9,1.4-69.3,1.7c-17.4,0.1-36.5,0.2-55.6,0.3c-29.3-0.1-58.5-0.3-87.8-0.7
	c-11.8-0.2-23.6-0.4-35.4-1.2c-3.6-0.3-8-1.1-9.3-4.5c-1.3-3.3,1.1-6.5,3-9c0.6-0.9,3.3-5,4.6-5c1.1,0,2.2,0,3.3,0
	c11.7,0,23.4-0.1,35.1-0.1c16.5-0.1,32.9-0.1,49.4-0.2C499.9,72.7,512.3,72.7,524.7,72.7z"
          />
          <path
            class="st0"
            d="M524.4,93.3L469,93.1c0,0,0,0.1,0,0.2c0.1,1.1,0.3,6.7,0,12.7c-0.3,6.8,5.5,6.6,5.5,6.6s24.3,0.4,49,0.8h2.4
	c24.7-0.4,49-0.8,49-0.8s5.8,0.2,5.5-6.6c-0.3-6-0.1-11.6,0-12.7c0-0.1,0-0.2,0-0.2L525,93.3H524.4z"
          />
          <path
            class="st0"
            d="M616.3,154.3c0,0-22.2-19.7-16.7-34.1l75.2,1.8c0,0,5.7,0.2,7.2,5.7c0.1,0.5,0.3,1.2,0.4,2s0.3,1.7,0.4,2.9
	c0,0,0,0,0,0.1v0.2c0.4,2.8,3.8,21.5,3.1,22.7l-3.7-0.1l0,0L616.3,154.3z"
          />
          <path
            class="st0"
            d="M524.7,153.6h-0.5l-60.1,0.3l-7.4,0c6.7-27,33.8-33.7,33.8-33.7s15.7,0.2,33.7,0.3h0.5
	c18-0.1,33.7-0.3,33.7-0.3s27.1,6.7,33.8,33.7l-7.4,0L524.7,153.6"
          />
          <path
            class="st0"
            d="M436.6,154.3c0,0,22.2-19.7,16.7-34.1l-75.2,1.8c0,0-5.7,0.2-7.2,5.7c-0.1,0.5-0.3,1.2-0.4,2
	c-0.1,0.8-0.3,1.7-0.4,2.9c0,0,0,0,0,0.1v0.2c-0.4,2.8-3.8,21.5-3.1,22.7l3.7-0.1l0,0L436.6,154.3z"
          />
          <g class={`${this.addClassName("svg_FogLightL")}`}>
            <path
              style={{ fill: this.fillColor("svg_FogLightL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_FogLightL")}
              class="st4"
              d="M378.2,113.8L378.2,113.8c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C391,108,385.3,113.8,378.2,113.8z"
            />
            <g>
              <path
                class="st8"
                d="M376.3,101.2c0.2,0.2,0.4,0.4,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1
			c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.2-1.5,0.2c-0.6,0-1.1-0.1-1.7-0.2c-0.5-0.1-1-0.3-1.3-0.4v-1.4h0.1
			c0.4,0.3,0.8,0.5,1.4,0.6c0.5,0.2,1,0.3,1.5,0.3c0.3,0,0.6,0,0.9-0.1s0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.5-0.7
			c0.1-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.1
			h-0.6V100h0.5c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.3c0-0.2-0.1-0.5-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5
			c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1c-0.4,0-0.9,0.1-1.4,0.2c-0.5,0.2-0.9,0.4-1.4,0.7h-0.1v-1.4
			c0.3-0.2,0.8-0.3,1.3-0.4c0.5-0.1,1.1-0.2,1.6-0.2c0.5,0,0.9,0,1.3,0.1s0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.7,0.8s0.3,0.7,0.3,1.1
			c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.7-1.4,0.8v0.1c0.2,0,0.5,0.1,0.7,0.2C375.9,100.8,376.1,101,376.3,101.2z"
              />
              <path
                class="st8"
                d="M386,100.4c0,0.9-0.1,1.7-0.3,2.4c-0.2,0.7-0.5,1.3-0.9,1.8c-0.4,0.5-0.9,0.9-1.5,1.2
			c-0.6,0.3-1.3,0.4-2.2,0.4c-0.2,0-0.5,0-0.7,0c-0.2,0-0.4-0.1-0.6-0.1v-1.3h0.1c0.1,0.1,0.3,0.1,0.6,0.2c0.2,0.1,0.5,0.1,0.8,0.1
			c1,0,1.8-0.3,2.4-0.9c0.6-0.6,0.9-1.4,1-2.5c-0.4,0.3-0.8,0.4-1.2,0.5c-0.4,0.1-0.8,0.2-1.2,0.2c-0.4,0-0.8,0-1.1-0.1
			c-0.3-0.1-0.7-0.2-1-0.5c-0.4-0.3-0.7-0.6-0.9-1.1c-0.2-0.4-0.3-0.9-0.3-1.5c0-1,0.3-1.9,1-2.5s1.5-1,2.5-1c0.5,0,0.9,0.1,1.4,0.2
			c0.4,0.2,0.8,0.4,1.1,0.7c0.4,0.4,0.7,0.9,0.9,1.5C385.9,98.7,386,99.4,386,100.4z M384.6,100.1c0-0.7-0.1-1.3-0.2-1.7
			c-0.1-0.4-0.3-0.8-0.6-1c-0.2-0.2-0.4-0.4-0.7-0.4c-0.2-0.1-0.5-0.1-0.8-0.1c-0.7,0-1.2,0.2-1.5,0.6c-0.4,0.4-0.6,1-0.6,1.7
			c0,0.4,0.1,0.8,0.2,1.1c0.1,0.3,0.3,0.5,0.6,0.7c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0,0.5,0.1,0.8,0.1c0.4,0,0.7,0,1.1-0.1
			c0.4-0.1,0.7-0.2,1-0.4c0-0.1,0-0.2,0-0.3C384.6,100.3,384.6,100.2,384.6,100.1z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_FogLightR")}`}>
            <path
              style={{ fill: this.fillColor("svg_FogLightR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_FogLightR")}
              class="st4"
              d="M668.8,116L668.8,116c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8l0,0c7.1,0,12.8,5.7,12.8,12.8v0
		C681.6,110.3,675.8,116,668.8,116z"
            />
            <g>
              <path
                class="st8"
                d="M668.3,105.4h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V105.4z M665.5,104.3v-4.6l-3.9,4.6H665.5z"
              />
              <path
                class="st8"
                d="M676.9,103.2c0,1.8-0.3,3.1-0.9,4c-0.6,0.8-1.5,1.3-2.6,1.3c-1.2,0-2.1-0.4-2.7-1.3c-0.6-0.9-0.8-2.2-0.8-4
			c0-1.8,0.3-3.1,0.8-4c0.6-0.9,1.4-1.3,2.6-1.3c1.2,0,2.1,0.4,2.7,1.3C676.6,100.1,676.9,101.4,676.9,103.2z M675.1,106.3
			c0.2-0.4,0.3-0.8,0.3-1.3c0.1-0.5,0.1-1.1,0.1-1.8c0-0.7,0-1.3-0.1-1.8c-0.1-0.5-0.2-0.9-0.3-1.3c-0.2-0.3-0.4-0.6-0.6-0.8
			c-0.3-0.2-0.6-0.3-1.1-0.3c-0.4,0-0.8,0.1-1.1,0.3c-0.3,0.2-0.5,0.4-0.7,0.8c-0.2,0.3-0.3,0.8-0.3,1.3c-0.1,0.5-0.1,1.1-0.1,1.8
			c0,0.7,0,1.3,0.1,1.8c0,0.5,0.2,0.9,0.3,1.3c0.1,0.4,0.4,0.6,0.6,0.8c0.3,0.2,0.6,0.3,1.1,0.3c0.4,0,0.8-0.1,1.1-0.3
			S674.9,106.7,675.1,106.3z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_HeadlightL")}`}>
            <path
              style={{ fill: this.fillColor("svg_HeadlightL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_HeadlightL")}
              class="st4"
              d="M410.5,150.7L410.5,150.7c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C423.3,145,417.6,150.7,410.5,150.7z"
            />
            <g>
              <path
                class="st8"
                d="M410.3,140.2h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V140.2z M407.5,139.1v-4.6l-3.9,4.6H407.5z"
              />
              <path
                class="st8"
                d="M418.4,143h-5.5v-1h2.1v-6.8h-2.1v-0.9c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.5-0.4
			c0.1-0.2,0.2-0.4,0.2-0.7h1.1v9.1h2.1V143z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_HeadlightR")}`}>
            <path
              style={{ fill: this.fillColor("svg_HeadlightR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_HeadlightR")}
              class="st4"
              d="M642.3,150.7L642.3,150.7c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C655.1,145,649.4,150.7,642.3,150.7z"
            />
            <g>
              <path
                class="st8"
                d="M641.9,140.3h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V140.3z M639.1,139.2v-4.6l-3.9,4.6H639.1z"
              />
              <path
                class="st8"
                d="M650.5,143.1h-6.8v-1.4c0.5-0.4,1-0.8,1.4-1.2c0.5-0.4,0.9-0.8,1.3-1.2c0.9-0.8,1.5-1.5,1.8-2
			c0.3-0.5,0.5-1,0.5-1.6c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.3-0.8-0.4-1.5-0.4c-0.4,0-0.9,0.1-1.3,0.2c-0.5,0.1-0.9,0.4-1.4,0.7h-0.1
			v-1.4c0.3-0.2,0.8-0.3,1.3-0.4c0.5-0.1,1.1-0.2,1.6-0.2c1,0,1.8,0.3,2.4,0.8c0.6,0.5,0.9,1.2,0.9,2c0,0.4,0,0.7-0.1,1.1
			c-0.1,0.3-0.2,0.6-0.4,0.9c-0.2,0.3-0.4,0.6-0.6,0.8c-0.2,0.3-0.5,0.6-0.9,0.9c-0.5,0.5-1,0.9-1.5,1.4c-0.5,0.4-1,0.9-1.4,1.2h5.4
			V143.1z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RadiatorGrille")}`}>
            <path
              style={{ fill: this.fillColor("svg_RadiatorGrille") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RadiatorGrille")}
              class="st4"
              d="M524.4,149.9L524.4,149.9c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8l0,0c7.1,0,12.8,5.7,12.8,12.8
		v0C537.3,144.1,531.5,149.9,524.4,149.9z"
            />
            <g>
              <path
                class="st8"
                d="M524,139.3h-1.5v2.8h-1.3v-2.8h-4.8v-1.6l4.9-5.7h1.2v6.2h1.5V139.3z M521.2,138.2v-4.6l-3.9,4.6H521.2z"
              />
              <path
                class="st8"
                d="M531.8,137.3c0.2,0.2,0.4,0.4,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1
			c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.2-1.5,0.2c-0.6,0-1.1-0.1-1.7-0.2c-0.5-0.1-1-0.3-1.3-0.4v-1.4h0.1
			c0.4,0.3,0.8,0.5,1.4,0.6c0.5,0.2,1,0.3,1.5,0.3c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.5-0.7
			c0.1-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.1
			h-0.6v-1.1h0.5c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.3c0-0.2-0.1-0.5-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5
			c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1c-0.4,0-0.9,0.1-1.4,0.2c-0.5,0.2-0.9,0.4-1.4,0.7h-0.1v-1.4
			c0.3-0.2,0.8-0.3,1.3-0.4c0.5-0.1,1.1-0.2,1.6-0.2c0.5,0,0.9,0,1.3,0.1c0.4,0.1,0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.7,0.8
			c0.2,0.3,0.3,0.7,0.3,1.1c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.7-1.4,0.8v0.1c0.2,0,0.5,0.1,0.7,0.2
			C531.3,136.9,531.6,137.1,531.8,137.3z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_OuterLowerDoorWindowSlotSeal_Crom_FL"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor(
                  "svg_OuterLowerDoorWindowSlotSeal_Crom_FL"
                ),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_OuterLowerDoorWindowSlotSeal_Crom_FL")
              }
              class="st0"
              points="228.7,480.6 228.7,514.9 211.5,497.7"
            />
            <g>
              <path
                d="M221.2,501.2h-4.5v-0.9c0.3-0.3,0.6-0.5,0.9-0.8c0.3-0.3,0.6-0.5,0.9-0.8c0.6-0.6,1-1,1.2-1.3c0.2-0.3,0.3-0.7,0.3-1.1
			c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.6,0.2-0.9,0.4h0v-0.9c0.2-0.1,0.5-0.2,0.9-0.3
			c0.4-0.1,0.7-0.1,1-0.1c0.7,0,1.2,0.2,1.6,0.5c0.4,0.3,0.6,0.8,0.6,1.3c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.3,0.6
			c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.2-0.3,0.4-0.6,0.6c-0.3,0.3-0.7,0.6-1,0.9c-0.3,0.3-0.7,0.6-1,0.8h3.6V501.2z"
              />
              <path
                d="M227,501.2h-4.5v-0.9c0.3-0.3,0.6-0.5,0.9-0.8c0.3-0.3,0.6-0.5,0.9-0.8c0.6-0.6,1-1,1.2-1.3c0.2-0.3,0.3-0.7,0.3-1.1
			c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.6,0.2-0.9,0.4h0v-0.9c0.2-0.1,0.5-0.2,0.9-0.3
			c0.4-0.1,0.7-0.1,1-0.1c0.7,0,1.2,0.2,1.6,0.5c0.4,0.3,0.6,0.8,0.6,1.3c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.3,0.6
			c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.2-0.3,0.4-0.6,0.6c-0.3,0.3-0.7,0.6-1,0.9c-0.3,0.3-0.7,0.6-1,0.8h3.6V501.2z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName("svg_UprightOuterDoorCover_PlateFL")}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_UprightOuterDoorCover_PlateFL"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_UprightOuterDoorCover_PlateFL")
              }
              class="st0"
              points="233.4,575.5 267.8,575.5 250.6,592.7"
            />
            <g>
              <path
                d="M249.5,584.3h-4.8v-1c0.3-0.3,0.7-0.6,1-0.9c0.3-0.3,0.6-0.6,0.9-0.9c0.6-0.6,1-1.1,1.3-1.4c0.2-0.3,0.3-0.7,0.3-1.1
			c0-0.4-0.1-0.7-0.4-0.9c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0.1-0.9,0.2s-0.7,0.3-1,0.5h0v-1c0.2-0.1,0.5-0.2,0.9-0.3
			c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.3,0.2,1.7,0.5c0.4,0.4,0.6,0.8,0.6,1.4c0,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.3,0.7
			c-0.1,0.2-0.3,0.4-0.4,0.6c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.7,0.7-1.1,1c-0.4,0.3-0.7,0.6-1,0.9h3.8V584.3z"
              />
              <path
                d="M255.3,584.3h-3.9v-0.7h1.5v-4.8h-1.5v-0.7c0.2,0,0.4,0,0.6-0.1c0.2,0,0.4-0.1,0.5-0.1c0.1-0.1,0.3-0.2,0.3-0.3
			c0.1-0.1,0.1-0.3,0.1-0.5h0.7v6.4h1.5V584.3z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_DoorHandleFL")} `}>
            <polygon
              style={{ fill: this.fillColor("svg_DoorHandleFL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_DoorHandleFL")}
              class="st0"
              points="163.1,587 163.1,552.7 180.3,569.9"
            />
            <g>
              <path
                d="M169.2,573.7h-5v-1c0.3-0.3,0.7-0.6,1.1-0.9c0.4-0.3,0.7-0.6,1-0.9c0.6-0.6,1.1-1.1,1.3-1.5c0.2-0.4,0.4-0.8,0.4-1.2
			c0-0.4-0.1-0.7-0.4-0.9c-0.3-0.2-0.6-0.3-1.1-0.3c-0.3,0-0.6,0.1-1,0.2c-0.4,0.1-0.7,0.3-1,0.5h0v-1c0.2-0.1,0.6-0.2,0.9-0.3
			c0.4-0.1,0.8-0.1,1.1-0.1c0.8,0,1.4,0.2,1.8,0.6c0.4,0.4,0.6,0.9,0.6,1.5c0,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.3,0.7
			c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.4,0.4-0.6,0.7c-0.4,0.3-0.7,0.7-1.1,1c-0.4,0.3-0.7,0.6-1.1,0.9h4V573.7z"
              />
              <path d="M175.9,571.6h-1.1v2.1h-1v-2.1h-3.6v-1.1l3.6-4.2h0.9v4.5h1.1V571.6z M173.8,570.8v-3.4l-2.9,3.4H173.8z" />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_Rocker_RunningPanelBL_DecorStrip"
            )} `}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_Rocker_RunningPanelBL_DecorStrip"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_Rocker_RunningPanelBL_DecorStrip")
              }
              class="st0"
              points="122.7,609.6 122.7,643.9 105.5,626.7"
            />
            <g>
              <path
                d="M114.5,626.8c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.2,0.1,0.4,0.1,0.6c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.4,0.6
			c-0.2,0.2-0.4,0.3-0.7,0.4c-0.3,0.1-0.5,0.1-0.9,0.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.6-0.2-0.8-0.2v-0.8h0.1
			c0.2,0.1,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.1,0.8,0.1c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.4
			c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2,0-0.3,0-0.5,0h-0.3v-0.6
			h0.3c0.4,0,0.7-0.1,0.9-0.2c0.2-0.2,0.3-0.4,0.3-0.7c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.4-0.1
			s-0.3,0-0.4,0c-0.2,0-0.5,0-0.8,0.1c-0.3,0.1-0.5,0.2-0.8,0.4h0v-0.8c0.2-0.1,0.4-0.2,0.7-0.2c0.3-0.1,0.6-0.1,0.9-0.1
			c0.3,0,0.5,0,0.7,0.1s0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.3,0.4,0.4c0.1,0.2,0.1,0.4,0.1,0.6c0,0.3-0.1,0.6-0.3,0.8
			c-0.2,0.2-0.5,0.4-0.8,0.4v0.1c0.1,0,0.3,0.1,0.4,0.1C114.3,626.6,114.4,626.7,114.5,626.8z"
              />
              <path
                d="M120,629.6h-3.9v-0.8c0.3-0.2,0.5-0.5,0.8-0.7c0.3-0.2,0.5-0.5,0.8-0.7c0.5-0.5,0.8-0.9,1-1.1c0.2-0.3,0.3-0.6,0.3-0.9
			c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.5,0-0.8,0.1c-0.3,0.1-0.5,0.2-0.8,0.4h0v-0.8c0.2-0.1,0.4-0.2,0.7-0.2
			c0.3-0.1,0.6-0.1,0.9-0.1c0.6,0,1,0.1,1.4,0.4c0.3,0.3,0.5,0.7,0.5,1.1c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.1,0.4-0.2,0.5
			c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.3,0.3-0.5,0.5c-0.3,0.3-0.6,0.5-0.8,0.8c-0.3,0.3-0.6,0.5-0.8,0.7h3.1V629.6z"
              />
            </g>
          </g>
          <g>
            <g class={`${this.addClassName("svg_FuelTankDoor")}`}>
              <polygon
                style={{ fill: this.fillColor("svg_FuelTankDoor") }}
                onClick={() => !this.props.isDisableClick && this.userClick("svg_FuelTankDoor")}
                class="st0"
                points="227,884.1 227,918.4 209.8,901.3	"
              />
            </g>
            <g>
              <path
                d="M219,901.4c0.1,0.1,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.7c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.5-0.4,0.6
			c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-1,0.1c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1c0.2,0.2,0.5,0.3,0.9,0.4
			c0.3,0.1,0.6,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1s0.4-0.1,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.3,0.1-0.6
			c0-0.2,0-0.4-0.1-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.1-0.5-0.2c-0.2,0-0.4,0-0.6,0h-0.4v-0.7h0.3c0.4,0,0.8-0.1,1-0.3
			c0.3-0.2,0.4-0.4,0.4-0.8c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.3,0-0.5,0
			c-0.3,0-0.6,0-0.9,0.1s-0.6,0.2-0.9,0.4h0v-0.9c0.2-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.7-0.1,1-0.1c0.3,0,0.6,0,0.8,0.1
			c0.2,0.1,0.5,0.1,0.6,0.3c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.4,0.2,0.7c0,0.4-0.1,0.7-0.4,0.9c-0.3,0.3-0.5,0.4-0.9,0.5v0.1
			c0.1,0,0.3,0.1,0.5,0.1C218.7,901.2,218.9,901.3,219,901.4z"
              />
              <path
                d="M225.1,902.4c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.3-0.3,0.5-0.4,0.7c-0.2,0.2-0.5,0.4-0.7,0.5c-0.3,0.1-0.6,0.2-1,0.2
			c-0.3,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1c0.2,0.1,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4
			c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.7,0.1c-0.2,0-0.4,0.1-0.6,0.1v-3.3h3.8v0.7h-3v1.7
			c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.4,0.5,0.6
			C225.1,901.8,225.1,902.1,225.1,902.4z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_FenderTrimPlateBL")} `}>
            <polygon
              style={{ fill: this.fillColor("svg_FenderTrimPlateBL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_FenderTrimPlateBL")}
              points="179.9,810.8 179.9,845.1 162.7,828"
              class="st0"
            />
            <g>
              <path
                d="M172.3,828.1c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.1,0.4,0.1,0.7c0,0.3-0.1,0.5-0.2,0.8c-0.1,0.2-0.2,0.4-0.4,0.6
			c-0.2,0.2-0.5,0.3-0.7,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1
			c0.2,0.2,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.1,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4
			c0.1-0.1,0.1-0.3,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.1-0.2-0.3-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.2c-0.2,0-0.4,0-0.6,0h-0.4v-0.7
			h0.3c0.4,0,0.8-0.1,1-0.3c0.3-0.2,0.4-0.4,0.4-0.8c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.1-0.4-0.1
			c-0.1,0-0.3,0-0.5,0c-0.3,0-0.5,0-0.8,0.1c-0.3,0.1-0.6,0.2-0.8,0.4h0v-0.9c0.2-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.6-0.1,1-0.1
			c0.3,0,0.6,0,0.8,0.1c0.2,0.1,0.4,0.1,0.6,0.3c0.2,0.1,0.4,0.3,0.5,0.5s0.2,0.4,0.2,0.7c0,0.3-0.1,0.6-0.4,0.9
			c-0.2,0.3-0.5,0.4-0.9,0.5v0.1c0.1,0,0.3,0.1,0.5,0.1C172,827.9,172.2,828,172.3,828.1z"
              />
              <path
                d="M178.3,829c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.6-1.5,0.6c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.5-0.2-0.7-0.4
			c-0.2-0.2-0.4-0.5-0.6-0.9c-0.1-0.4-0.2-0.8-0.2-1.4c0-0.5,0.1-1,0.2-1.5c0.1-0.4,0.3-0.8,0.6-1.1c0.2-0.3,0.6-0.6,0.9-0.7
			c0.4-0.2,0.8-0.3,1.3-0.3c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0.1v0.8h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1
			c-0.6,0-1.1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0.2-0.1,0.5-0.2,0.7-0.3c0.2-0.1,0.5-0.1,0.8-0.1c0.3,0,0.5,0,0.7,0.1
			c0.2,0,0.4,0.1,0.6,0.3c0.2,0.2,0.4,0.4,0.6,0.6C178.3,828.4,178.3,828.7,178.3,829z M177.5,829.1c0-0.3,0-0.5-0.1-0.6
			c-0.1-0.2-0.2-0.3-0.4-0.4c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2,0-0.3,0-0.5,0c-0.2,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.1-0.6,0.3
			c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.4,0,0.8,0.1,1c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3
			c0.1,0.1,0.3,0.1,0.5,0.1c0.4,0,0.7-0.1,0.9-0.4C177.4,829.9,177.5,829.5,177.5,829.1z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_FrontBumper")}`}>
            <path
              style={{ fill: this.fillColor("svg_FrontBumper") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_FrontBumper")}
              class="st4"
              d="M524,74.5L524,74.5c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C536.8,68.8,531.1,74.5,524,74.5z"
            />
            <g>
              <path
                d="M516.9,64.2c0-1.3,0.8-2.2,2-2.7l0,0c-1.1-0.5-1.6-1.4-1.6-2.3c0-1.6,1.4-2.7,3.1-2.7c2,0,3,1.2,3,2.5
			c0,0.9-0.4,1.8-1.7,2.4v0c1.3,0.5,2,1.4,2,2.6c0,1.8-1.5,3-3.5,3C518.2,67,516.9,65.7,516.9,64.2z M522.4,64.2
			c0-1.2-0.9-1.8-2.2-2.2c-1.2,0.3-1.8,1.1-1.8,2.1c0,1,0.7,1.9,2,1.9C521.6,66,522.4,65.2,522.4,64.2z M518.6,59.1
			c0,1,0.8,1.6,1.9,1.9c0.9-0.3,1.5-0.9,1.5-1.8c0-0.8-0.5-1.7-1.7-1.7C519.3,57.5,518.6,58.2,518.6,59.1z"
              />
              <path
                d="M525.9,65.8c0.3,0,0.6,0,1.1,0c0.8-0.1,1.5-0.4,2.1-1c0.7-0.6,1.2-1.5,1.3-2.7h0c-0.6,0.7-1.4,1.1-2.4,1.1
			c-1.8,0-3-1.4-3-3.1c0-1.9,1.4-3.6,3.5-3.6c2.1,0,3.4,1.7,3.4,4.3c0,2.2-0.8,3.8-1.8,4.8c-0.8,0.8-1.9,1.2-3,1.4
			c-0.5,0.1-0.9,0.1-1.3,0.1V65.8z M526.4,60c0,1.3,0.8,2.2,2,2.2c0.9,0,1.6-0.5,2-1.1c0.1-0.1,0.1-0.3,0.1-0.5
			c0-1.7-0.6-3.1-2.1-3.1C527.2,57.5,526.4,58.6,526.4,60z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_LeftFrontTyre")}`}>
            <path
              style={{ fill: this.fillColor("svg_LeftFrontTyre") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_LeftFrontTyre")}
              class="st4"
              d="M86.7,291.6L86.7,291.6c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C99.6,285.9,93.8,291.6,86.7,291.6z"
            />
            <g>
              <path
                d="M80.6,282.7c0.3,0,0.6,0,1,0c0.7-0.1,1.5-0.4,2-0.9c0.6-0.6,1.1-1.4,1.3-2.5h0c-0.5,0.6-1.3,1-2.2,1
			c-1.7,0-2.8-1.3-2.8-2.9c0-1.8,1.3-3.4,3.3-3.4c1.9,0,3.1,1.6,3.1,4c0,2.1-0.7,3.6-1.6,4.5c-0.7,0.7-1.7,1.2-2.8,1.3
			c-0.5,0.1-0.9,0.1-1.2,0.1V282.7z M81.1,277.2c0,1.2,0.7,2,1.8,2c0.9,0,1.5-0.4,1.9-1c0.1-0.1,0.1-0.3,0.1-0.5
			c0-1.6-0.6-2.9-1.9-2.9C81.8,274.9,81.1,275.8,81.1,277.2z"
              />
              <path
                d="M93.7,278.7c0,3.2-1.2,5-3.3,5c-1.9,0-3.1-1.7-3.1-4.9c0-3.2,1.4-5,3.3-5C92.6,273.9,93.7,275.7,93.7,278.7z M88.5,278.8
			c0,2.5,0.8,3.9,1.9,3.9c1.3,0,1.9-1.5,1.9-4c0-2.3-0.6-3.9-1.9-3.9C89.3,274.9,88.5,276.3,88.5,278.8z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_LeftBackTyre")}`}>
            <path
              style={{ fill: this.fillColor("svg_LeftBackTyre") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_LeftBackTyre")}
              class="st4"
              d="M87.3,836.2L87.3,836.2c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C100.1,830.5,94.4,836.2,87.3,836.2z"
            />
            <g>
              <path
                d="M82.5,827.1c0.3,0,0.6,0,1,0c0.7-0.1,1.4-0.4,1.9-0.9c0.6-0.5,1-1.3,1.2-2.4h0c-0.5,0.6-1.2,1-2.1,1
			c-1.6,0-2.7-1.2-2.7-2.8c0-1.7,1.2-3.2,3.1-3.2c1.9,0,3,1.5,3,3.8c0,2-0.7,3.4-1.6,4.3c-0.7,0.7-1.7,1.1-2.6,1.2
			c-0.4,0.1-0.8,0.1-1.1,0.1V827.1z M82.9,821.8c0,1.1,0.7,1.9,1.8,1.9c0.8,0,1.5-0.4,1.8-1c0.1-0.1,0.1-0.3,0.1-0.4
			c0-1.6-0.6-2.7-1.9-2.7C83.7,819.6,82.9,820.6,82.9,821.8z"
              />
              <path d="M91.6,820L91.6,820l-1.6,0.9l-0.2-0.9l2-1.1h1.1v9.1h-1.2V820z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_DoorHandleBL")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_DoorHandleBL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_DoorHandleBL")}
              class="st0"
              points="162.7,780.9 162.7,746.6 179.9,763.8"
            />
            <g>
              <path
                d="M169,763.4c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.7c0,0.3-0.1,0.6-0.2,0.8s-0.3,0.5-0.4,0.6
			c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1
			c0.2,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.1,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4
			c0.1-0.2,0.1-0.3,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.1-0.5-0.2c-0.2,0-0.4,0-0.6,0h-0.4v-0.7
			h0.3c0.4,0,0.8-0.1,1-0.3c0.3-0.2,0.4-0.4,0.4-0.8c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.2
			c-0.1,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.6,0.2-0.9,0.4h0v-0.9c0.2-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.7-0.1,1-0.1
			c0.3,0,0.6,0,0.8,0.1s0.4,0.1,0.6,0.3c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.4,0.2,0.7c0,0.4-0.1,0.7-0.4,0.9
			c-0.2,0.3-0.5,0.4-0.9,0.5v0.1c0.1,0,0.3,0.1,0.5,0.1C168.7,763.2,168.8,763.3,169,763.4z"
              />
              <path
                d="M174.7,766.4h-3.4v-0.6h1.3v-4.2h-1.3v-0.6c0.2,0,0.4,0,0.6,0c0.2,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.2,0.3-0.3
			c0.1-0.1,0.1-0.3,0.1-0.4h0.7v5.7h1.3V766.4z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RearWindshieldDecorTrimL")}`}>
            <path
              style={{ fill: this.fillColor("svg_RearWindshieldDecorTrimL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RearWindshieldDecorTrimL")}
              class="st4"
              d="M277.4,891.2L277.4,891.2c-6.9,1.5-13.7-2.9-15.2-9.9v0c-1.5-6.9,2.9-13.7,9.9-15.2h0
		c6.9-1.5,13.7,2.9,15.2,9.9l0,0C288.7,882.9,284.3,889.7,277.4,891.2z"
            />
            <g>
              <path
                d="M272.7,878.8c0.2,0.2,0.4,0.4,0.5,0.7s0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1
			c-0.3,0.3-0.7,0.6-1.2,0.7c-0.5,0.2-1,0.2-1.5,0.2c-0.6,0-1.1-0.1-1.7-0.2c-0.5-0.1-1-0.3-1.3-0.4v-1.4h0.1
			c0.4,0.3,0.8,0.5,1.4,0.6c0.5,0.2,1,0.3,1.5,0.3c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.5-0.7
			c0.1-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.1
			h-0.6v-1.1h0.5c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.3c0-0.2-0.1-0.5-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5
			c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5-0.1-0.8-0.1c-0.4,0-0.9,0.1-1.4,0.2s-0.9,0.4-1.4,0.7h-0.1V874c0.3-0.2,0.8-0.3,1.3-0.4
			c0.5-0.1,1.1-0.2,1.6-0.2c0.5,0,0.9,0,1.3,0.1s0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.7,0.8c0.2,0.3,0.3,0.7,0.3,1.1
			c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.7-1.4,0.8v0.1c0.2,0,0.5,0.1,0.7,0.2C272.3,878.5,272.6,878.7,272.7,878.8z"
              />
              <path
                d="M282.6,880.9c0,0.9-0.3,1.6-1,2.2c-0.7,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8c-0.7-0.6-1-1.3-1-2.2
			c0-0.6,0.2-1.1,0.5-1.5c0.3-0.5,0.8-0.8,1.4-1.1v0c-0.5-0.3-0.9-0.6-1.2-1c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.8,0.3-1.4,0.9-1.9
			c0.6-0.5,1.4-0.8,2.4-0.8c1,0,1.8,0.2,2.4,0.7c0.6,0.5,0.9,1.1,0.9,1.8c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.7,0.8-1.3,1v0
			c0.6,0.3,1.1,0.6,1.5,1S282.6,880.3,282.6,880.9z M281.2,881c0-0.4-0.1-0.8-0.3-1c-0.2-0.3-0.5-0.5-1.1-0.8
			c-0.2-0.1-0.4-0.2-0.7-0.3s-0.6-0.2-1-0.4c-0.4,0.2-0.7,0.5-1,0.9c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.6,0.2,1.1,0.6,1.5
			c0.4,0.4,1,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.5C281,882.1,281.2,881.6,281.2,881z M280.9,875.9c0-0.5-0.2-0.9-0.6-1.2
			c-0.4-0.3-0.9-0.4-1.4-0.4c-0.6,0-1,0.1-1.4,0.4c-0.4,0.3-0.5,0.6-0.5,1.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.4-0.3,0.8-0.6,0.9-0.9C280.9,876.7,280.9,876.4,280.9,875.9z"
              />
            </g>
          </g>
          <g>
            <g class={`${this.addClassName("svg_QuarterWindowTrim_Crom_BL")}`}>
              <polygon
                style={{
                  fill: this.fillColor("svg_QuarterWindowTrim_Crom_BL"),
                }}
                onClick={() => !this.props.isDisableClick && this.userClick("svg_QuarterWindowTrim_Crom_BL")}
                class="st0"
                points="196.5,836.2 196.5,801.9 213.6,819.1	"
              />
            </g>
            <g>
              <path
                d="M202.7,818.6c0.1,0.1,0.2,0.2,0.3,0.4s0.1,0.4,0.1,0.6c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.4,0.5
			c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.7-0.2v-0.8h0.1
			c0.2,0.1,0.5,0.2,0.7,0.3s0.6,0.1,0.8,0.1c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.4
			c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.1-0.2-0.3-0.3c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2,0-0.3,0-0.5,0h-0.3V818
			h0.3c0.4,0,0.7-0.1,0.9-0.2c0.2-0.2,0.3-0.4,0.3-0.7c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1
			c-0.1,0-0.3,0-0.4,0c-0.2,0-0.5,0-0.7,0.1c-0.3,0.1-0.5,0.2-0.7,0.4h0V816c0.2-0.1,0.4-0.2,0.7-0.2c0.3-0.1,0.6-0.1,0.8-0.1
			c0.3,0,0.5,0,0.7,0.1s0.4,0.1,0.5,0.2c0.2,0.1,0.3,0.3,0.4,0.4c0.1,0.2,0.1,0.4,0.1,0.6c0,0.3-0.1,0.6-0.3,0.8
			c-0.2,0.2-0.5,0.4-0.8,0.4v0.1c0.1,0,0.3,0.1,0.4,0.1C202.4,818.5,202.6,818.5,202.7,818.6z"
              />
              <path d="M208,819.7h-0.8v1.5h-0.7v-1.5h-2.6v-0.8l2.6-3.1h0.7v3.3h0.8V819.7z M206.5,819.1v-2.5l-2.1,2.5H206.5z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_WindshieldWiperL_ArmCap")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_WindshieldWiperL_ArmCap") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_WindshieldWiperL_ArmCap")}
              class="st0"
              points="434.1,421.2 399.8,421.2 416.9,404"
            />
            <g>
              <path d="M415.8,416.8h-1v2h-0.9v-2h-3.4v-1.1l3.4-4h0.9v4.3h1V416.8z M413.9,416v-3.2l-2.7,3.2H413.9z" />
              <path d="M421.9,412.8l-3.2,6h-1l3.4-6.2h-4v-0.8h4.8V412.8z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_WindshieldWiperR_ArmCap")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_WindshieldWiperR_ArmCap") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_WindshieldWiperR_ArmCap")}
              class="st0"
              points="587.9,420.8 551.7,420.8 569.8,402.7"
            />
            <g>
              <path d="M569.4,415.6h-1.1v2.1h-1v-2.1h-3.6v-1.2l3.7-4.3h0.9v4.6h1.1V415.6z M567.3,414.8v-3.4l-2.9,3.4H567.3z" />
              <path
                d="M576,415.6c0,0.7-0.3,1.2-0.8,1.6c-0.5,0.4-1.2,0.7-1.9,0.7c-0.8,0-1.5-0.2-2-0.6c-0.5-0.4-0.7-1-0.7-1.6
			c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8v0c-0.4-0.2-0.7-0.5-0.9-0.7c-0.2-0.3-0.3-0.6-0.3-1c0-0.6,0.2-1,0.7-1.4
			c0.5-0.4,1.1-0.6,1.8-0.6c0.8,0,1.4,0.2,1.8,0.5c0.5,0.4,0.7,0.8,0.7,1.4c0,0.3-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.6-0.9,0.8v0
			c0.5,0.2,0.8,0.5,1.1,0.8C575.8,414.8,576,415.1,576,415.6z M574.9,415.7c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.4-0.4-0.8-0.6
			c-0.2-0.1-0.3-0.1-0.5-0.2c-0.2-0.1-0.4-0.2-0.8-0.3c-0.3,0.2-0.6,0.4-0.7,0.7c-0.2,0.3-0.3,0.6-0.3,1c0,0.5,0.2,0.8,0.5,1.1
			c0.3,0.3,0.7,0.4,1.2,0.4c0.5,0,0.9-0.1,1.2-0.4C574.8,416.5,574.9,416.1,574.9,415.7z M574.8,411.9c0-0.4-0.1-0.7-0.4-0.9
			c-0.3-0.2-0.6-0.3-1.1-0.3c-0.4,0-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.8c0,0.2,0.1,0.5,0.2,0.6c0.1,0.2,0.3,0.3,0.6,0.5
			c0.1,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.5,0.2,0.7,0.2c0.3-0.2,0.6-0.5,0.7-0.7C574.7,412.5,574.8,412.2,574.8,411.9z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_WindshieldDecorTrimL")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_WindshieldDecorTrimL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_WindshieldDecorTrimL")}
              class="st0"
              points="420,448 420,482.3 402.9,465.1"
            />
            <g>
              <path
                d="M412.7,466.4c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.7,0.2-1.1,0.2
			c-0.4,0-0.7,0-1.1-0.1c-0.3-0.1-0.6-0.2-0.9-0.3v-1h0.1c0.2,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.7,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4
			c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1c-0.3,0-0.5,0-0.8,0.1c-0.2,0-0.5,0.1-0.6,0.1v-3.5h4.1v0.8h-3.2v1.8
			c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.4,0,0.7,0,1,0.1c0.3,0.1,0.5,0.2,0.8,0.3c0.2,0.2,0.4,0.4,0.6,0.6
			C412.6,465.7,412.7,466,412.7,466.4z"
              />
              <path
                d="M418.7,465.1c0,1.2-0.2,2.1-0.6,2.7c-0.4,0.6-1,0.9-1.8,0.9c-0.8,0-1.4-0.3-1.8-0.9c-0.4-0.6-0.6-1.5-0.6-2.7
			c0-1.2,0.2-2.1,0.6-2.7c0.4-0.6,1-0.9,1.8-0.9c0.8,0,1.4,0.3,1.8,0.9C418.5,463.1,418.7,464,418.7,465.1z M417.5,467.2
			c0.1-0.2,0.2-0.5,0.2-0.9c0-0.3,0.1-0.7,0.1-1.2c0-0.5,0-0.9-0.1-1.2c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.2-0.3-0.4-0.4-0.5
			c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.2-0.2,0.5-0.2,0.9c0,0.4-0.1,0.8-0.1,1.2
			c0,0.5,0,0.9,0.1,1.2c0,0.3,0.1,0.6,0.2,0.9c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0,0.5-0.1,0.7-0.2
			S417.4,467.5,417.5,467.2z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_WindshieldDecorTrimR")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_WindshieldDecorTrimR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_WindshieldDecorTrimR")}
              class="st0"
              points="632,483.3 632,449 649.1,466.1"
            />
            <g>
              <path
                d="M638.2,467c0,0.3,0,0.5-0.1,0.7s-0.2,0.4-0.4,0.6c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.1-0.9,0.1
			c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.1-0.7-0.2v-0.8h0.1c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.3,0,0.5-0.1
			c0.2,0,0.3-0.1,0.4-0.3c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.2-0.3-0.3
			c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0.1-0.5,0.1v-2.9h3.3v0.7h-2.6v1.5
			c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.8,0.1c0.2,0.1,0.4,0.1,0.6,0.3c0.2,0.1,0.4,0.3,0.5,0.5
			C638.2,466.4,638.2,466.6,638.2,467z"
              />
              <path
                d="M642.8,468.7h-3v-0.6h1.2v-3.7h-1.2v-0.5c0.2,0,0.3,0,0.5,0c0.2,0,0.3-0.1,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.2
			c0.1-0.1,0.1-0.2,0.1-0.4h0.6v5h1.1V468.7z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RoofDripMoldingL")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_RoofDripMoldingL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RoofDripMoldingL")}
              class="st0"
              points="455,652.6 455,686.9 437.8,669.7"
            />
            <g>
              <path
                d="M448,669.9c0,0.3-0.1,0.6-0.2,0.9s-0.3,0.5-0.4,0.7c-0.2,0.2-0.5,0.4-0.7,0.5c-0.3,0.1-0.6,0.2-1,0.2c-0.4,0-0.7,0-1-0.1
			c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1c0.2,0.1,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4
			c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.7,0.1c-0.2,0-0.4,0.1-0.6,0.1v-3.3h3.9v0.8h-3v1.7
			c0.1,0,0.3,0,0.4,0s0.2,0,0.3,0c0.3,0,0.7,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.4,0.5,0.6
			C448,669.2,448,669.5,448,669.9z"
              />
              <path
                d="M453.7,671.9h-4.4V671c0.3-0.3,0.6-0.5,0.9-0.8c0.3-0.3,0.6-0.5,0.8-0.8c0.6-0.5,0.9-1,1.1-1.3c0.2-0.3,0.3-0.7,0.3-1
			c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.9-0.3c-0.3,0-0.5,0-0.9,0.1c-0.3,0.1-0.6,0.2-0.9,0.4h0v-0.9c0.2-0.1,0.5-0.2,0.8-0.3
			c0.3-0.1,0.7-0.1,1-0.1c0.7,0,1.2,0.2,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.3,0.6
			c-0.1,0.2-0.2,0.4-0.4,0.5c-0.2,0.2-0.3,0.4-0.6,0.6c-0.3,0.3-0.6,0.6-1,0.9c-0.3,0.3-0.6,0.5-0.9,0.8h3.5V671.9z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RoofDripMoldingR")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_RoofDripMoldingR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RoofDripMoldingR")}
              class="st0"
              points="592.6,686.9 592.6,652.6 609.7,669.7"
            />
            <g>
              <path
                d="M598.7,671c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.7,0.2-1.1,0.2
			c-0.4,0-0.7,0-1.1-0.1c-0.3-0.1-0.6-0.2-0.9-0.3v-1h0.1c0.3,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.7,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4
			c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1c-0.3,0-0.5,0-0.8,0.1c-0.2,0-0.5,0.1-0.6,0.1v-3.5h4.1v0.8h-3.2v1.8
			c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.4,0,0.7,0,1,0.1c0.3,0.1,0.5,0.2,0.8,0.3c0.2,0.2,0.4,0.4,0.6,0.7
			C598.6,670.3,598.7,670.6,598.7,671z"
              />
              <path
                d="M604.1,669.9c0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7
			c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.7,0.2-1,0.2c-0.4,0-0.8,0-1.1-0.1c-0.4-0.1-0.7-0.2-0.9-0.3v-1h0.1c0.3,0.2,0.6,0.3,0.9,0.4
			c0.4,0.1,0.7,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.4,0.1-0.6
			c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.6-0.1h-0.4v-0.8h0.3
			c0.5,0,0.8-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.9c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.2
			s-0.3,0-0.5,0c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.1-0.6,0.3-0.9,0.4h0v-1c0.2-0.1,0.5-0.2,0.9-0.3c0.4-0.1,0.7-0.1,1.1-0.1
			c0.3,0,0.6,0,0.9,0.1s0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.7c0,0.4-0.1,0.7-0.4,1
			c-0.3,0.3-0.6,0.5-0.9,0.5v0.1c0.1,0,0.3,0.1,0.5,0.2C603.8,669.7,604,669.8,604.1,669.9z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RoofRailL")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_RoofRailL") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RoofRailL")}
              class="st0"
              points="391.7,733.9 391.7,699.6 408.9,716.8"
            />
            <g>
              <path
                d="M397.4,718c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.6,0.2-1,0.2
			c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1c0.2,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.6,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4
			c-0.2-0.1-0.3-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.8,0.1c-0.2,0-0.4,0.1-0.6,0.1v-3.4h4v0.8h-3.1v1.8
			c0.1,0,0.3,0,0.4,0s0.2,0,0.3,0c0.4,0,0.7,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.4,0.6,0.6S397.4,717.6,397.4,718z"
              />
              <path
                d="M403.2,718c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.6,0.2-1,0.2
			c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1c0.2,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.6,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4
			c-0.2-0.1-0.3-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.8,0.1c-0.2,0-0.4,0.1-0.6,0.1v-3.4h4v0.8H400v1.8
			c0.1,0,0.3,0,0.4,0s0.2,0,0.3,0c0.4,0,0.7,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.4,0.6,0.6S403.2,717.6,403.2,718z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RoofRailR")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_RoofRailR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RoofRailR")}
              class="st0"
              points="653.6,699.6 653.6,733.9 636.4,716.8"
            />
            <g>
              <path
                d="M645.9,718c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.7,0.2-1.1,0.2
			c-0.4,0-0.7,0-1.1-0.1c-0.3-0.1-0.6-0.2-0.9-0.3v-1h0.1c0.3,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.7,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4
			c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1c-0.3,0-0.5,0-0.8,0.1c-0.2,0-0.5,0.1-0.6,0.1v-3.5h4.1v0.8h-3.2v1.8
			c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.4,0,0.7,0,1,0.1c0.3,0.1,0.5,0.2,0.8,0.3c0.2,0.2,0.4,0.4,0.6,0.7S645.9,717.6,645.9,718z
			"
              />
              <path
                d="M652,717.9c0,0.7-0.2,1.3-0.7,1.7c-0.5,0.4-1,0.7-1.7,0.7c-0.3,0-0.6-0.1-0.9-0.2s-0.5-0.3-0.7-0.5
			c-0.3-0.3-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.6,0.1-1.1,0.2-1.6c0.1-0.5,0.3-0.9,0.6-1.2c0.3-0.3,0.6-0.6,1-0.8
			c0.4-0.2,0.9-0.3,1.5-0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0.1v0.9h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1
			c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.7,1.7c0.3-0.2,0.5-0.3,0.8-0.4c0.2-0.1,0.5-0.1,0.9-0.1c0.3,0,0.5,0,0.8,0.1
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.2,0.5,0.4,0.6,0.7C652,717.2,652,717.5,652,717.9z M651.1,718c0-0.3,0-0.5-0.1-0.7
			c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.3,0-0.5,0c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.5,0.2-0.7,0.3
			c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.5,0,0.9,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.1,0.3,0.2,0.5,0.3
			c0.2,0.1,0.3,0.1,0.5,0.1c0.4,0,0.8-0.1,1-0.4C651,718.9,651.1,718.5,651.1,718z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_Antenna")} `}>
            <polygon
              style={{ fill: this.fillColor("svg_Antenna") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_Antenna")}
              class="st0"
              points="489.2,819.1 489.2,784.8 506.4,801.9"
            />
            <g>
              <path
                d="M495.2,803c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.4,0.3-0.7,0.4c-0.3,0.1-0.6,0.2-1,0.2
			c-0.3,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1c0.2,0.1,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4
			c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.5,0-0.7,0c-0.2,0-0.4,0.1-0.6,0.1v-3.2h3.7v0.7h-2.9v1.6
			c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.3,0.5,0.6
			C495.2,802.4,495.2,802.7,495.2,803z"
              />
              <path d="M500.7,799.8l-2.8,5.2H497l3-5.4h-3.5v-0.7h4.2V799.8z" />
            </g>
          </g>
          <g class={`${this.addClassName("svg_HighMountStopLight")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_HighMountStopLight") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_HighMountStopLight")}
              class="st0"
              points="465.6,905.7 465.6,871.4 482.8,888.6"
            />
            <g>
              <path
                d="M471.6,889.8c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.4,0.3-0.7,0.4c-0.3,0.1-0.6,0.2-0.9,0.2
			c-0.3,0-0.6,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1c0.2,0.1,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.1,0.9,0.1c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.3-0.1,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.3
			c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.5,0-0.7,0c-0.2,0-0.4,0.1-0.6,0.1v-3.1h3.6v0.7h-2.9v1.6
			c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.9,0.1c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.3,0.5,0.6
			C471.5,889.1,471.6,889.4,471.6,889.8z"
              />
              <path
                d="M476.9,888.3c0,0.5-0.1,1-0.2,1.4c-0.1,0.4-0.3,0.8-0.5,1.1c-0.2,0.3-0.6,0.5-0.9,0.7c-0.4,0.2-0.8,0.3-1.3,0.3
			c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3-0.1v-0.8h0c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.3,0.1,0.5,0.1c0.6,0,1.1-0.2,1.4-0.5
			c0.3-0.4,0.5-0.9,0.6-1.5c-0.3,0.2-0.5,0.3-0.7,0.3c-0.2,0.1-0.5,0.1-0.7,0.1c-0.2,0-0.5,0-0.7-0.1c-0.2,0-0.4-0.1-0.6-0.3
			c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.6,0.2-1.1,0.6-1.5c0.4-0.4,0.9-0.6,1.5-0.6c0.3,0,0.6,0,0.8,0.1
			c0.2,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.4,0.5,0.5,0.9C476.9,887.3,476.9,887.7,476.9,888.3z M476.1,888.1c0-0.4,0-0.8-0.1-1
			c-0.1-0.3-0.2-0.5-0.4-0.6c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.3-0.1-0.5-0.1c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.3,0.6-0.3,1
			c0,0.3,0,0.5,0.1,0.6c0.1,0.2,0.2,0.3,0.4,0.4c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0,0.3,0,0.5,0c0.2,0,0.4,0,0.6-0.1s0.4-0.1,0.6-0.2
			c0-0.1,0-0.1,0-0.2C476.1,888.3,476.1,888.2,476.1,888.1z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName("svg_WiperForRearWindshield_ArmCap")}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_WiperForRearWindshield_ArmCap"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_WiperForRearWindshield_ArmCap")
              }
              class="st0"
              points="590.9,934.4 590.9,968.7 573.8,951.6"
            />
            <g>
              <path
                d="M584,952.8c0,0.7-0.2,1.3-0.7,1.7c-0.5,0.5-1,0.7-1.7,0.7c-0.3,0-0.7-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.8-0.5
			c-0.3-0.3-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.9-0.2-1.6c0-0.6,0.1-1.2,0.2-1.7c0.1-0.5,0.3-0.9,0.6-1.3c0.3-0.4,0.6-0.6,1.1-0.8
			c0.4-0.2,0.9-0.3,1.5-0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.3,0,0.4,0.1v0.9h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.4-0.1-0.5-0.1
			c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.7,1.7c0.3-0.2,0.5-0.3,0.8-0.4c0.3-0.1,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.8,0.1
			c0.2,0.1,0.5,0.2,0.7,0.3c0.3,0.2,0.5,0.4,0.6,0.7C583.9,952,584,952.4,584,952.8z M583,952.8c0-0.3,0-0.5-0.1-0.7
			c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.2s-0.4,0-0.6,0c-0.3,0-0.5,0-0.7,0.1s-0.5,0.2-0.7,0.3c0,0.1,0,0.1,0,0.2
			c0,0.1,0,0.1,0,0.2c0,0.5,0.1,0.9,0.2,1.2c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.5,0.1
			c0.5,0,0.8-0.1,1.1-0.4C582.9,953.7,583,953.3,583,952.8z"
              />
              <path
                d="M589.6,955.1h-3.8v-0.7h1.5v-4.7h-1.5V949c0.2,0,0.4,0,0.6,0c0.2,0,0.4-0.1,0.5-0.1c0.1-0.1,0.3-0.2,0.3-0.3
			c0.1-0.1,0.1-0.3,0.1-0.5h0.7v6.3h1.4V955.1z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_TrunkEmblem")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_TrunkEmblem") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_TrunkEmblem")}
              class="st0"
              points="559.2,998.9 559.2,1033.2 542.1,1016.1"
            />
            <g>
              <path
                d="M551.6,1017.6c0,0.7-0.2,1.3-0.7,1.7c-0.5,0.4-1,0.7-1.7,0.7c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.5
			c-0.3-0.3-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.6,0.1-1.1,0.2-1.6c0.1-0.5,0.3-0.9,0.6-1.2c0.3-0.3,0.6-0.6,1-0.8
			c0.4-0.2,0.9-0.3,1.5-0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0.1v0.9h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.4-0.1-0.5-0.1
			c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.7,1.7c0.3-0.2,0.5-0.3,0.8-0.4c0.2-0.1,0.5-0.1,0.9-0.1c0.3,0,0.5,0,0.8,0.1
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.2,0.5,0.4,0.6,0.7C551.6,1016.8,551.6,1017.2,551.6,1017.6z M550.7,1017.6c0-0.3,0-0.5-0.1-0.7
			c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0-0.5,0c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.5,0.2-0.7,0.3
			c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.5,0,0.9,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.1,0.3,0.2,0.5,0.3
			c0.2,0.1,0.3,0.1,0.5,0.1c0.4,0,0.8-0.1,1-0.4C550.6,1018.5,550.7,1018.1,550.7,1017.6z"
              />
              <path
                d="M557.5,1019.8h-4.6v-1c0.3-0.3,0.6-0.6,1-0.8c0.3-0.3,0.6-0.5,0.9-0.8c0.6-0.6,1-1,1.2-1.4c0.2-0.3,0.3-0.7,0.3-1.1
			c0-0.4-0.1-0.6-0.4-0.8c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.6,0.2-1,0.5h0v-1c0.2-0.1,0.5-0.2,0.9-0.3
			c0.4-0.1,0.7-0.1,1.1-0.1c0.7,0,1.3,0.2,1.6,0.5c0.4,0.3,0.6,0.8,0.6,1.4c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.3,0.6
			c-0.1,0.2-0.3,0.4-0.4,0.6c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.7,0.6-1,0.9c-0.3,0.3-0.7,0.6-1,0.8h3.7V1019.8z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_Emblem")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_Emblem") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_Emblem")}
              class="st0"
              points="457.9,1056.7 423.6,1056.7 440.8,1039.5"
            />
            <g>
              <path
                d="M440.2,1051.2c0,0.8-0.3,1.4-0.8,1.9c-0.5,0.5-1.1,0.7-1.9,0.7c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.5
			c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2-0.5-0.2-1-0.2-1.7c0-0.7,0.1-1.3,0.2-1.8c0.1-0.5,0.4-1,0.7-1.4c0.3-0.4,0.7-0.7,1.2-0.9
			c0.5-0.2,1-0.3,1.7-0.3c0.2,0,0.4,0,0.5,0c0.1,0,0.3,0,0.4,0.1v1h-0.1c-0.1-0.1-0.2-0.1-0.4-0.1c-0.2,0-0.4-0.1-0.6-0.1
			c-0.7,0-1.3,0.2-1.8,0.7c-0.4,0.5-0.7,1.1-0.8,1.9c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.6-0.1,1-0.1c0.3,0,0.6,0,0.9,0.1
			c0.2,0.1,0.5,0.2,0.8,0.4c0.3,0.2,0.5,0.5,0.7,0.8C440.2,1050.4,440.2,1050.8,440.2,1051.2z M439.2,1051.3c0-0.3,0-0.6-0.1-0.8
			c-0.1-0.2-0.2-0.4-0.5-0.5c-0.2-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0-0.6,0-0.8,0.1s-0.5,0.2-0.8,0.3
			c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.5,0.1,1,0.2,1.3c0.1,0.3,0.3,0.6,0.5,0.7c0.2,0.2,0.3,0.3,0.5,0.3
			c0.2,0.1,0.4,0.1,0.6,0.1c0.5,0,0.9-0.2,1.2-0.5C439,1052.3,439.2,1051.8,439.2,1051.3z"
              />
              <path
                d="M446.1,1050c0.2,0.1,0.3,0.3,0.4,0.6c0.1,0.2,0.2,0.5,0.2,0.9c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.5-0.5,0.8
			c-0.3,0.2-0.6,0.4-0.9,0.5c-0.3,0.1-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.3-0.2c-0.4-0.1-0.8-0.2-1-0.3v-1.1h0.1
			c0.3,0.2,0.6,0.4,1,0.5s0.8,0.2,1.1,0.2c0.2,0,0.4,0,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.2,0.3-0.3,0.4-0.5
			c0.1-0.2,0.1-0.4,0.1-0.7c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.3-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.7-0.1h-0.5
			v-0.9h0.4c0.5,0,0.9-0.1,1.2-0.3c0.3-0.2,0.5-0.5,0.5-1c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.3c-0.1-0.1-0.3-0.2-0.5-0.2
			c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0-0.7,0.1-1,0.2c-0.4,0.1-0.7,0.3-1,0.5h-0.1v-1.1c0.2-0.1,0.6-0.2,1-0.3c0.4-0.1,0.8-0.2,1.2-0.2
			c0.4,0,0.7,0,1,0.1c0.3,0.1,0.5,0.2,0.8,0.3c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.2,0.2,0.5,0.2,0.8c0,0.4-0.2,0.8-0.5,1.1
			c-0.3,0.3-0.7,0.5-1.1,0.6v0.1c0.2,0,0.4,0.1,0.6,0.2C445.8,1049.8,446,1049.9,446.1,1050z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RightFrontTyre")}`}>
            <path
              style={{ fill: this.fillColor("svg_RightFrontTyre") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RightFrontTyre")}
              class="st4"
              d="M962.8,290.7L962.8,290.7c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8h0c7.1,0,12.8,5.7,12.8,12.8v0
		C975.6,285,969.9,290.7,962.8,290.7z"
            />
            <g>
              <path
                d="M962,277.3c0,0.9-0.1,1.7-0.3,2.4c-0.2,0.7-0.5,1.3-0.9,1.9c-0.4,0.5-0.9,0.9-1.6,1.2s-1.4,0.4-2.2,0.4
			c-0.2,0-0.5,0-0.7,0s-0.4-0.1-0.6-0.1v-1.3h0.1c0.1,0.1,0.3,0.1,0.6,0.2s0.5,0.1,0.8,0.1c1,0,1.8-0.3,2.4-0.9
			c0.6-0.6,0.9-1.4,1-2.5c-0.4,0.3-0.8,0.4-1.2,0.5s-0.8,0.2-1.2,0.2c-0.4,0-0.8,0-1.1-0.1c-0.3-0.1-0.7-0.2-1-0.5
			c-0.4-0.3-0.7-0.6-0.9-1.1c-0.2-0.4-0.3-0.9-0.3-1.5c0-1,0.3-1.9,1-2.5s1.5-1,2.5-1c0.5,0,0.9,0.1,1.4,0.2s0.8,0.4,1.1,0.7
			c0.4,0.4,0.7,0.9,0.9,1.5S962,276.3,962,277.3z M960.6,277c0-0.7-0.1-1.3-0.2-1.7s-0.3-0.8-0.6-1c-0.2-0.2-0.4-0.4-0.7-0.4
			s-0.5-0.1-0.8-0.1c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.7c0,0.4,0.1,0.8,0.2,1.1s0.3,0.5,0.6,0.7c0.2,0.1,0.4,0.2,0.7,0.3
			s0.5,0.1,0.8,0.1c0.4,0,0.7,0,1.1-0.1s0.7-0.2,1-0.4c0-0.1,0-0.2,0-0.3C960.6,277.3,960.6,277.1,960.6,277z"
              />
              <path
                d="M970.9,283H964v-1.4c0.5-0.4,1-0.8,1.4-1.2c0.5-0.4,0.9-0.8,1.3-1.2c0.9-0.8,1.5-1.5,1.8-2s0.5-1,0.5-1.6
			c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.3-0.8-0.4-1.5-0.4c-0.4,0-0.9,0.1-1.3,0.2s-1,0.4-1.4,0.7h-0.1v-1.4c0.3-0.2,0.8-0.3,1.3-0.4
			c0.5-0.1,1.1-0.2,1.6-0.2c1,0,1.9,0.3,2.5,0.8s0.9,1.2,0.9,2c0,0.4,0,0.7-0.1,1.1c-0.1,0.3-0.2,0.7-0.4,1
			c-0.2,0.3-0.4,0.6-0.6,0.8c-0.2,0.3-0.5,0.6-0.9,0.9c-0.5,0.5-1,0.9-1.5,1.4s-1,0.9-1.5,1.2h5.5V283z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_Rocker_RunningPanelFR_DecorStrip"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_Rocker_RunningPanelFR_DecorStrip"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_Rocker_RunningPanelFR_DecorStrip")
              }
              class="st0"
              points="926.3,439.7 926.3,403 944.6,421.4"
            />
            <g>
              <path d="M932.4,418.2l-3.1,5.8h-1l3.3-6h-3.9v-0.8h4.7V418.2z" />
              <path
                d="M938.5,421.8c0,0.7-0.2,1.3-0.7,1.7c-0.5,0.4-1,0.7-1.7,0.7c-0.3,0-0.6-0.1-0.9-0.2s-0.5-0.3-0.7-0.5
			c-0.3-0.3-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.6,0.1-1.1,0.2-1.6c0.1-0.5,0.3-0.9,0.6-1.2c0.3-0.3,0.6-0.6,1-0.8
			c0.4-0.2,0.9-0.3,1.5-0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0.1v0.9h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1
			c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.7,1.7c0.3-0.2,0.5-0.3,0.8-0.4c0.2-0.1,0.5-0.1,0.9-0.1c0.3,0,0.5,0,0.8,0.1
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.2,0.5,0.4,0.6,0.7C938.4,421.1,938.5,421.4,938.5,421.8z M937.5,421.8c0-0.3,0-0.5-0.1-0.7
			c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.2s-0.3,0-0.5,0c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.5,0.2-0.7,0.3
			c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.5,0,0.9,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.1,0.3,0.2,0.5,0.3
			c0.2,0.1,0.3,0.1,0.5,0.1c0.4,0,0.8-0.1,1-0.4C937.4,422.7,937.5,422.4,937.5,421.8z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_SideMirrorRepeaterLampR")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_SideMirrorRepeaterLampR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_SideMirrorRepeaterLampR")}
              class="st0"
              points="863,427.6 863,464.3 844.7,446"
            />
            <g>
              <path d="M855.2,443.2l-3.6,6.7h-1.1l3.8-7h-4.5V442h5.4V443.2z" />
              <path
                d="M862.1,446c0,1.4-0.2,2.5-0.7,3.1c-0.4,0.7-1.1,1-2.1,1c-0.9,0-1.6-0.3-2.1-1c-0.4-0.7-0.7-1.7-0.7-3.1
			c0-1.4,0.2-2.4,0.7-3.1c0.4-0.7,1.1-1,2.1-1c0.9,0,1.6,0.3,2.1,1C861.9,443.6,862.1,444.6,862.1,446z M860.7,448.4
			c0.1-0.3,0.2-0.6,0.3-1c0-0.4,0.1-0.9,0.1-1.4c0-0.5,0-1-0.1-1.4c0-0.4-0.1-0.7-0.3-1c-0.1-0.3-0.3-0.5-0.5-0.6
			c-0.2-0.1-0.5-0.2-0.8-0.2c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,1c0,0.4-0.1,0.9-0.1,1.4
			c0,0.6,0,1,0.1,1.4c0,0.4,0.1,0.7,0.2,1c0.1,0.3,0.3,0.5,0.5,0.6c0.2,0.1,0.5,0.2,0.9,0.2c0.3,0,0.6-0.1,0.8-0.2
			C860.4,448.9,860.6,448.6,860.7,448.4z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_OuterUpperDoorWindowTrim_Crom_FR"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_OuterUpperDoorWindowTrim_Crom_FR"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_OuterUpperDoorWindowTrim_Crom_FR")
              }
              class="st0"
              points="812.3,459.1 812.3,495.7 794,477.4"
            />
            <g>
              <path d="M804.9,474.7l-3.6,6.8h-1.1l3.8-7h-4.5v-0.9h5.4V474.7z" />
              <path
                d="M811.4,481.4h-4.3v-0.8h1.7v-5.3h-1.7v-0.7c0.2,0,0.5,0,0.7-0.1c0.3,0,0.5-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.3
			c0.1-0.1,0.1-0.3,0.2-0.6h0.8v7.2h1.6V481.4z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_OuterLowerDoorWindowSlotSeal_Crom_FR"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor(
                  "svg_OuterLowerDoorWindowSlotSeal_Crom_FR"
                ),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_OuterLowerDoorWindowSlotSeal_Crom_FR")
              }
              class="st0"
              points="820.1,523.1 820.1,486.4 838.4,504.8"
            />
            <g>
              <path d="M826.7,501.3l-3.7,7h-1.2l4-7.3h-4.7v-1h5.6V501.3z" />
              <path
                d="M833.2,504.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.2,0.6,0.2,0.9c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8
			c-0.3,0.3-0.6,0.4-1,0.6c-0.4,0.1-0.8,0.2-1.2,0.2c-0.5,0-0.9-0.1-1.4-0.2c-0.4-0.1-0.8-0.2-1.1-0.4v-1.2h0.1
			c0.3,0.2,0.7,0.4,1.1,0.5c0.4,0.1,0.8,0.2,1.2,0.2c0.2,0,0.5,0,0.7-0.1c0.3-0.1,0.5-0.2,0.6-0.3c0.2-0.2,0.3-0.3,0.4-0.5
			c0.1-0.2,0.1-0.4,0.1-0.7c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.2-0.3-0.4-0.5c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1h-0.5
			v-0.9h0.4c0.6,0,1-0.1,1.3-0.4c0.3-0.2,0.5-0.6,0.5-1c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.3-0.2-0.5-0.2
			s-0.4-0.1-0.6-0.1c-0.4,0-0.7,0.1-1.1,0.2c-0.4,0.1-0.8,0.3-1.1,0.5h-0.1v-1.2c0.3-0.1,0.6-0.2,1.1-0.4c0.4-0.1,0.9-0.2,1.3-0.2
			c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.6,0.2,0.8,0.4c0.3,0.2,0.5,0.4,0.6,0.6c0.1,0.3,0.2,0.5,0.2,0.9c0,0.5-0.2,0.9-0.5,1.2
			c-0.3,0.3-0.7,0.6-1.1,0.6v0.1c0.2,0,0.4,0.1,0.6,0.2C832.8,504.1,833,504.3,833.2,504.4z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName("svg_UprightOuterDoorCover_PlateFR")}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_UprightOuterDoorCover_PlateFR"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_UprightOuterDoorCover_PlateFR")
              }
              class="st0"
              points="766.4,578.7 803.1,578.7 784.7,597.1"
            />
            <g>
              <path d="M784,581.5l-3.8,7.2h-1.2l4.1-7.4h-4.8v-1h5.8V581.5z" />
              <path
                d="M791.3,588.7h-5.7v-1.2c0.4-0.3,0.8-0.7,1.2-1c0.4-0.3,0.8-0.7,1.1-1c0.7-0.7,1.2-1.3,1.5-1.7c0.3-0.4,0.4-0.9,0.4-1.3
			c0-0.4-0.1-0.8-0.4-1c-0.3-0.2-0.7-0.4-1.2-0.4c-0.3,0-0.7,0.1-1.1,0.2c-0.4,0.1-0.8,0.3-1.2,0.6h-0.1v-1.2
			c0.3-0.1,0.6-0.3,1.1-0.4c0.4-0.1,0.9-0.2,1.3-0.2c0.9,0,1.5,0.2,2,0.6c0.5,0.4,0.7,1,0.7,1.7c0,0.3,0,0.6-0.1,0.9
			c-0.1,0.3-0.2,0.5-0.4,0.8c-0.1,0.2-0.3,0.5-0.5,0.7c-0.2,0.2-0.4,0.5-0.7,0.8c-0.4,0.4-0.8,0.8-1.2,1.1c-0.4,0.4-0.8,0.7-1.2,1
			h4.5V588.7z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_DoorHandleFR")}`}>
            <polygon
              style={{ fill: this.fillColor("svg_DoorHandleFR") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_DoorHandleFR")}
              class="st0"
              points="887.5,547.6 887.5,584.3 869.2,566"
            />
            <g>
              <path d="M879.9,563.3l-3.3,6.3h-1.1l3.6-6.5h-4.2v-0.9h5.1V563.3z" />
              <path
                d="M886.3,567.3c0,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.9,0.5c-0.3,0.1-0.7,0.2-1.1,0.2
			c-0.4,0-0.8,0-1.2-0.1c-0.4-0.1-0.7-0.2-0.9-0.3v-1h0.1c0.3,0.2,0.6,0.3,1,0.4c0.4,0.1,0.7,0.2,1.1,0.2c0.2,0,0.5,0,0.7-0.1
			c0.2-0.1,0.4-0.2,0.6-0.3c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.7c0-0.3,0-0.5-0.1-0.6c-0.1-0.2-0.2-0.3-0.4-0.4
			c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.5-0.1-0.8-0.1c-0.3,0-0.6,0-0.8,0.1c-0.3,0-0.5,0.1-0.7,0.1v-3.8h4.4v0.9h-3.5v2
			c0.1,0,0.3,0,0.4,0s0.3,0,0.4,0c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.6,0.2,0.8,0.4c0.3,0.2,0.5,0.4,0.6,0.7
			C886.2,566.5,886.3,566.8,886.3,567.3z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_Rocker_RunningPanelBR_DecorStrip"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_Rocker_RunningPanelBR_DecorStrip"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_Rocker_RunningPanelBR_DecorStrip")
              }
              class="st0"
              points="924.9,646.6 924.9,610 943.2,628.3"
            />
            <g>
              <path
                d="M932,630c0,0.7-0.3,1.2-0.8,1.7c-0.5,0.5-1.2,0.7-2,0.7c-0.9,0-1.5-0.2-2-0.7c-0.5-0.4-0.8-1-0.8-1.7
			c0-0.4,0.1-0.8,0.4-1.2c0.3-0.4,0.6-0.6,1.1-0.8v0c-0.4-0.2-0.7-0.5-0.9-0.7c-0.2-0.3-0.3-0.6-0.3-1c0-0.6,0.2-1.1,0.7-1.5
			s1.1-0.6,1.9-0.6c0.8,0,1.4,0.2,1.9,0.6s0.7,0.9,0.7,1.4c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.6-1,0.8v0c0.5,0.2,0.9,0.5,1.1,0.8
			C931.8,629.1,932,629.5,932,630z M930.9,630.1c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.4-0.4-0.8-0.6c-0.2-0.1-0.3-0.1-0.5-0.2
			c-0.2-0.1-0.5-0.2-0.8-0.3c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,1c0,0.5,0.2,0.9,0.5,1.2c0.3,0.3,0.7,0.5,1.2,0.5
			c0.5,0,0.9-0.1,1.2-0.4C930.7,630.9,930.9,630.6,930.9,630.1z M930.7,626.2c0-0.4-0.1-0.7-0.4-0.9c-0.3-0.2-0.7-0.3-1.1-0.3
			c-0.4,0-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.9c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.4,0.3,0.6,0.5c0.1,0.1,0.3,0.1,0.6,0.2
			c0.2,0.1,0.5,0.2,0.7,0.3c0.3-0.2,0.6-0.5,0.7-0.7C930.7,626.8,930.7,626.5,930.7,626.2z"
              />
              <path
                d="M938.1,628.4c0.2,0.2,0.3,0.3,0.4,0.6s0.2,0.5,0.2,0.9c0,0.4-0.1,0.7-0.2,1s-0.3,0.6-0.5,0.8c-0.3,0.2-0.6,0.4-0.9,0.5
			c-0.4,0.1-0.7,0.2-1.2,0.2c-0.4,0-0.9-0.1-1.3-0.2c-0.4-0.1-0.8-0.2-1-0.3v-1.1h0.1c0.3,0.2,0.7,0.4,1.1,0.5s0.8,0.2,1.2,0.2
			c0.2,0,0.5,0,0.7-0.1s0.5-0.2,0.6-0.3c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.1-0.4,0.1-0.7c0-0.3,0-0.5-0.1-0.7
			c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.7-0.1h-0.5v-0.9h0.4c0.5,0,1-0.1,1.3-0.3
			c0.3-0.2,0.5-0.6,0.5-1c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.6-0.1
			c-0.3,0-0.7,0.1-1.1,0.2c-0.4,0.1-0.7,0.3-1.1,0.5h-0.1v-1.1c0.2-0.1,0.6-0.2,1-0.3c0.4-0.1,0.8-0.2,1.2-0.2c0.4,0,0.7,0,1,0.1
			c0.3,0.1,0.6,0.2,0.8,0.3c0.3,0.2,0.4,0.4,0.6,0.6s0.2,0.5,0.2,0.8c0,0.4-0.2,0.8-0.5,1.1c-0.3,0.3-0.7,0.5-1.1,0.6v0.1
			c0.2,0,0.4,0.1,0.6,0.2C937.8,628.2,937.9,628.3,938.1,628.4z"
              />
            </g>
          </g>
          <g>
            <g
              class={`${this.addClassName(
                "svg_OuterUpperDoorWindowTrim_Crom_BR"
              )}`}
            >
              <polygon
                style={{
                  fill: this.fillColor("svg_OuterUpperDoorWindowTrim_Crom_BR"),
                }}
                onClick={() =>
                  !this.props.isDisableClick && this.userClick("svg_OuterUpperDoorWindowTrim_Crom_BR")
                }
                class="st0"
                points="782.2,624.9 782.2,661.6 763.9,643.3	"
              />
            </g>
            <g>
              <path d="M774.1,640.2l-3.5,6.6h-1.1l3.7-6.8h-4.4V639h5.3V640.2z" />
              <path
                d="M780.8,644.6c0,0.7-0.3,1.2-0.8,1.7c-0.5,0.4-1.2,0.7-2,0.7c-0.8,0-1.5-0.2-2-0.6c-0.5-0.4-0.7-1-0.7-1.7
			c0-0.4,0.1-0.8,0.4-1.2c0.2-0.3,0.6-0.6,1.1-0.8v0c-0.4-0.2-0.7-0.5-0.9-0.7c-0.2-0.3-0.3-0.6-0.3-1c0-0.6,0.2-1.1,0.7-1.4
			c0.5-0.4,1.1-0.6,1.8-0.6c0.8,0,1.4,0.2,1.8,0.6s0.7,0.8,0.7,1.4c0,0.3-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.6-1,0.8v0
			c0.5,0.2,0.9,0.5,1.1,0.8C780.7,643.7,780.8,644.1,780.8,644.6z M779.8,644.7c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.4-0.4-0.8-0.6
			c-0.2-0.1-0.3-0.1-0.5-0.2c-0.2-0.1-0.5-0.2-0.8-0.3c-0.3,0.2-0.6,0.4-0.7,0.7c-0.2,0.3-0.3,0.6-0.3,1c0,0.5,0.2,0.9,0.5,1.2
			c0.3,0.3,0.7,0.5,1.2,0.5c0.5,0,0.9-0.1,1.2-0.4C779.6,645.5,779.8,645.1,779.8,644.7z M779.6,640.8c0-0.4-0.1-0.7-0.4-0.9
			c-0.3-0.2-0.6-0.3-1.1-0.3c-0.4,0-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.8c0,0.2,0.1,0.5,0.2,0.6c0.1,0.2,0.4,0.3,0.6,0.5
			c0.1,0.1,0.3,0.1,0.6,0.2c0.2,0.1,0.5,0.2,0.7,0.2c0.3-0.2,0.6-0.5,0.7-0.7C779.6,641.4,779.6,641.1,779.6,640.8z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_UprightOuterDoorCover_PlateFirstOneBR"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor(
                  "svg_UprightOuterDoorCover_PlateFirstOneBR"
                ),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_UprightOuterDoorCover_PlateFirstOneBR")
              }
              class="st0"
              points="834.3,638.1 797.6,638.1 815.9,619.7"
            />
            <g>
              <path d="M815.5,628.9l-3.5,6.7h-1.1l3.8-6.9h-4.5v-0.9h5.4V628.9z" />
              <path d="M822.4,628.9l-3.5,6.7h-1.1l3.8-6.9H817v-0.9h5.4V628.9z" />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_UprightOuterDoorCover_PlateSecondOneBR"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor(
                  "svg_UprightOuterDoorCover_PlateSecondOneBR"
                ),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_UprightOuterDoorCover_PlateSecondOneBR")
              }
              class="st0"
              points="766.8,745.6 803.4,743.4 786.2,762.8"
            />
            <g>
              <path d="M784.9,748l-3.5,6.5h-1.1l3.7-6.7h-4.3v-0.9h5.2V748z" />
              <path
                d="M791.5,750.2c0,0.7-0.1,1.3-0.2,1.8c-0.2,0.5-0.4,1-0.7,1.4c-0.3,0.4-0.7,0.7-1.2,0.9c-0.5,0.2-1,0.3-1.7,0.3
			c-0.2,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.4-0.1v-1h0.1c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.4,0.1,0.6,0.1c0.8,0,1.3-0.2,1.8-0.7
			c0.4-0.5,0.7-1.1,0.7-1.9c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.8-0.4
			c-0.3-0.2-0.5-0.5-0.7-0.8c-0.2-0.3-0.2-0.7-0.2-1.2c0-0.8,0.3-1.4,0.8-1.9c0.5-0.5,1.1-0.7,1.9-0.7c0.4,0,0.7,0.1,1,0.2
			c0.3,0.1,0.6,0.3,0.8,0.5c0.3,0.3,0.5,0.6,0.7,1.1C791.4,748.9,791.5,749.5,791.5,750.2z M790.5,750c0-0.5-0.1-1-0.2-1.3
			c-0.1-0.3-0.3-0.6-0.5-0.7c-0.2-0.2-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.4,0.7-0.4,1.3
			c0,0.3,0,0.6,0.1,0.8c0.1,0.2,0.2,0.4,0.5,0.5c0.2,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4,0.1,0.6,0.1c0.3,0,0.5,0,0.8-0.1
			s0.5-0.2,0.8-0.3c0-0.1,0-0.1,0-0.2C790.5,750.2,790.5,750.1,790.5,750z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_OuterLowerDoorWindowSlotSeal_Crom_BR"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor(
                  "svg_OuterLowerDoorWindowSlotSeal_Crom_BR"
                ),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_OuterLowerDoorWindowSlotSeal_Crom_BR")
              }
              class="st0"
              points="814.8,757.5 812.7,720.9 832.1,738.1"
            />
            <g>
              <path
                d="M820.6,740c0,0.7-0.3,1.2-0.8,1.6c-0.5,0.4-1.2,0.7-1.9,0.7c-0.8,0-1.5-0.2-2-0.6c-0.5-0.4-0.7-1-0.7-1.6
			c0-0.4,0.1-0.8,0.4-1.2c0.2-0.3,0.6-0.6,1-0.8v0c-0.4-0.2-0.7-0.5-0.9-0.7c-0.2-0.3-0.3-0.6-0.3-1c0-0.6,0.2-1.1,0.7-1.4
			s1.1-0.6,1.8-0.6c0.8,0,1.4,0.2,1.8,0.5c0.5,0.4,0.7,0.8,0.7,1.4c0,0.3-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.6-0.9,0.8v0
			c0.5,0.2,0.8,0.5,1.1,0.8C820.4,739.1,820.6,739.5,820.6,740z M819.5,740.1c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.4-0.4-0.8-0.6
			c-0.2-0.1-0.3-0.1-0.5-0.2c-0.2-0.1-0.4-0.2-0.8-0.3c-0.3,0.2-0.6,0.4-0.7,0.7c-0.2,0.3-0.3,0.6-0.3,1c0,0.5,0.2,0.8,0.5,1.1
			s0.7,0.5,1.2,0.5c0.5,0,0.9-0.1,1.2-0.4C819.4,740.9,819.5,740.5,819.5,740.1z M819.4,736.2c0-0.4-0.1-0.7-0.4-0.9
			c-0.3-0.2-0.6-0.3-1.1-0.3c-0.4,0-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.8c0,0.2,0.1,0.5,0.2,0.6c0.1,0.2,0.3,0.3,0.6,0.5
			c0.1,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.5,0.2,0.7,0.2c0.3-0.2,0.6-0.5,0.7-0.7C819.3,736.8,819.4,736.5,819.4,736.2z"
              />
              <path
                d="M827.2,738.3c0,1.4-0.2,2.4-0.6,3c-0.4,0.6-1.1,1-2,1c-0.9,0-1.6-0.3-2-1c-0.4-0.7-0.6-1.6-0.6-3c0-1.4,0.2-2.4,0.6-3
			c0.4-0.6,1.1-1,2-1c0.9,0,1.6,0.3,2,1C827,735.9,827.2,736.9,827.2,738.3z M825.8,740.6c0.1-0.3,0.2-0.6,0.2-1
			c0-0.4,0.1-0.8,0.1-1.4c0-0.5,0-1-0.1-1.4c0-0.4-0.1-0.7-0.2-1c-0.1-0.3-0.3-0.5-0.5-0.6c-0.2-0.1-0.5-0.2-0.8-0.2
			c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,1c0,0.4-0.1,0.9-0.1,1.3c0,0.5,0,1,0.1,1.3s0.1,0.7,0.2,1
			c0.1,0.3,0.3,0.5,0.5,0.6c0.2,0.1,0.5,0.2,0.8,0.2c0.3,0,0.6-0.1,0.8-0.2C825.6,741.1,825.7,740.9,825.8,740.6z"
              />
            </g>
          </g>
          <g>
            <g class={`${this.addClassName("svg_DoorHandleBR")}`}>
              <polygon
                style={{ fill: this.fillColor("svg_DoorHandleBR") }}
                onClick={() => !this.props.isDisableClick && this.userClick("svg_DoorHandleBR")}
                class="st0"
                points="887.5,744.5 887.5,781.1 869.2,762.8	"
              />
            </g>
            <g>
              <path
                d="M880.4,763.7c0,0.5-0.2,1-0.6,1.3c-0.4,0.4-0.9,0.5-1.6,0.5c-0.7,0-1.2-0.2-1.6-0.5c-0.4-0.3-0.6-0.8-0.6-1.3
			c0-0.3,0.1-0.6,0.3-0.9c0.2-0.3,0.5-0.5,0.8-0.7v0c-0.3-0.2-0.6-0.4-0.7-0.6c-0.2-0.2-0.2-0.5-0.2-0.8c0-0.5,0.2-0.8,0.6-1.2
			c0.4-0.3,0.9-0.5,1.4-0.5c0.6,0,1.1,0.1,1.5,0.4c0.4,0.3,0.5,0.7,0.5,1.1c0,0.3-0.1,0.5-0.3,0.8c-0.2,0.3-0.4,0.5-0.8,0.6v0
			c0.4,0.2,0.7,0.4,0.9,0.6C880.3,763,880.4,763.3,880.4,763.7z M879.5,763.7c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.7-0.5
			c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2,0.1-0.4,0.3-0.6,0.5c-0.1,0.2-0.2,0.5-0.2,0.8c0,0.4,0.1,0.7,0.4,0.9
			s0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.3C879.4,764.4,879.5,764.1,879.5,763.7z M879.4,760.7c0-0.3-0.1-0.5-0.3-0.7
			c-0.2-0.2-0.5-0.3-0.9-0.3c-0.3,0-0.6,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.3,0.5,0.4
			c0.1,0,0.2,0.1,0.4,0.2c0.2,0.1,0.4,0.1,0.6,0.2c0.3-0.2,0.5-0.4,0.6-0.6C879.3,761.1,879.4,760.9,879.4,760.7z"
              />
              <path
                d="M885.7,765.4h-4.2v-0.9c0.3-0.2,0.6-0.5,0.9-0.7c0.3-0.2,0.6-0.5,0.8-0.7c0.5-0.5,0.9-0.9,1.1-1.2c0.2-0.3,0.3-0.6,0.3-1
			c0-0.3-0.1-0.6-0.3-0.7c-0.2-0.2-0.5-0.3-0.9-0.3c-0.2,0-0.5,0-0.8,0.1c-0.3,0.1-0.6,0.2-0.9,0.4h0v-0.9c0.2-0.1,0.5-0.2,0.8-0.3
			c0.3-0.1,0.6-0.1,0.9-0.1c0.6,0,1.1,0.2,1.5,0.5c0.4,0.3,0.5,0.7,0.5,1.2c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.1,0.4-0.3,0.6
			c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.2-0.3,0.3-0.5,0.5c-0.3,0.3-0.6,0.6-0.9,0.8c-0.3,0.3-0.6,0.5-0.9,0.8h3.3V765.4z"
              />
            </g>
          </g>
          <g>
            <g class={`${this.addClassName("svg_QuarterWindowTrim_Crom_BR")}`}>
              <polygon
                style={{
                  fill: this.fillColor("svg_QuarterWindowTrim_Crom_BR"),
                }}
                onClick={() => !this.props.isDisableClick && this.userClick("svg_QuarterWindowTrim_Crom_BR")}
                class="st0"
                points="854.2,800.9 854.2,837.5 835.9,819.2	"
              />
            </g>
            <g>
              <path
                d="M846.7,820.6c0,0.5-0.2,1-0.6,1.3c-0.4,0.4-0.9,0.5-1.6,0.5c-0.7,0-1.2-0.2-1.6-0.5c-0.4-0.3-0.6-0.8-0.6-1.3
			c0-0.3,0.1-0.7,0.3-0.9c0.2-0.3,0.5-0.5,0.8-0.7v0c-0.3-0.2-0.6-0.4-0.7-0.6c-0.2-0.2-0.2-0.5-0.2-0.8c0-0.5,0.2-0.9,0.6-1.2
			c0.4-0.3,0.9-0.5,1.5-0.5c0.6,0,1.1,0.1,1.5,0.4s0.6,0.7,0.6,1.1c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.3-0.4,0.5-0.8,0.6v0
			c0.4,0.2,0.7,0.4,0.9,0.6C846.6,819.9,846.7,820.2,846.7,820.6z M845.8,820.7c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.7-0.5
			c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3,0.1-0.5,0.3-0.6,0.6c-0.2,0.2-0.2,0.5-0.2,0.8c0,0.4,0.1,0.7,0.4,0.9
			c0.3,0.2,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.3C845.7,821.3,845.8,821,845.8,820.7z M845.7,817.6c0-0.3-0.1-0.5-0.3-0.7
			c-0.2-0.2-0.5-0.3-0.9-0.3c-0.4,0-0.6,0.1-0.9,0.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.3,0.5,0.4
			c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0.1,0.4,0.1,0.6,0.2c0.3-0.2,0.5-0.4,0.6-0.6C845.6,818,845.7,817.8,845.7,817.6z"
              />
              <path
                d="M852,820.4c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.3-0.3,0.5-0.4,0.7c-0.2,0.2-0.4,0.3-0.7,0.5c-0.3,0.1-0.6,0.2-1,0.2
			c-0.3,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3v-0.9h0.1c0.2,0.1,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1
			c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4
			c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.5,0-0.7,0.1c-0.2,0-0.4,0.1-0.6,0.1v-3.2h3.8v0.7H849v1.7
			c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.4,0.5,0.6S852,820,852,820.4z"
              />
            </g>
          </g>
          <g>
            <g class={`${this.addClassName("svg_FenderTrimPlateBR")}`}>
              <polygon
                style={{ fill: this.fillColor("svg_FenderTrimPlateBR") }}
                onClick={() => !this.props.isDisableClick && this.userClick("svg_FenderTrimPlateBR")}
                class="st0"
                points="870.7,867.2 870.7,830.5 889.1,848.9	"
              />
            </g>
            <g>
              <path
                d="M877.2,850.1c0,0.6-0.2,1.1-0.7,1.5c-0.5,0.4-1.1,0.6-1.8,0.6c-0.8,0-1.4-0.2-1.9-0.6c-0.5-0.4-0.7-0.9-0.7-1.5
			c0-0.4,0.1-0.8,0.3-1.1c0.2-0.3,0.6-0.6,1-0.8v0c-0.4-0.2-0.7-0.4-0.9-0.7c-0.2-0.2-0.3-0.5-0.3-0.9c0-0.5,0.2-1,0.7-1.3
			s1-0.5,1.7-0.5c0.7,0,1.3,0.2,1.7,0.5c0.4,0.3,0.6,0.8,0.6,1.3c0,0.3-0.1,0.6-0.3,1c-0.2,0.3-0.5,0.6-0.9,0.7v0
			c0.4,0.2,0.8,0.4,1,0.7S877.2,849.6,877.2,850.1z M876.2,850.1c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.4-0.4-0.8-0.5
			c-0.2-0.1-0.3-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.7-0.3c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.4,0.1,0.8,0.4,1.1
			c0.3,0.3,0.7,0.4,1.1,0.4c0.5,0,0.8-0.1,1.1-0.4C876.1,850.9,876.2,850.6,876.2,850.1z M876.1,846.6c0-0.3-0.1-0.6-0.4-0.8
			c-0.3-0.2-0.6-0.3-1-0.3c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.4,0.5-0.4,0.8c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.3,0.3,0.6,0.5
			c0.1,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.4,0.2,0.7,0.2c0.3-0.2,0.5-0.4,0.7-0.7C876,847.1,876.1,846.9,876.1,846.6z"
              />
              <path
                d="M883.5,849.7c0,0.7-0.2,1.3-0.7,1.8c-0.5,0.5-1.1,0.7-1.8,0.7c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.5-0.3-0.8-0.5
			c-0.3-0.3-0.5-0.6-0.6-1.1c-0.1-0.4-0.2-1-0.2-1.6c0-0.6,0.1-1.2,0.2-1.7c0.1-0.5,0.4-0.9,0.7-1.3c0.3-0.4,0.6-0.6,1.1-0.8
			c0.4-0.2,1-0.3,1.6-0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.3,0,0.4,0.1v0.9h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.4-0.1-0.6-0.1
			c-0.7,0-1.2,0.2-1.7,0.6c-0.4,0.4-0.6,1-0.7,1.7c0.3-0.2,0.5-0.3,0.8-0.4c0.3-0.1,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.8,0.1
			c0.2,0.1,0.5,0.2,0.7,0.3c0.3,0.2,0.5,0.4,0.6,0.7C883.4,848.9,883.5,849.3,883.5,849.7z M882.5,849.8c0-0.3,0-0.5-0.1-0.7
			c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5,0-0.8,0.1c-0.2,0.1-0.5,0.2-0.7,0.3
			c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.5,0.1,0.9,0.2,1.2c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.1,0.3,0.2,0.5,0.3
			c0.2,0.1,0.4,0.1,0.6,0.1c0.5,0,0.8-0.1,1.1-0.4C882.4,850.7,882.5,850.3,882.5,849.8z"
              />
            </g>
          </g>
          <g class={`${this.addClassName("svg_RightBackTyre")}`}>
            <path
              style={{ fill: this.fillColor("svg_RightBackTyre") }}
              onClick={() => !this.props.isDisableClick && this.userClick("svg_RightBackTyre")}
              class="st4"
              d="M962.7,836.2L962.7,836.2c-7.1,0-12.8-5.7-12.8-12.8v0c0-7.1,5.7-12.8,12.8-12.8l0,0c7.1,0,12.8,5.7,12.8,12.8
		v0C975.5,830.5,969.8,836.2,962.7,836.2z"
            />
            <g>
              <path
                d="M961.9,822.8c0,0.9-0.1,1.7-0.3,2.4c-0.2,0.7-0.5,1.3-0.9,1.9c-0.4,0.5-0.9,0.9-1.6,1.2s-1.4,0.4-2.2,0.4
			c-0.2,0-0.5,0-0.7,0s-0.4-0.1-0.6-0.1v-1.3h0.1c0.1,0.1,0.3,0.1,0.6,0.2s0.5,0.1,0.8,0.1c1,0,1.8-0.3,2.4-0.9
			c0.6-0.6,0.9-1.4,1-2.5c-0.4,0.3-0.8,0.4-1.2,0.5s-0.8,0.2-1.2,0.2c-0.4,0-0.8,0-1.1-0.1c-0.3-0.1-0.7-0.2-1-0.5
			c-0.4-0.3-0.7-0.6-0.9-1.1c-0.2-0.4-0.3-0.9-0.3-1.5c0-1,0.3-1.9,1-2.5s1.5-1,2.5-1c0.5,0,0.9,0.1,1.4,0.2s0.8,0.4,1.1,0.7
			c0.4,0.4,0.7,0.9,0.9,1.5S961.9,821.8,961.9,822.8z M960.6,822.5c0-0.7-0.1-1.3-0.2-1.7s-0.3-0.8-0.6-1c-0.2-0.2-0.4-0.4-0.7-0.4
			s-0.5-0.1-0.8-0.1c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.7c0,0.4,0.1,0.8,0.2,1.1s0.3,0.5,0.6,0.7c0.2,0.1,0.4,0.2,0.7,0.3
			s0.5,0.1,0.8,0.1c0.4,0,0.7,0,1.1-0.1s0.7-0.2,1-0.4c0-0.1,0-0.2,0-0.3C960.6,822.8,960.6,822.6,960.6,822.5z"
              />
              <path
                d="M970,823.6c0.2,0.2,0.4,0.4,0.5,0.7s0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.3s-0.4,0.7-0.7,1c-0.3,0.3-0.7,0.6-1.2,0.7
			c-0.5,0.2-1,0.2-1.5,0.2c-0.6,0-1.1-0.1-1.7-0.2s-1-0.3-1.3-0.4v-1.4h0.1c0.4,0.3,0.8,0.5,1.4,0.6s1,0.3,1.5,0.3
			c0.3,0,0.6,0,0.9-0.1s0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.5-0.7c0.1-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9
			c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.5-0.2-0.7-0.3s-0.6-0.1-0.9-0.1h-0.6v-1.1h0.5c0.7,0,1.2-0.1,1.7-0.4
			c0.4-0.3,0.6-0.7,0.6-1.3c0-0.2-0.1-0.5-0.2-0.6s-0.3-0.3-0.4-0.5c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5-0.1-0.8-0.1
			c-0.4,0-0.9,0.1-1.4,0.2s-0.9,0.4-1.4,0.7h-0.1v-1.4c0.3-0.2,0.8-0.3,1.3-0.4c0.5-0.1,1.1-0.2,1.6-0.2c0.5,0,0.9,0,1.3,0.1
			s0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.7,0.8s0.3,0.7,0.3,1.1c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.7-1.4,0.8v0.1
			c0.2,0,0.5,0.1,0.8,0.2S969.8,823.4,970,823.6z"
              />
            </g>
          </g>
          <g
            class={`${this.addClassName(
              "svg_SideFenderTurnSignalRepeaterLampR"
            )}`}
          >
            <polygon
              style={{
                fill: this.fillColor("svg_SideFenderTurnSignalRepeaterLampR"),
              }}
              onClick={() =>
                !this.props.isDisableClick && this.userClick("svg_SideFenderTurnSignalRepeaterLampR")
              }
              class="st0"
              points="909.5,338 909.5,374.6 891.2,356.3"
            />
            <g>
              <path
                d="M902.1,357.6c0,0.7-0.2,1.2-0.7,1.6c-0.4,0.4-1,0.6-1.6,0.6c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.4
			c-0.3-0.2-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.6,0.1-1.1,0.2-1.6c0.1-0.5,0.3-0.9,0.6-1.2c0.3-0.3,0.6-0.6,1-0.8
			c0.4-0.2,0.9-0.3,1.4-0.3c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.4,0.1v0.8h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1
			c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.7,1.6c0.2-0.2,0.5-0.3,0.7-0.3c0.2-0.1,0.5-0.1,0.8-0.1c0.3,0,0.5,0,0.7,0.1
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.2,0.5,0.4,0.6,0.7C902,356.9,902.1,357.3,902.1,357.6z M901.2,357.7c0-0.3,0-0.5-0.1-0.7
			c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.2s-0.3,0-0.5,0c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.7,0.3
			c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2c0,0.5,0,0.8,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1
			c0.4,0,0.8-0.1,1-0.4S901.2,358.2,901.2,357.7z"
              />
              <path
                d="M907.9,357.6c0,0.7-0.2,1.2-0.7,1.6c-0.4,0.4-1,0.6-1.6,0.6c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.4
			c-0.3-0.2-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.6,0.1-1.1,0.2-1.6c0.1-0.5,0.3-0.9,0.6-1.2c0.3-0.3,0.6-0.6,1-0.8
			s0.9-0.3,1.4-0.3c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.4,0.1v0.8h0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1
			c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.7,1.6c0.2-0.2,0.5-0.3,0.7-0.3c0.2-0.1,0.5-0.1,0.8-0.1c0.3,0,0.5,0,0.7,0.1
			c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0.2,0.5,0.4,0.6,0.7C907.8,356.9,907.9,357.3,907.9,357.6z M907,357.7c0-0.3,0-0.5-0.1-0.7
			c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.2s-0.3,0-0.5,0c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.7,0.3
			c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2c0,0.5,0,0.8,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1
			c0.4,0,0.8-0.1,1-0.4S907,358.2,907,357.7z"
              />
            </g>
            {/* 94 part */}
            <g class={`${this.addClassName("svg_BackBumper")}`}>
              <path
                style={{ fill: this.fillColor("svg_BackBumper") }}
                onClick={() => !this.props.isDisableClick && this.userClick("svg_BackBumper")}
                class="st4"
                d="M936.7,973.4L936.7,973.4c-7.1,0-12.8-5.7-12.8-12.8l0,0c0-7.1,5.7-12.8,12.8-12.8l0,0
		c7.1,0,12.8,5.7,12.8,12.8l0,0C949.5,967.7,943.8,973.4,936.7,973.4z"
              />
              <g>
                <path
                  d="M935.3,959.9c0,4-1.6,6-4.7,6c-0.5,0-1,0-1.3-0.1v-1c0.4,0.1,0.8,0.2,1.3,0.2c1.1,0,2-0.3,2.6-1c0.6-0.7,0.9-1.8,0.9-3.2
			H934c-0.3,0.4-0.6,0.7-1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3c-0.9,0-1.6-0.3-2.2-0.8s-0.8-1.3-0.8-2.3c0-1.1,0.3-1.9,0.9-2.5
			s1.4-0.9,2.4-0.9c0.7,0,1.3,0.2,1.8,0.5s0.9,0.9,1.2,1.6C935.1,958.1,935.3,959,935.3,959.9z M931.8,956.3c-0.7,0-1.2,0.2-1.6,0.6
			c-0.4,0.4-0.6,1-0.6,1.8c0,0.7,0.2,1.2,0.5,1.6c0.3,0.4,0.9,0.6,1.5,0.6c0.4,0,0.8-0.1,1.2-0.3c0.4-0.2,0.6-0.4,0.9-0.7
			c0.2-0.3,0.3-0.6,0.3-0.9c0-0.5-0.1-0.9-0.3-1.4s-0.5-0.7-0.8-1C932.6,956.5,932.2,956.3,931.8,956.3z"
                />
                <path
                  d="M944.8,963.4h-1.5v2.4h-1.1v-2.4h-5v-1l4.9-7h1.2v6.9h1.5V963.4z M942.2,962.4v-3.4c0-0.7,0-1.4,0.1-2.3h-0.1
			c-0.2,0.5-0.4,0.8-0.6,1.1l-3.2,4.6H942.2z"
                />
              </g>
            </g>
            {/*   end */}
          </g>
        </svg>

        {
          isLightBoxOpen &&
          <>
          <Lightbox
            className="photoapp_lightbox_main"
            reactModalStyle={{
              overlay: { zIndex: 100000000 },
              content: {},
            }}
            toolbarButtons={toolbarButtons}
            mainSrc={
             `${clickedPartName}?${Date.now()}`
            }

            onCloseRequest={() =>
              this.setState({
                isLightBoxOpen: false,
              })
            }

            onImageLoadError={(...events) => { console.log(events) }}

            imageLoadErrorMessage={
              <img
                style={{ height: "100%", width: "100%" }}
                src={dashboardErrorImg}
              />
            }
          />
          </>
        }
      </>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(PreDamage93SVG);
